/* eslint-disable */

export default {
  en: {
    errorText: {
      servlet: {
        locale: {
          missing: function(d) { return "Locale missing"; }
        },
        token: {
          missing: function(d) { return "Token missing"; }
        },
        serializing: {
          error: function(d) { return "Serialization error"; }
        },
        mandatory: {
          info: {
            missing: function(d) { return "Mandatory info missing"; }
          }
        },
        additional: {
          info: {
            too: {
              long: function(d) { return "Additional info too long"; }
            }
          }
        },
        email: {
          sending: {
            failed: function(d) { return "Email sending failed"; }
          }
        }
      },
      checkSsn: function(d) { return "Check the policyholder's personal identity code."; },
      length: function(d) { return "Check value length"; },
      notNumber: function(d) { return "Check filled in number"; },
      invalidDate: function(d) { return "Invalid date"; },
      invalidInput: function(d) { return "Check value of the input"; },
      invalidHomeInput: function(d) { return "Check value of the input"; },
      formContains: function(d) { return "Errors in form:"; },
      forestArea: function(d) { return "Check the forest area."; },
      forestPropertCode: function(d) { return "Check the forest property identifier."; },
      valuableFirstYearOfService: function(d) { return "Check first year of service. "; },
      permittedCharacters: function(d) { return "Check spelling."; },
      animalDateOfBirthDog: function(d) { return "Check date of birth. The insured dog must be under 7 years old and the date of birth may not be later than the current or next year."; },
      animalDateOfBirthCat: function(d) { return "Check date of birth. The insured cat must be under 7 years old and the date of birth may not be later than the current or next year."; },
      animalDateOfBirthHorse: function(d) { return "Check date of birth. The insured horse must be under 22 years old and the date of birth may not be later than the current or next year."; },
      animalValue: function(d) { return "Check the monetary value."; },
      personBirthDate: function(d) { return "Check calculated due date. The calculated due date may not be in the past."; },
      vehicleRegNum: function(d) { return "Check registration number."; },
      muuAjoneuvoVehicleRegNum: function(d) { return "Check vehicle registration or identification number."; },
      vehicleSsn: function(d) { return "Check policyholders personal identity code."; },
      homeFloorArea: function(d) { return "Check floor area of the flat."; },
      homeTotalFloorArea: function(d) { return "Check total floor area."; },
      homeYourOwnTotalFloorArea: function(d) { return "Check total floor area of your home."; },
      homeConstructionYear: function(d) { return "Check year of construction."; },
      boatMake: function(d) { return "Check make."; },
      boatModel: function(d) { return "Check model."; },
      boatManufactureYear: function(d) { return "Check year of manufacture."; },
      boatEnginePower: function(d) { return "Check engine power."; },
      engineProductionNumber: function(d) { return "Check production number."; },
      engineYearOfManufacture: function(d) { return "Check year of manufacture."; },
      checkValue: function(d) { return "Check value"; },
      required: function(d) { return "Required"; },
      initError: function(d) { return "Application initialization failed."; },
      noResponse: function(d) { return "No answer, please try again in a moment."; },
      technicalErrorTitle: function(d) { return "Service disruption, we apologise"; },
      checkPersonalIdentityCode: function(d) { return "Check personal identity code."; },
      atLeastOne: function(d) { return "Please select at least one item"; },
      technicalErrorTextOpfi: function(d) { return "Please try again or contact online buyer support on 010 253 6139 (Mon-Fri 8.00 to 18.00)."; },
      technicalErrorTextOpas: function(d) { return "Please try again in a moment."; },
      technicalErrorSending: function(d) { return "Failed to send request for quotation. Please try again."; },
      sendingProposalFailed: function(d) { return "Failed to send request for proposal. Please try again soon . "; }
    },
    error: {
      fill: {
        "in": {
          missing: {
            information: function(d) { return "Fill in the missing mandatory information."; }
          }
        }
      },
      contact: {
        info: {
          first: {
            name: function(d) { return "Write first name."; }
          },
          last: {
            name: function(d) { return "Write last name."; }
          },
          security: {
            number: function(d) { return "Write personal identity code."; }
          },
          address: function(d) { return "Write address."; },
          postcode: function(d) { return "Write postcode."; },
          postal: {
            district: function(d) { return "Write town/city."; }
          },
          phone: {
            number: function(d) { return "Write phone number."; }
          },
          email: function(d) { return "Write email."; }
        }
      },
      check: {
        first: {
          name: function(d) { return "Check first name."; }
        },
        last: {
          name: function(d) { return "Check last name."; }
        },
        address: function(d) { return "Check address."; },
        email: function(d) { return "Check email."; },
        phone: {
          number: function(d) { return "Check phone number."; }
        },
        postal: {
          district: function(d) { return "Check town/city."; }
        },
        post: {
          code: function(d) { return "Check postcode."; }
        },
        security: {
          number: function(d) { return "Check personal identity code."; }
        }
      },
      invalidCharacters: function(d) { return "Check spelling."; },
      header: {
        text: function(d) { return "The service is currently unavailable"; }
      },
      id: function(d) { return "Error Id"; },
      code: function(d) { return "Error code"; }
    },
    placeHolderText: {
      ppkkvvvv: function(d) { return "dd.mm.yyyy"; }
    },
    uiTitleText: {
      contactBasicDetails: function(d) { return "Basic details"; },
      contactExtraDetails: function(d) { return "Extra details"; },
      insuraceQuestions: function(d) { return "Details of object to be insured"; }
    },
    uiText: {
      keepAliveModalTitle: function(d) { return "Your session was stopped"; },
      keepAliveModalBody: function(d) { return "Technical error occurred in the service."; },
      addInsurance: function(d) { return "Add a new insured item"; },
      all: function(d) { return "All"; },
      almost: {
        ready: function(d) { return "Almost ready! Fill in your information and we will make you a personal offer."; }
      },
      animal: function(d) { return "Animal"; },
      boat: function(d) { return "Boat"; },
      close: function(d) { return "Close"; },
      contactNeedContactInfo: function(d) { return "Fill in your contact information"; },
      contactAdditionalInfo: function(d) { return "Enter additional information if necessary."; },
      additionalInfoMessage: function(d) { return "Do not include personal data such as personal identity codes or health information here."; },
      creditInformation: function(d) { return "To make an offer, we will check your customer details from the Pohjola Insurance customer data file. We may check your credit history from Suomen Asiakastieto Oy and your personal data from the Digital and Population Data Services Agency. You can find more information about personal data processing in the Privacy Notice of Pohjola Insurance Ltd and OP Life Assurance Company Ltd's customer data file."; },
      choose: function(d) { return "- Select -"; },
      deleteInsuranceQuestions: function(d) { return "Delete target"; },
      enlarge: function(d) { return "Enlarge"; },
      filter: function(d) { return "Filter"; },
      forest: function(d) { return "Forest"; },
      home: function(d) { return "Home"; },
      hideAdditionalErrorDetails: function(d) { return "Hide more error information"; },
      infoboxTile: function(d) { return "Do you want to remove this item from the request for quotation? The entered data will also be deleted."; },
      infoboxTileActive: function(d) { return "Do you want to remove these items from the request for quotation? The entered data will also be deleted."; },
      lifeInsuranceIssuanceMsg: function(d) { return "Life insurance is granted by OP Life Assurance Company Ltd, with Pohjola Insurance Ltd acting as the agent. Other vehicle, home, property and health insurance policies are granted by Pohjola Insurance Ltd."; },
      noResults: function(d) { return "No hits"; },
      open: function(d) { return "Open"; },
      responsiveTable: {
        checkDate: function(d) { return "Check date."; }
      },
      toApplicationStartPage: function(d) { return "To the home page of the application"; },
      toInsuranceFrontPage: function(d) { return "To insurance home page"; },
      returnToAuthenticatedFrontPage: function(d) { return "Return to the online service"; },
      linkInterruptionTitle: function(d) { return "Exiting the application"; },
      linkInterruptionBodyText: function(d) { return "You are about to leave the application. Unsaved data will be lost."; },
      insuranceSelectionheader: function(d) { return "Select the insured items"; },
      pieces: function(d) { return "pcs"; },
      startEditing: function(d) { return "Edit"; },
      view: function(d) { return "View"; },
      showAdditionalErrorDetails: function(d) { return "Show more details about the error"; },
      shrink: function(d) { return "Shrink"; },
      one: function(d) { return "1"; },
      two: function(d) { return "2"; },
      three: function(d) { return "3"; },
      returnToReportSearch: function(d) { return "Return to alert search"; },
      person: function(d) { return "Person"; },
      travel: function(d) { return "Travel"; },
      valuable: function(d) { return "Valuable"; },
      vehicle: function(d) { return "Vehicle"; },
      thankYou: function(d) { return "Thank you!"; },
      questionsInfoBox: function(d) { return "Do you want to delete the item and the information entered in it?"; },
      oneTargetSelected: function(d) { return "object selected"; },
      targetsSelected: function(d) { return "objects selected"; },
      engineData: function(d) { return "Engine data"; },
      doesnNotRequireMotorLiabilityInsuranceElectricBike: function(d) { return "Based on the information you entered, your electric bicycle does not require separate motor liability insurance."; },
      doesnNotRequireMotorLiabilityInsuranceElectricVehicle: function(d) { return "Based on the information you entered, your light electric vehicle does not require separate motor liability insurance."; }
    },
    uitext: {
      line: function(d) { return "-"; }
    },
    email: {
      sending: {
        failed: function(d) { return "Fill in missing information"; }
      }
    },
    buttonText: {
      "continue": function(d) { return "Continue"; },
      send: function(d) { return "Send"; },
      yes: function(d) { return "Yes"; },
      no: function(d) { return "No"; },
      previousButton: function(d) { return "Previous"; },
      closeButton: function(d) { return "Close"; },
      okButton: function(d) { return "Ok"; },
      reStart: function(d) { return "Restart"; },
      cancelQuit: function(d) { return "Quit"; },
      cancel: function(d) { return "Cancel"; },
      pdfButton: function(d) { return "Print PDF"; },
      confirm: function(d) { return "Confirm"; },
      ready: function(d) { return "Ready"; },
      closeTab: function(d) { return "Close tab"; },
      save: function(d) { return "Save"; },
      showMore: function(d) { return "Show more"; },
      showLess: function(d) { return "Show less"; },
      acceptButton: function(d) { return "Approve"; },
      declineButton: function(d) { return "Decline"; },
      search: function(d) { return "Search"; },
      replace: function(d) { return "Replace"; },
      back: function(d) { return "Back"; },
      "delete": function(d) { return "Delete"; },
      clear: function(d) { return "Clear"; }
    },
    unitText: {
      kw: function(d) { return "kW"; },
      cm3: function(d) { return "cm³"; },
      kg: function(d) { return "kg"; },
      euro: function(d) { return "€"; },
      horsePower: function(d) { return "hp"; },
      hectare: function(d) { return "ha"; },
      squareMetre: function(d) { return "mÂ²"; },
      euros: function(d) { return "euros"; }
    },
    labelText: {
      bannerTextForFixedTermTravelInsurance: function(d) { return "You can buy fixed-term travel insurance only at op.fi or in OP-mobile."; },
      fixedTermLinkUrl: function(d) { return "/en/private-customers/insurance/personal-insurance/travel-insurance"; },
      fixedTemLinkText: function(d) { return "Buy fixed-term travel insurance"; },
      boatUsedInCompetitionsOrRaces: function(d) { return "Is the boat used in competitions or races?"; },
      boatFinanceCompany: function(d) { return "Finance company?"; },
      ownedByFinanceCompany: function(d) { return "Is the boat owned by a finance company?"; },
      registrationNumber: function(d) { return "Registration number"; },
      manufacturingMethod: function(d) { return "Manufacturing method"; },
      highRiskSports: function(d) { return "Do you practice special sports or high-risk sports?"; },
      highRiskSportsMe: function(d) { return "Do you practice special sports or high-risk sports?"; },
      whichHighRiskSports: function(d) { return "Specify the sport(s)"; },
      forestNameOfTheForestEstateAndLocality: function(d) { return "Name of the forest estate and locality"; },
      animalUELN: function(d) { return "Horse's UELN"; },
      animalPurposeOfHorse: function(d) { return "For what purpose is the horse used?"; },
      AddNewInsurance: function(d) { return "Add new insurance"; },
      bannerTextForTotalOffer: function(d) { return "If you would like to also receive an offer for motor vehicle insurance for your spouse or family member, you can call our Customer Service with that person. We need their consent before we can give our offer."; },
      aspaLinkText: function(d) { return "Contact our customer service"; },
      aspaLinkUrl: function(d) { return "/en/private-customers/customer-service/contact-us/online-buyer-support"; },
      noElectricMotorAssistanceOver25Kph: function(d) { return "Does the bicycle's electric motor assistance turn off when the bicycle reaches 25 kph?"; },
      motorPowerOver250W: function(d) { return "Is the motor power over 250 W?"; },
      weighMoreThan25Kg: function(d) { return "Does the bicycle weigh more than 25 kg?"; },
      scooterWeighMoreThan25Kg: function(d) { return "Does the electric vehicle weigh more than 25 kg?"; },
      topSpeedOver25Kph: function(d) { return "Is the electric vehicle's top speed over 25 kph?"; },
      BasicDetailsAddress: function(d) { return "Address"; },
      BasicDetailsPostCode: function(d) { return "Postcode"; },
      BasicDetailsPost: function(d) { return "Town/city"; },
      BasicDetailsPhoneNumber: function(d) { return "Phone"; },
      BasicDetailsEmail: function(d) { return "Email"; },
      BasicDetailsKela: function(d) { return "Do you have a KELA card?"; },
      BasicDetailsPermanentResidenceInFinland: function(d) { return "Do you have permanent residence in Finland?"; },
      BasicDetailsNationality: function(d) { return "Nationality"; },
      BonusAuthorisedQuestionOtherPerson: function(d) { return "Has the policyholder authorised his/her insurance and claims history to be checked for the purposes of calculating the bonus?"; },
      DamageCoverage: function(d) { return "Do you want the insurance policy to cover damage caused to the vehicle by collisions?"; },
      vvhConsent: function(d) { return "I grant permission for the calculation of no-claims bonus for motor liability insurance on the basis of my insurance and claims history"; },
      ExtraDetailsAdditionalInfo: function(d) { return "Enter additional information as needed (optional)."; },
      FirstYearOfService: function(d) { return "First year of service"; },
      electricPersonalTransportationDeviceFirstYearOfService: function(d) { return "First year of service"; },
      Health: function(d) { return "Health Insurance"; },
      HealthCoverage: function(d) { return "Health Insurance coverage"; },
      Life: function(d) { return "OP Life Insurance"; },
      LifeAria: function(d) { return "More information: OP Life Insurance"; },
      LifeAdditionalInsurances: function(d) { return "Additional insurance policies (optional)"; },
      LifeAdditionalInsurancesAria: function(d) { return "More information: Additional insurance policies"; },
      AdditionalLifeInsurancesSeriousIllness: function(d) { return "Critical Illness Insurance"; },
      AdditionalLifeInsurancesSeriousIllnessAria: function(d) { return "More information: Critical Illness Insurance"; },
      AdditionalLifeInsurancesTemporaryDisability: function(d) { return "Temporary Disability Insurance"; },
      AdditionalLifeInsurancesTemporaryDisabilityAria: function(d) { return "More information: Temporary Disability Insurance"; },
      AdditionalLifeInsurancesPermanentDisability: function(d) { return "Permanent Disability Insurance"; },
      AdditionalLifeInsurancesPermanentDisabilityAria: function(d) { return "More information: Permanent Disability Insurance"; },
      PolicyToOwnName: function(d) { return "Do you want to sign up for the policy in your own name?"; },
      PolicyholderSSN: function(d) { return "Policyholders personal identity code"; },
      PolicyToOwnNameCarText: function(d) { return "We create your personal motor insurance bonus based on your insurance and claims history. We check your history with your personal identity code from the insurance companies joint insurance and claims history information."; },
      RegisteredOtherVehicle: function(d) { return "Is the vehicle registered?"; },
      RegistrationNumber: function(d) { return "Registration number"; },
      MuuAjoneuvoRegistrationNumber: function(d) { return "Vehicle registration or identification number"; },
      boatType: function(d) { return "Insured boat"; },
      motorBoatType: function(d) { return "Boat type"; },
      engineBrand: function(d) { return "Engine brand"; },
      engineProductionNumber: function(d) { return "Production Number"; },
      engineYearOfManufacture: function(d) { return "Year of Manufacture"; },
      enginePower: function(d) { return "Engine power"; },
      electricPersonalTransportationDevicEnginePower: function(d) { return "Engine power (W)"; },
      boatValue: function(d) { return "Value of boat and accessories"; },
      boatMunicipality: function(d) { return "Boat’s municipality of use"; },
      boatEngine: function(d) { return "Does the sailing boat have an engine?"; },
      bonuses: function(d) { return "Do you want to consider bonuses from another insurance company in the price of your insurance?"; },
      "breed-horse": function(d) { return "Breed group"; },
      breed: function(d) { return "Breed"; },
      calculatedDueDate: function(d) { return "Calculated due date"; },
      competitiveSports: function(d) { return "Does the person engage in competitive sports?"; },
      competitiveSportsMe: function(d) { return "Do you compete in sports?"; },
      highRiskSportsMeSecond: function(d) { return "Special and high-risk sports"; },
      competitiveSportsModalHeader: function(d) { return "Special and high-risk sports?"; },
      competitiveSportsModalItemAdditionalCover: function(d) { return "Sports that require additional cover"; },
      competitiveSportsModalTitleAviationSports: function(d) { return "Aviation sports, including"; },
      competitiveSportsModalItemHotAirBalloonAndGasbagFlight: function(d) { return "hot air balloon and gasbag flight"; },
      competitiveSportsModalItemMotorisedFlying: function(d) { return "motorised flying"; },
      competitiveSportsModalItemHangGlidingAndParagliding: function(d) { return "hang-gliding and paragliding"; },
      competitiveSportsModalItemMicroLightFlying: function(d) { return "microlight flying"; },
      competitiveSportsModalItemSkydiving: function(d) { return "skydiving"; },
      competitiveSportsModalItemIndoorSkydiving: function(d) { return "indoor skydiving"; },
      competitiveSportsModalItemFlyingWithAmateurBuiltAircraft: function(d) { return "flying with amateur-built aircraft"; },
      competitiveSportsModalItemGlidingAndMotorsailing: function(d) { return "gliding and motorsailing"; },
      competitiveSportsModalItemParasailing: function(d) { return "parasailing"; },
      competitiveSportsModalTitleTeamSports: function(d) { return "Team sports, including"; },
      competitiveSportsModalItemAmericanFootball: function(d) { return "American football"; },
      competitiveSportsModalItemAustralianFootball: function(d) { return "Australian football"; },
      competitiveSportsModalItemRugby: function(d) { return "rugby"; },
      competitiveSportsModalItemlLacrosse: function(d) { return "lacrosse"; },
      competitiveSportsModalItemRollerDerby: function(d) { return "roller derby"; },
      competitiveSportsModalTitleCombatSports: function(d) { return "Combat sports, self-defence sports or martial arts, including"; },
      competitiveSportsModalItemMixedMartialArts: function(d) { return "Mixed Martial Arts"; },
      competitiveSportsModalItemWrestling: function(d) { return "wrestling"; },
      competitiveSportsModalTitleClimbingSports: function(d) { return "Climbing sports, including"; },
      competitiveSportsModalItemIceAndRockClimbing: function(d) { return "ice and rock climbing"; },
      competitiveSportsModalItemGlacierAndMountainClimbing: function(d) { return "glacier and mountain climbing"; },
      competitiveSportsModalTitleDivingSports: function(d) { return "Diving sports, including"; },
      competitiveSportsModalItemScubaDiving: function(d) { return "scuba diving"; },
      competitiveSportsModalItemFreediving: function(d) { return "freediving"; },
      competitiveSportsModalTitleWinterSports: function(d) { return "Winter sports, including"; },
      competitiveSportsModalItemSledding: function(d) { return "sledding"; },
      competitiveSportsModalItemFreestyleSkiing: function(d) { return "freestyle skiing"; },
      competitiveSportsModalItemSpeedAndDownhillSkiing: function(d) { return "speed and downhill skiing"; },
      competitiveSportsModalItemOffPisteSkiing: function(d) { return "off-piste skiing"; },
      competitiveSportsModalItemDownhillSkating: function(d) { return "downhill skating"; },
      competitiveSportsModalTitleStrengthSports: function(d) { return "Strength sports, including"; },
      competitiveSportsModalItemStrengthAthletics: function(d) { return "strength athletics"; },
      competitiveSportsModalItemPowerlifting: function(d) { return "powerlifting"; },
      competitiveSportsModalItemWeightlifting: function(d) { return "weightlifting"; },
      competitiveSportsModalItemBodybuilding: function(d) { return "bodybuilding"; },
      competitiveSportsModalTitleOtherSeparatelyInsuredSports: function(d) { return "Other separately insured sports"; },
      competitiveSportsModalItemBmxCycling: function(d) { return "BMX cycling"; },
      competitiveSportsModalItemBungeeJumping: function(d) { return "bungee jumping"; },
      competitiveSportsModalItemSkimbatOrKiteSurfing: function(d) { return "skimbat or kite surfing"; },
      competitiveSportsModalItemSailboardingAndFlyboarding: function(d) { return "sailboarding and flyboarding"; },
      competitiveSportsModalItemParkour: function(d) { return "parkour"; },
      competitiveSportsModalItemAbseiling: function(d) { return "abseiling"; },
      competitiveSportsModalItemAcrobatics: function(d) { return "acrobatics"; },
      competitiveSportsModalItemFreeRunning: function(d) { return "free running"; },
      competitiveSportsModalItemDownhillBiking: function(d) { return "downhill biking"; },
      competitiveSportsModalItemOceanSailing: function(d) { return "ocean sailing"; },
      competitiveSportsModalItemBaseJumping: function(d) { return "BASE jumping"; },
      competitiveSportsModalItemTrekking: function(d) { return "trekking into uninhabited areas, such as research expeditions or treks to mountains, jungles, deserts or wilds or other similar areas abroad"; },
      competitiveSportsModalItemWildwaterCanoeing: function(d) { return "wildwater canoeing"; },
      competitiveSportsModalTitleOtherSportsOfComparableLevelOfRisk: function(d) { return "Other sports of a comparable level of risk"; },
      constructionYear: function(d) { return "Year of construction"; },
      damageCover: function(d) { return "Do you want the insurance policy to cover damage caused by, for instance, a collision or running aground?"; },
      FullName: function(d) { return "Name"; },
      FirstName: function(d) { return "First name"; },
      floorArea: function(d) { return "Floor area of the flat"; },
      forestArea: function(d) { return "Forest area (ha)"; },
      forestPropertCode: function(d) { return "Forest property identifier"; },
      forestGrowthStage: function(d) { return "Forest growth stage"; },
      forestIndemnity: function(d) { return "Scope of indemnity"; },
      forestMunicipality: function(d) { return "Forest municipality"; },
      frameMaterial: function(d) { return "Frame material"; },
      AnimalGender: function(d) { return "Gender"; },
      homeType: function(d) { return "Insured home or building"; },
      housingCompany: function(d) { return "Is this a housing company?"; },
      inspectionClass: function(d) { return "Inspection class or condition survey"; },
      insuranceCompany: function(d) { return "From which insurance company do you want to transfer the bonus?"; },
      insuranceIncludesMe: function(d) { return "Insured luggage"; },
      insuranceScope: function(d) { return "Scope of insurance"; },
      "insured-animal": function(d) { return "Insured animal"; },
      insuredItem: function(d) { return "Insured item"; },
      LastName: function(d) { return "Last name"; },
      longTrip: function(d) { return "Longest trip"; },
      luggageInsuranceFamily: function(d) { return "Do you want to insure your family’s luggage?"; },
      luggageInsuranceMe: function(d) { return "Do you want to insure the luggage?"; },
      make: function(d) { return "Make"; },
      electricPersonalTransportationDeviceMake: function(d) { return "Make"; },
      manufactureYear: function(d) { return "Year of manufacture"; },
      "monetary-value-horse": function(d) { return "Monetary value of horse"; },
      "monetary-value-dog": function(d) { return "Monetary value of dog"; },
      "monetary-value-pedigree-cat": function(d) { return "Monetary value of cat"; },
      AnimalName: function(d) { return "Name"; },
      person: function(d) { return "Insured person"; },
      pipeRenewalYear: function(d) { return "Installation or renewal year of the service water pipes"; },
      pipeSystem: function(d) { return "Does the building have a service water pipe system?"; },
      postcode: function(d) { return "Postcode of insured item"; },
      primaryEngines: function(d) { return "Number of primary engines"; },
      purposeOfUse: function(d) { return "Purpose of use"; },
      SecurityId: function(d) { return "Personal identity code"; },
      "time-of-birth": function(d) { return "Date of birth"; },
      totalFloorArea: function(d) { return "Total floor area"; },
      "totalFloorAreaOwnHomeSemi-detached": function(d) { return "The total floor area of your own home"; },
      transferrableBonus: function(d) { return "Transferrable bonus"; },
      valuableType: function(d) { return "Insured valuable"; },
      valueCamera: function(d) { return "Value of camera and accessories"; },
      valueInstrument: function(d) { return "Value of musical instrument"; },
      valueJewellery: function(d) { return "Value of jewellery"; },
      valueLens: function(d) { return "Value of lens"; },
      valueWatch: function(d) { return "Value of watch"; },
      valueWeapon: function(d) { return "Value of weapon"; },
      vehicleType: function(d) { return "Insured vehicle"; },
      vehicleValue: function(d) { return "Vehicle value"; },
      vehicleMileage: function(d) { return "Estimate how many kilometres are driven with the car in a year"; },
      whichSports: function(d) { return "Specify the sport(s)"; },
      museumVehicleType: function(d) { return "What type of vehicle is it?"; },
      electricPersonalTransportationDeviceVehicleType: function(d) { return "Type of vehicle"; },
      HomeAddress: function(d) { return "Address of the insured object"; },
      insuranceIncludesPackages: function(d) { return "Insured luggage"; },
      model: function(d) { return "Model"; },
      electricPersonalTransportationDeviceModel: function(d) { return "Model"; },
      personUnbornMotherChild: function(d) { return "Are you the child’s mother?"; },
      mothersIdentificationNumber: function(d) { return "Mother’s personal identity code"; },
      waterPipeSystem: function(d) { return "Does the building have a service water pipe system?"; },
      heatingSystem: function(d) { return "Does the building have heating?"; },
      electricityType: function(d) { return "Does the building have electricity?"; },
      YearOfWaterPipeSystem: function(d) { return "Installation or renewal year of service water pipes"; },
      YearOfHeatingSystem: function(d) { return "Installation or renewal year of heating pipes"; },
      ContactInfo: function(d) { return "Contact Information"; },
      electricPersonalTransportationDeviceSerialNumber: function(d) { return "Identification number or serial number"; },
      electricPersonalTransportationDeviceMaximumDesignSpeed: function(d) { return "Maximum design speed (kph)"; },
      electricPersonalTransportationDeviceTotalWeight: function(d) { return "Total weight (kg)"; },
      electricPersonalTransportationDeviceValue: function(d) { return "Vehicle value"; },
      electricPersonalTransportationDeviceAgeUnder24: function(d) { return "Is the person using the vehicle under 24 years of age?"; },
      electricPersonalTransportationDeviceCollisionCrashCoverage: function(d) { return "Do you want the insurance to cover damage to the vehicle caused by a collision or crash?"; },
      tractorInPrivateUse: function(d) { return "Is the tractor in private use?"; },
      monthlyRent: function(d) { return "Monthly rent"; },
      deviceNumber: function(d) { return "Device number"; },
      serialNumber: function(d) { return "Serial number"; },
      whichJewellery: function(d) { return "Which piece of jewellery?"; }
    },
    hintText: {
      boatUsedInCompetitionsOrRaces: function(d) { return "Please note that the insurance is not valid during competitions or races."; },
      registrationNumber: function(d) { return "The registration number is listed on the registration certificate."; },
      animalUELN: function(d) { return "The horse's UELN (Universal Equine Life Number) is a unique identifier that may contain letters and numbers."; },
      tractorInPrivateUse: function(d) { return "A tractor in private use means a tractor that is not used by a business for agriculture or production. A private tractor is used for ploughing snow in your own property, transporting your own firewood and other private uses."; },
      electricPersonalTransportationDeviceValue: function(d) { return "Give an estimate of the vehicle's value in euros."; },
      electricPersonalTransportationDeviceTotalWeight: function(d) { return "For example: enter the bicycle's total weight, including the battery."; },
      bannerTextForTotalOffer: function(d) { return "The total area is the sum of the areas calculated according to the external dimensions of all the floors of the dwelling, taking into account spaces at least 160 cm high. You can choose the total area from the building drawings."; },
      BonusAuthorisedQuestionOtherPerson: function(d) { return "If you answer ‘Yes’, you assure that you have received the policyholder’s permission to check his/her insurance and claims history. We will check the history, using the personal identity code, from insurance companies’ joint insurance and claims records, and use the information to calculate the personal motor liability insurance bonus."; },
      DamageCoverage: function(d) { return "The amount of compensation depends on the policy, so depending on your selection, we can offer a suitable motor vehicle insurance. A motor liability insurance will only cover the damage caused by collision to the adverse party, whereas a comprehensive motor vehicle insurance also covers the damage caused to your vehicle."; },
      vvhConsent: function(d) { return "Your personal motor liability insurance bonus will be determined on the basis of your insurance and claims history. We will check your history using your personal identity code from insurance companies’ joint insurance and claims history records."; },
      vehicleValue: function(d) { return "Report an estimate of your vehicle’s value in euros. We will recommend a suitable comprehensive motor vehicle insurance based on your vehicle’s value. For example, Standard Motor Insurance covers loss and damage of up to 15,000 euros."; },
      vehicleMileage: function(d) { return "Estimate the maximum number of kilometres driven with the car in a year. If there are changes to the number of kilometres driven, you can report the change in the online service. You can always drive without worry, as the number of kilometres driven affects the insurance price, not its content."; },
      FirstYearOfService: function(d) { return "The first year of service refers to the time when the valuable was manufactured or used for the first time."; },
      Health: function(d) { return "Health Insurance is a personal insurance that covers medical treatment expenses for injuries or both injuries and illnesses, depending on the level of cover you select."; },
      HealthCoverageTitle: function(d) { return "Select what you want in your insurance cover:"; },
      HealthCoverageFirst: function(d) { return "Illness and injury: The most comprehensive option gives the best cover against illnesses and accidents. It covers everything from the common cold to cancer treatment, physical examinations and medication."; },
      HealthCoverageSecond: function(d) { return "Comprehensive accident: Gives comprehensive cover against accidents and those illnesses specified in the terms and conditions whose symptoms often appear in connection with an accident."; },
      HealthCoverageThird: function(d) { return "Accident: Covers treatment and medication for injuries caused by an accident. Does not cover illnesses covered by a more comprehensive insurance policy."; },
      Life: function(d) { return "Compensation from the life insurance policy will be paid to the beneficiary. You can name the beneficiary."; },
      LifeSecond: function(d) { return "Compensation paid from OP Life Insurance helps your loved ones if you die during the validity of the insurance. You can supplement your OP Life Insurance with Critical Illness Insurance and Disability Insurance. You can request quotes for all insurance policies at the same time."; },
      LifeAdditionalInsurances: function(d) { return "Compensation from additional insurance policies will be paid to you as a lump sum or as monthly payments."; },
      AdditionalLifeInsurancesSeriousIllness: function(d) { return "We will pay the agreed lump sum if you are diagnosed with a critical illness specified in the insurance terms and conditions or if you undergo a procedure specified in the terms and conditions."; },
      AdditionalLifeInsurancesTemporaryDisability: function(d) { return "You will receive daily compensation from Temporary Disability Insurance if you are unable to work due to illness or injury and have to take sick leave."; },
      AdditionalLifeInsurancesPermanentDisability: function(d) { return "You will receive a lump-sum compensation from Permanent Disability Insurance if, during the validity of the insurance policy, you permanently lose your ability to work due to injury or illness."; },
      PolicyToOwnName: function(d) { return "In addition to you, the policyholder may be other owner or holder of the vehicle. If the insurance will be, or the current insurance already is, in the other owners or holders name, add them as the policyholder."; },
      boatValue: function(d) { return "Enter the monetary value for which your boat plus its engines and accessories are insured.  The value corresponds to the maximum compensation for the equipment, so you should set the value of a relatively new boat at the purchase price of new equipment. If the boat is older, set the value at the equipments current resale value."; },
      boatMunicipality: function(d) { return "Report the municipality where your boat is used mainly as its municipality of use."; },
      bonuses: function(d) { return "You can transfer bonuses in your name to a new policy from another insurance company. Select the bonus to be transferred between 0 % and 70 %."; },
      competitiveSports: function(d) { return "Competitive sports means sports games or matches arranged by a sports association or sports club, training arranged according to a training programme and travel directly related to these, regardless of the level of competitiveness or the age of the insured person."; },
      damageCover: function(d) { return "The amount of compensation depends on the policy, so depending on your selection, we can offer a suitable insurance for the boat. The boat damage cover covers boating damage and additionally storm damage or damage caused to a boat/yacht kept on dry land, etc."; },
      forestPropertCode: function(d) { return "If you own several forest estates, please insure the forests using separate estate unit identifiers."; },
      forestArea: function(d) { return "Please note that scrub and waste lands are not included in the area of the forest."; },
      forestGrowthStage: function(d) { return "The maximum compensation for storm damage is based on the growth stage of the forest."; },
      forestIndemnity: function(d) { return "The scope of indemnity depends on the covers included in your policy. The covers included in the policy cover damages to standing crop, seedling stand, timber, planting stock and timber offcuts."; },
      inspectionClass: function(d) { return "You will receive a policy discount by having your boat/yacht inspected or condition surveyed (Finnboat) once a year."; },
      insuranceIncludes: function(d) { return "Your personal luggage insurance covers the luggage of any family member living in the same household, when you travel together. Luggage of the whole family insurance covers the luggage of everyone living in your household even if you do not travel together."; },
      insuranceScope: function(d) { return "Select what you want the insurance to cover so that we can offer you a suitable personal insurance. A personal insurance can compensate the medical treatment expenses of both illnesses and accidents, or only accidents."; },
      longTrip: function(d) { return "If an individual trip lasts longer than 45 days, this should be taken into account when taking out travel insurance."; },
      luggageInsuranceFamily: function(d) { return "You can insure the luggage of everyone living in your household even if you did not travel together or travelled to different destinations."; },
      model: function(d) { return "Give the model of your boat as accurately as possible; for example 520 DC."; },
      "monetary-value": function(d) { return "The monetary value of the animal reflects the compensation paid for the loss of the animal.  The monetary value comprises the purchase price of the animal or, for instance, the value added through a competition, show or breeding background."; },
      pipeSystem: function(d) { return "If the building has a service water pipe system, the water is delivered to tapping points. The age of the pipes affects the compensation paid in case of a leak damage."; },
      totalFloorArea: function(d) { return "The total floor area is the combined floor area of each floor of the building, calculated on the basis of the external dimensions and taking into consideration areas of 160 cm or higher.  You can check the total floor area from, for example, the construction drawing."; },
      value: function(d) { return "Enter the monetary value for which your valuable is insured.  The value equals the maximum compensation paid for the valuable, so the value should be set at the purchase price of a new similar valuable."; },
      BonusAuthorisedQuestionOtherPersonCarExtraText: function(d) { return "We will call you as we need the policyholder's permission to review their insurance and claims history. This way, we can calculate a personal bonus as well as the best possible price."; },
      electricPersonalTransportationDeviceSerialNumber: function(d) { return "To insure the vehicle, we require the vehicle identification number or serial number."; },
      extra: {
        information: function(d) { return "You can add additional information to your request for proposal if you want."; }
      },
      PolicyToOwnNameCarHint: function(d) { return "We create your personal motor insurance bonus based on your insurance and claims history. We check your history with your personal identity number from the insurance companies joint insurance and claims history information."; },
      phoneNumberContactInfo: function(d) { return "Type your phone number without space characters. If you have a foreign subscription, please remember your country code."; },
      mothersIdentificationNumber: function(d) { return "We need the mother’s personal identity code to calculate the insurance rate including discounts and to retrieve her address from the customer data file of Pohjola Insurance or other OP Financial Group companies, or from the Population Information System. We will also send the mother a health declaration form."; },
      heatingSystem: function(d) { return "Hydronic heating means that the building is heated by water circulating in radiators or floor pipes. Please note! If any of the rooms in the house (such as bathroom) have a hydronic heating system, select hydronic heating."; },
      waterPipeSystem: function(d) { return "Service water pipes refers to water pipes leading to water points such as taps. Please note that the age of the pipes affects the amount of compensation for leakage damage."; },
      electricityType: function(d) { return "Grid connection means that the building receives electricity from the national grid. Own power generation means that the building does not receive electricity from the national grid but instead from solar panels or a generator. No electrification means that the building does not get electricity at all."; },
      YearOfWaterPipeSystem: function(d) { return "If the service water pipes have only been partially renewed, enter the original year of installation of the pipes"; },
      YearOfHeatingSystem: function(d) { return "If the heating pipes have only been partially renewed, enter the original year of installation of the pipes"; }
    },
    option: {
      true: function(d) { return "Yes"; },
      false: function(d) { return "No"; },
      yes: function(d) { return "Yes"; },
      no: function(d) { return "No"; },
      manufacturingMethod: {
        "001": function(d) { return "Factory-made"; },
        "002": function(d) { return "Self-made"; }
      },
      animalPurposeOfHorse: {
        "001": function(d) { return "Showjumping or eventing"; },
        "002": function(d) { return "Recreational use"; },
        "003": function(d) { return "Dressage"; },
        "004": function(d) { return "Harness racing"; },
        "005": function(d) { return "Breeding use"; },
        "006": function(d) { return "Other"; }
      },
      HealthCoverage: {
        "001": function(d) { return "Illness and injury"; },
        "002": function(d) { return "Comprehensive accident"; },
        "003": function(d) { return "Accident"; }
      },
      museumVehicleType: {
        "001": function(d) { return "Car"; },
        "002": function(d) { return "Van"; },
        "003": function(d) { return "Motorcycle"; },
        "004": function(d) { return "Moped or light quadricycle"; },
        "005": function(d) { return "Snowmobile"; },
        "006": function(d) { return "Trailer"; },
        "007": function(d) { return "Caravan"; },
        "008": function(d) { return "Campervan"; },
        "009": function(d) { return "Lorry"; },
        "010": function(d) { return "Tractor"; },
        "011": function(d) { return "All-terrain vehicle"; }
      },
      electricPersonalTransportationDeviceVehicleType: {
        "001": function(d) { return "Electric bicycle"; },
        "002": function(d) { return "Light electric vehicle"; }
      },
      boatType: {
        "001": function(d) { return "Motor boat"; },
        "002": function(d) { return "Sailing boat with engine"; },
        "003": function(d) { return "Sailing boat"; }
      },
      motorBoatType: {
        "001": function(d) { return "Outboard motor boat"; },
        "002": function(d) { return "Inboard engine boat"; },
        "003": function(d) { return "Inboard engine boat"; }
      },
      "breed-horse": {
        "001": function(d) { return "Thoroughbred or halfbred"; },
        "002": function(d) { return "Coldblood"; },
        "003": function(d) { return "Pony"; }
      },
      "breed-pedigree-cat": {
        "001": function(d) { return "Abyssinian"; },
        "002": function(d) { return "American Curl"; },
        "003": function(d) { return "Asian"; },
        "004": function(d) { return "Asian Longhair"; },
        "005": function(d) { return "Asian Shorthair"; },
        "006": function(d) { return "Balinese"; },
        "007": function(d) { return "Bengal"; },
        "008": function(d) { return "Birman"; },
        "009": function(d) { return "British"; },
        "010": function(d) { return "Burmese"; },
        "011": function(d) { return "Burmilla"; },
        "012": function(d) { return "Chartreux"; },
        "013": function(d) { return "Colourpoint hybrid"; },
        "014": function(d) { return "Cornish rex"; },
        "015": function(d) { return "Cymrix"; },
        "016": function(d) { return "Devon rex"; },
        "017": function(d) { return "Don Sfinx"; },
        "018": function(d) { return "Egyptian Mau"; },
        "019": function(d) { return "European"; },
        "020": function(d) { return "Exotic"; },
        "021": function(d) { return "German rex"; },
        "022": function(d) { return "Japanese Bobtail"; },
        "023": function(d) { return "Javanese"; },
        "024": function(d) { return "Korat"; },
        "025": function(d) { return "Kurilian bobtail"; },
        "026": function(d) { return "Maine Coon"; },
        "027": function(d) { return "Manx"; },
        "028": function(d) { return "Neva Masquarade"; },
        "029": function(d) { return "Norwegian Forest"; },
        "030": function(d) { return "Ocicat"; },
        "031": function(d) { return "Persian"; },
        "032": function(d) { return "Peterblad"; },
        "033": function(d) { return "Ragdoll"; },
        "034": function(d) { return "Russian Blue"; },
        "035": function(d) { return "Scottish fold"; },
        "036": function(d) { return "Selkirk Rex"; },
        "037": function(d) { return "Seychellois longhair"; },
        "038": function(d) { return "Seychellois shorthair"; },
        "039": function(d) { return "Siamese"; },
        "040": function(d) { return "Siberian"; },
        "041": function(d) { return "Singapura"; },
        "042": function(d) { return "Snowshoe"; },
        "043": function(d) { return "Sokoke"; },
        "044": function(d) { return "Somali"; },
        "045": function(d) { return "Sphynx"; },
        "046": function(d) { return "Thai"; },
        "047": function(d) { return "Turkish"; },
        "048": function(d) { return "Turkish Angora"; },
        "049": function(d) { return "Turkish Van"; },
        "050": function(d) { return "Breed unknown"; }
      },
      "breed-pedigree-dog": {
        "100": function(d) { return "Dachshund"; },
        "101": function(d) { return "Dachshund, Miniature Long-haired"; },
        "102": function(d) { return "Dachshund, Miniature Smooth-haired"; },
        "103": function(d) { return "Dachshund, Miniature Wire-haired"; },
        "104": function(d) { return "Dachshund, Standard Long-haired"; },
        "105": function(d) { return "Dachshund, Standard Smooth-haired"; },
        "106": function(d) { return "Dachshund, Standard Wire-haired"; },
        "107": function(d) { return "Dalmatian"; },
        "108": function(d) { return "Dandie Dinmont Terrier"; },
        "109": function(d) { return "Danish-Swedish Farmdog"; },
        "110": function(d) { return "Deerhound"; },
        "111": function(d) { return "Dobermann"; },
        "112": function(d) { return "Dogo Argentino"; },
        "113": function(d) { return "Dogo Canario"; },
        "114": function(d) { return "Dogo Mallorquin"; },
        "115": function(d) { return "Dogue de Bordeaux"; },
        "116": function(d) { return "Drever"; },
        "117": function(d) { return "Dunker Hound"; },
        "118": function(d) { return "Dutch Shepherd Dog, Long-haired"; },
        "119": function(d) { return "Dutch Shepherd Dog, Rough-Haired"; },
        "120": function(d) { return "Dutch Shepherd Dog, Short-haired"; },
        "121": function(d) { return "Dutch Shepherd Dogs"; },
        "122": function(d) { return "East-Siberian Laika"; },
        "123": function(d) { return "English Foxhound"; },
        "124": function(d) { return "English Pointer"; },
        "125": function(d) { return "English Setter"; },
        "126": function(d) { return "English Springer Spaniel"; },
        "127": function(d) { return "English Toy Terrier"; },
        "128": function(d) { return "Entlebuch Cattle Dog"; },
        "129": function(d) { return "Estonian Hound"; },
        "130": function(d) { return "Estrela Mountain Dogs"; },
        "131": function(d) { return "Eurasier"; },
        "132": function(d) { return "Field Spaniel"; },
        "133": function(d) { return "Fila Brasileiro"; },
        "134": function(d) { return "Finnish Hound"; },
        "135": function(d) { return "Finnish Lapphund"; },
        "136": function(d) { return "Finnish Spitz"; },
        "137": function(d) { return "Flat Coated Retriever"; },
        "138": function(d) { return "Fox Terrier, Smooth-haired"; },
        "139": function(d) { return "Fox Terrier, Wire-haired"; },
        "140": function(d) { return "French Bulldog"; },
        "141": function(d) { return "French Spaniel"; },
        "142": function(d) { return "French Spaniel"; },
        "143": function(d) { return "French Wire-haired Korthals Pointing Dog"; },
        "144": function(d) { return "German Hound"; },
        "145": function(d) { return "German Hunting Terrier"; },
        "146": function(d) { return "German Pinscher"; },
        "147": function(d) { return "German Shepherd Dog"; },
        "148": function(d) { return "German Shepherd Dog, long and harsh outer coat"; },
        "149": function(d) { return "German Spaniel"; },
        "150": function(d) { return "Giant Schnauzers"; },
        "151": function(d) { return "Golden Retriever"; },
        "152": function(d) { return "Gordon Setter"; },
        "153": function(d) { return "Grand Basset Griffon Vend?en"; },
        "154": function(d) { return "Grand Bleu de Gascogne"; },
        "155": function(d) { return "Great Dane"; },
        "156": function(d) { return "Great Swiss Cattle Dog"; },
        "157": function(d) { return "Greenland Dog"; },
        "158": function(d) { return "Greyhound"; },
        "159": function(d) { return "Griffon Belge"; },
        "160": function(d) { return "Griffon Bruxellois"; },
        "161": function(d) { return "Griffon Fauve de Bretagne"; },
        "162": function(d) { return "Grosspitz"; },
        "163": function(d) { return "Halden Hound"; },
        "164": function(d) { return "Hälleforshund"; },
        "165": function(d) { return "Hamilton Hound"; },
        "166": function(d) { return "Hanoverian Scenthound"; },
        "167": function(d) { return "Harrier"; },
        "168": function(d) { return "Hellenic Hound"; },
        "169": function(d) { return "Hokkaido"; },
        "170": function(d) { return "Hollandse Smoushond"; },
        "171": function(d) { return "Hovawart"; },
        "172": function(d) { return "Hungarian Greyhound"; },
        "173": function(d) { return "Hungarian Vizsla"; },
        "174": function(d) { return "Hygen Hound"; },
        "175": function(d) { return "Ibizan Hounds"; },
        "176": function(d) { return "Iceland Sheepdog"; },
        "177": function(d) { return "Irish Glen Of Imaal Terrier"; },
        "178": function(d) { return "Irish Red and White Setter"; },
        "179": function(d) { return "Irish Red Setter"; },
        "180": function(d) { return "Irish Soft Coated Wheaten Terrier"; },
        "181": function(d) { return "Irish Terrier"; },
        "182": function(d) { return "Irish Water Spaniel"; },
        "183": function(d) { return "Irish Wolfhound"; },
        "184": function(d) { return "Italian Cane Corso"; },
        "185": function(d) { return "Italian Greyhound"; },
        "186": function(d) { return "Jack Russell Terrier"; },
        "187": function(d) { return "Japanese Chin"; },
        "188": function(d) { return "Japanese Spitz"; },
        "189": function(d) { return "Kai"; },
        "190": function(d) { return "Karelian Bear Dog"; },
        "191": function(d) { return "Keeshond"; },
        "192": function(d) { return "Kerry Blue Terrier"; },
        "193": function(d) { return "King Charles Spaniel"; },
        "194": function(d) { return "Kishu"; },
        "195": function(d) { return "Kleinspitz"; },
        "196": function(d) { return "Komondor"; },
        "197": function(d) { return "Kopo"; },
        "198": function(d) { return "Kromfohrländer"; },
        "199": function(d) { return "Kuvasz"; },
        "200": function(d) { return "Labrador Retriever"; },
        "201": function(d) { return "Lagotto Romagnolo"; },
        "202": function(d) { return "Lakeland Terrier"; },
        "203": function(d) { return "Lancashire Heeler"; },
        "204": function(d) { return "Landseer"; },
        "205": function(d) { return "Lapponian Herder"; },
        "206": function(d) { return "Large Münsterländer"; },
        "207": function(d) { return "Leonberger"; },
        "208": function(d) { return "Lhasa Apso"; },
        "209": function(d) { return "Little Lion Dog"; },
        "210": function(d) { return "Long-haired German Pointer"; },
        "211": function(d) { return "Long-haired Pyrenean Sheepdog"; },
        "212": function(d) { return "Maltese"; },
        "213": function(d) { return "Manchester Terrier"; },
        "214": function(d) { return "Maremma and Abruzzese Sheepdog"; },
        "215": function(d) { return "Mastiff"; },
        "216": function(d) { return "Medium Size Poodle"; },
        "217": function(d) { return "Mexican Hairless Dogs"; },
        "218": function(d) { return "Miniature Bull Terrier"; },
        "219": function(d) { return "Miniature Pinscher"; },
        "220": function(d) { return "Miniature Poodle"; },
        "221": function(d) { return "Miniature Schnauzers"; },
        "222": function(d) { return "Mittelspitz"; },
        "223": function(d) { return "Mudi"; },
        "224": function(d) { return "Napolitan Mastiff"; },
        "225": function(d) { return "Nederlandse Kooikerhondje"; },
        "226": function(d) { return "Newfoundland"; },
        "227": function(d) { return "Norfolk Terrier"; },
        "228": function(d) { return "Norrbottenspitz"; },
        "229": function(d) { return "Norwegian Buhund"; },
        "230": function(d) { return "Norwegian Elkhound, black"; },
        "231": function(d) { return "Norwegian Elkhound, grey"; },
        "232": function(d) { return "Norwegian Lundehund"; },
        "233": function(d) { return "Norwich Terrier"; },
        "234": function(d) { return "Nova Scotia Duck Tolling Retriever"; },
        "235": function(d) { return "Old Danish Pointer"; },
        "236": function(d) { return "Old English Sheepdog"; },
        "237": function(d) { return "Olde English Bulldogge"; },
        "238": function(d) { return "Otterhound"; },
        "239": function(d) { return "Papillon"; },
        "240": function(d) { return "Parson Russell Terrier"; },
        "241": function(d) { return "Pekingese"; },
        "242": function(d) { return "Peruvian Hairless Dog"; },
        "243": function(d) { return "Petit Basset Griffon Vendèn"; },
        "244": function(d) { return "Petit Bleu de Gascogne"; },
        "245": function(d) { return "Petit Brabancon"; },
        "246": function(d) { return "Phalène"; },
        "247": function(d) { return "Pharaoh Hound"; },
        "248": function(d) { return "Picardy Spaniel"; },
        "249": function(d) { return "Plott"; },
        "250": function(d) { return "Podengo Portuguese Smooth-haired Large"; },
        "251": function(d) { return "Podengo Portuguese Smooth-haired Medium size"; },
        "252": function(d) { return "Podengo Portuguese Smooth-haired Miniature"; },
        "253": function(d) { return "Podengo Portuguese Wire-haired Miniature"; },
        "254": function(d) { return "Podengo Portuguese, Wire-haired Medium size"; },
        "255": function(d) { return "Polish Greyhound"; },
        "256": function(d) { return "Polish Hound"; },
        "257": function(d) { return "Polish Lowland Sheepdog"; },
        "258": function(d) { return "Pomeranian"; },
        "259": function(d) { return "Poodles"; },
        "260": function(d) { return "Porcelaine"; },
        "261": function(d) { return "Portuguese Pointing Dog"; },
        "262": function(d) { return "Portuguese Sheepdog"; },
        "263": function(d) { return "Portuguese Water Dog"; },
        "264": function(d) { return "Posavski Gonic"; },
        "265": function(d) { return "Prazsky Krysavik"; },
        "266": function(d) { return "Pudelpointer"; },
        "267": function(d) { return "Pug"; },
        "268": function(d) { return "Puli"; },
        "269": function(d) { return "Pumi"; },
        "270": function(d) { return "Pyrenean Mastiff"; },
        "271": function(d) { return "Pyrenean Mountain Dog"; },
        "272": function(d) { return "Rabbit Dachshund, Long-haired"; },
        "273": function(d) { return "Rabbit Dachshund, Smooth-haired"; },
        "274": function(d) { return "Rabbit Dachshund, Wire-haired"; },
        "275": function(d) { return "Rhodesian Ridgeback"; },
        "276": function(d) { return "Romanian Mioritic Shepherd Dog"; },
        "277": function(d) { return "Rottweiler"; },
        "278": function(d) { return "Russian Hound"; },
        "279": function(d) { return "Russian Toy"; },
        "280": function(d) { return "Russian-European Laika"; },
        "281": function(d) { return "Russkaja Tsvetnaja Bolonka"; },
        "282": function(d) { return "Saarloos Wolfdog"; },
        "283": function(d) { return "Saint Bernard"; },
        "284": function(d) { return "Saint Bernard Dog, Long-haired"; },
        "285": function(d) { return "Saint Bernard Dog, Short-haired"; },
        "286": function(d) { return "Saluki"; },
        "287": function(d) { return "Samoyed"; },
        "288": function(d) { return "Sarplaninac"; },
        "289": function(d) { return "Sauerland Hound"; },
        "290": function(d) { return "Schapendoes"; },
        "291": function(d) { return "Schiller Hound"; },
        "292": function(d) { return "Schipperke"; },
        "293": function(d) { return "Schnauzers"; },
        "294": function(d) { return "Scottish Terrier"; },
        "295": function(d) { return "Sealyham Terrier"; },
        "296": function(d) { return "Shar Pei"; },
        "297": function(d) { return "Shetland Sheepdog"; },
        "298": function(d) { return "Shiba"; },
        "299": function(d) { return "Shih Tzu"; },
        "300": function(d) { return "Shikoku"; },
        "301": function(d) { return "Short-haired German Pointer"; },
        "302": function(d) { return "Short-haired Italian Hound"; },
        "303": function(d) { return "Short-haired Pyrenean Sheepdog"; },
        "304": function(d) { return "Siberian Husky"; },
        "305": function(d) { return "Skye Terrier"; },
        "306": function(d) { return "Sloughi"; },
        "307": function(d) { return "Slovakian Chuvach"; },
        "308": function(d) { return "Slovakian Hound"; },
        "309": function(d) { return "Small M?nsterl?nder"; },
        "310": function(d) { return "South-Russian Ovtcharka"; },
        "311": function(d) { return "Spaniel de Pont-Audemer"; },
        "312": function(d) { return "Spanish Greyhound"; },
        "313": function(d) { return "Spanish Mastiff"; },
        "314": function(d) { return "Spanish Waterdog"; },
        "315": function(d) { return "Spinone Italiano"; },
        "316": function(d) { return "Stabyhoun"; },
        "317": function(d) { return "Staffordshire Bull Terrier"; },
        "318": function(d) { return "Standard Poodle"; },
        "319": function(d) { return "Sussex Spaniel"; },
        "320": function(d) { return "Swedish Elkhound"; },
        "321": function(d) { return "Swedish Lapphund"; },
        "322": function(d) { return "Swedish Vallhund"; },
        "323": function(d) { return "Swedish White Elkhound"; },
        "324": function(d) { return "Swiss Hound"; },
        "325": function(d) { return "Swiss Hound, Lucerne Hound"; },
        "326": function(d) { return "Tatra Shepherd Dog"; },
        "327": function(d) { return "Thai Ridgeback"; },
        "328": function(d) { return "Tibetan Mastiff"; },
        "329": function(d) { return "Tibetan Spaniel"; },
        "330": function(d) { return "Tibetan Terrier"; },
        "331": function(d) { return "Tornjak"; },
        "332": function(d) { return "Tosa"; },
        "333": function(d) { return "Toy Poodle"; },
        "334": function(d) { return "Uruguayan Cimarron"; },
        "335": function(d) { return "Volpino Italiano"; },
        "336": function(d) { return "Weimaraner"; },
        "337": function(d) { return "Welsh Corgi"; },
        "338": function(d) { return "Welsh Corgi Cardigan"; },
        "339": function(d) { return "Welsh Corgi Pembroke"; },
        "340": function(d) { return "Welsh Springer Spaniel"; },
        "341": function(d) { return "Welsh Terrier"; },
        "342": function(d) { return "West Highland White Terrier"; },
        "343": function(d) { return "West-Siberian Laika"; },
        "344": function(d) { return "Wetterhoun"; },
        "345": function(d) { return "Whippet"; },
        "346": function(d) { return "White Swiss Shepherd Dog"; },
        "347": function(d) { return "Wire-haired German Pointer"; },
        "348": function(d) { return "Yorkshire Terrier"; },
        "349": function(d) { return "Breed unknown"; },
        "001": function(d) { return "Affenpinscher"; },
        "002": function(d) { return "Afghan Hound"; },
        "003": function(d) { return "Airedale Terrier"; },
        "004": function(d) { return "Akita"; },
        "005": function(d) { return "Alaskan Malamute"; },
        "006": function(d) { return "Alpine Dachsbracke"; },
        "007": function(d) { return "American Akita"; },
        "008": function(d) { return "American Cocker Spaniel"; },
        "009": function(d) { return "American Fox Hound"; },
        "010": function(d) { return "American Hairless Terrier"; },
        "011": function(d) { return "American Staffordshire Terrier"; },
        "012": function(d) { return "American Toy Fox Terrier"; },
        "013": function(d) { return "American Water Spaniel"; },
        "014": function(d) { return "Anatolian Shepherd Dog"; },
        "015": function(d) { return "Anglo-Russian Hound"; },
        "016": function(d) { return "Appenzell Cattle Dog"; },
        "017": function(d) { return "Australian Cattle Dog"; },
        "018": function(d) { return "Australian Kelpie"; },
        "019": function(d) { return "Australian Shepherd"; },
        "020": function(d) { return "Australian Silky Terrier"; },
        "021": function(d) { return "Australian Terrier"; },
        "022": function(d) { return "Austrian Pinscher"; },
        "023": function(d) { return "Azawakh"; },
        "024": function(d) { return "Barbet"; },
        "025": function(d) { return "Basenji"; },
        "026": function(d) { return "Basset artésien normand"; },
        "027": function(d) { return "Basset Bleu de Gascogne"; },
        "028": function(d) { return "Basset fauve de Bretagne"; },
        "029": function(d) { return "Basset Griffon Vendén"; },
        "030": function(d) { return "Basset Hound"; },
        "031": function(d) { return "Bavarian Mountain Scenthound"; },
        "032": function(d) { return "Beagle"; },
        "033": function(d) { return "Beagle Harrier"; },
        "034": function(d) { return "Bearded Collie"; },
        "035": function(d) { return "Beauceron"; },
        "036": function(d) { return "Bedlington Terrier"; },
        "037": function(d) { return "Belgian Shepherd Dog, Groenendael"; },
        "038": function(d) { return "Belgian Shepherd Dog, Laekenois"; },
        "039": function(d) { return "Belgian Shepherd Dog, Malinois"; },
        "040": function(d) { return "Belgian Shepherd Dog, Tervueren"; },
        "041": function(d) { return "Belgian Shepherd Dogs"; },
        "042": function(d) { return "Bergamasco"; },
        "043": function(d) { return "Berger Picard"; },
        "044": function(d) { return "Bernese Mountain Dog"; },
        "045": function(d) { return "Bichon Frise"; },
        "046": function(d) { return "Bichon Havanais"; },
        "047": function(d) { return "Black and Tan Coon Hound"; },
        "048": function(d) { return "Black Russian Terrier"; },
        "049": function(d) { return "Blood Hound"; },
        "050": function(d) { return "Blue Picardy Spaniel"; },
        "051": function(d) { return "Bolognese"; },
        "052": function(d) { return "Border Collie"; },
        "053": function(d) { return "Border Terrier"; },
        "054": function(d) { return "Borzoi"; },
        "055": function(d) { return "Boston Terrier"; },
        "056": function(d) { return "Bouvier des Flandres"; },
        "057": function(d) { return "Boxer"; },
        "058": function(d) { return "Bracco Italiano"; },
        "059": function(d) { return "Braque dAuvergne"; },
        "060": function(d) { return "Braque du Bourbonnais"; },
        "061": function(d) { return "Braque Francais, type Pyrenees"; },
        "062": function(d) { return "Brazilian Terrier"; },
        "063": function(d) { return "Briard"; },
        "064": function(d) { return "Brittany"; },
        "065": function(d) { return "Broholmer"; },
        "066": function(d) { return "Bull Terrier"; },
        "067": function(d) { return "Bulldog"; },
        "068": function(d) { return "Bullmastiff"; },
        "069": function(d) { return "Burgos Pointing Dog"; },
        "070": function(d) { return "Cairn Terrier"; },
        "071": function(d) { return "Canaan Dog"; },
        "072": function(d) { return "Cao Fila de Sao Miguel"; },
        "073": function(d) { return "Catalan Sheepdog"; },
        "074": function(d) { return "Caucasian Ovtcharka"; },
        "075": function(d) { return "Cavalier King Charles Spaniel"; },
        "076": function(d) { return "Central Asian Ovtcharka"; },
        "077": function(d) { return "Ceskoslovensky Vlcak"; },
        "078": function(d) { return "Cesky Fousek"; },
        "079": function(d) { return "Cesky Terrier"; },
        "080": function(d) { return "Chesapeake Bay Retriever"; },
        "081": function(d) { return "Chihuahua"; },
        "082": function(d) { return "Chihuahua Long-haired"; },
        "083": function(d) { return "Chihuahua Smooth-haired"; },
        "084": function(d) { return "Chinese Crested Dog"; },
        "085": function(d) { return "Chinese Crested Dog, Powder Puff"; },
        "086": function(d) { return "Chodsky Pes"; },
        "087": function(d) { return "Chow Chow"; },
        "088": function(d) { return "Chow Chow, Smooth-haired"; },
        "089": function(d) { return "Cirneco dellEtna"; },
        "090": function(d) { return "Clumber Spaniel"; },
        "091": function(d) { return "Coarse-haired Istrian Hound"; },
        "092": function(d) { return "Coarse-haired Italian Hound"; },
        "093": function(d) { return "Cocker Spaniel"; },
        "094": function(d) { return "Collie"; },
        "095": function(d) { return "Collie Rough"; },
        "096": function(d) { return "Collie Smooth"; },
        "097": function(d) { return "Coton de Tuléar"; },
        "098": function(d) { return "Croatian Sheepdog"; },
        "099": function(d) { return "Curly Coated Retriever"; }
      },
      enginebrand: {
        "001": function(d) { return "Alamarin Jet"; },
        "002": function(d) { return "Alona"; },
        "003": function(d) { return "Archimedes"; },
        "004": function(d) { return "Arona"; },
        "005": function(d) { return "Bedford"; },
        "006": function(d) { return "Betamarine"; },
        "007": function(d) { return "Bmw"; },
        "008": function(d) { return "Bombardier-Rotax"; },
        "009": function(d) { return "Bukh"; },
        "010": function(d) { return "Castoldi Jet"; },
        "011": function(d) { return "Caterpillar"; },
        "012": function(d) { return "Chevrolet"; },
        "013": function(d) { return "Chrysler"; },
        "014": function(d) { return "Crusader"; },
        "015": function(d) { return "Cummins"; },
        "016": function(d) { return "Cummins Industrial"; },
        "017": function(d) { return "Detroit Diesel"; },
        "018": function(d) { return "Deutz"; },
        "019": function(d) { return "Deutz Marine"; },
        "020": function(d) { return "Ekström"; },
        "021": function(d) { return "Engine"; },
        "022": function(d) { return "Evinrude"; },
        "023": function(d) { return "Ford"; },
        "024": function(d) { return "Ford Power"; },
        "025": function(d) { return "Hamilton Jet"; },
        "026": function(d) { return "Hanomag"; },
        "027": function(d) { return "Honda"; },
        "028": function(d) { return "Industrial-Ford"; },
        "029": function(d) { return "Iveco"; },
        "030": function(d) { return "Iveco Aifo"; },
        "031": function(d) { return "Johnson"; },
        "032": function(d) { return "Kawasaki"; },
        "033": function(d) { return "Kubota Beta Marine"; },
        "034": function(d) { return "Kubota Nanni"; },
        "035": function(d) { return "Kubota Nanni Marine"; },
        "036": function(d) { return "Leyland"; },
        "037": function(d) { return "Lister"; },
        "038": function(d) { return "Lombardini"; },
        "039": function(d) { return "MAN"; },
        "040": function(d) { return "Mariner"; },
        "041": function(d) { return "Mariner Power"; },
        "042": function(d) { return "Mercedez-Benz"; },
        "043": function(d) { return "MerCruiser"; },
        "044": function(d) { return "Mercury"; },
        "045": function(d) { return "Mitsubishi"; },
        "046": function(d) { return "Monark"; },
        "047": function(d) { return "MTU"; },
        "048": function(d) { return "Najad 340"; },
        "049": function(d) { return "Nissan"; },
        "050": function(d) { return "Olympia"; },
        "051": function(d) { return "OMC"; },
        "052": function(d) { return "OMC Cobra Diesel"; },
        "053": function(d) { return "OMC-Cobra"; },
        "054": function(d) { return "OMC-King Cobra"; },
        "055": function(d) { return "Peninsular"; },
        "056": function(d) { return "Perkins"; },
        "057": function(d) { return "Rotax"; },
        "058": function(d) { return "Ruggesriine"; },
        "059": function(d) { return "Sabre Lehman"; },
        "060": function(d) { return "Scania"; },
        "061": function(d) { return "Seagull"; },
        "062": function(d) { return "Seatoy-Toyota"; },
        "063": function(d) { return "Selva"; },
        "064": function(d) { return "Sole Diesel"; },
        "065": function(d) { return "Status"; },
        "066": function(d) { return "Suzuki"; },
        "067": function(d) { return "Tamdee"; },
        "068": function(d) { return "Tohatsu"; },
        "069": function(d) { return "Toyota"; },
        "070": function(d) { return "Valmet"; },
        "071": function(d) { return "Vetus"; },
        "072": function(d) { return "Vetus Deutz"; },
        "073": function(d) { return "Vire"; },
        "074": function(d) { return "Volvo Penta"; },
        "075": function(d) { return "Westerbeke"; },
        "076": function(d) { return "Wickström"; },
        "077": function(d) { return "Yamaha"; },
        "078": function(d) { return "Yanmar"; }
      },
      forestGrowthStage: {
        "001": function(d) { return "Mature forest"; },
        "002": function(d) { return "Primarily growth forest"; },
        "003": function(d) { return "Primarily seedling forest"; }
      },
      forestIndemnity: {
        "001": function(d) { return "Storm, snow, fire, lightning and other damage"; },
        "002": function(d) { return "Storm, snow, fire and lightning damage"; },
        "003": function(d) { return "Storm, fire and lightning damage"; },
        "004": function(d) { return "Storm and snow damage"; },
        "005": function(d) { return "Storm damage"; }
      },
      municipality: {
        "100": function(d) { return "Kivijärvi"; },
        "101": function(d) { return "Kokemäki"; },
        "102": function(d) { return "Kokkola"; },
        "103": function(d) { return "Kolari"; },
        "104": function(d) { return "Konnevesi"; },
        "105": function(d) { return "Kontiolahti"; },
        "106": function(d) { return "Korsnäs"; },
        "107": function(d) { return "Koski Tl"; },
        "108": function(d) { return "Kotka"; },
        "109": function(d) { return "Kouvola"; },
        "110": function(d) { return "Kristiinankaupunki"; },
        "111": function(d) { return "Kruunupyy"; },
        "112": function(d) { return "Kuhmo"; },
        "113": function(d) { return "Kuhmoinen"; },
        "114": function(d) { return "Kumlinge"; },
        "115": function(d) { return "Kuopio"; },
        "116": function(d) { return "Kuortane"; },
        "117": function(d) { return "Kurikka"; },
        "118": function(d) { return "Kustavi"; },
        "119": function(d) { return "Kuusamo"; },
        "120": function(d) { return "Kyyjärvi"; },
        "121": function(d) { return "Kärkölä"; },
        "122": function(d) { return "Kärsämäki"; },
        "123": function(d) { return "Kökar"; },
        "124": function(d) { return "Lahti"; },
        "125": function(d) { return "Laihia"; },
        "126": function(d) { return "Laitila"; },
        "127": function(d) { return "Lapinjärvi"; },
        "128": function(d) { return "Lapinlahti"; },
        "129": function(d) { return "Lappajärvi"; },
        "130": function(d) { return "Lappeenranta"; },
        "131": function(d) { return "Lapua"; },
        "132": function(d) { return "Laukaa"; },
        "133": function(d) { return "Lemi"; },
        "134": function(d) { return "Lemland"; },
        "135": function(d) { return "Lempäälä"; },
        "136": function(d) { return "Leppävirta"; },
        "137": function(d) { return "Lestijärvi"; },
        "138": function(d) { return "Lieksa"; },
        "139": function(d) { return "Lieto"; },
        "140": function(d) { return "Liminka"; },
        "141": function(d) { return "Liperi"; },
        "142": function(d) { return "Lohja"; },
        "143": function(d) { return "Loimaa"; },
        "144": function(d) { return "Loppi"; },
        "145": function(d) { return "Loviisa"; },
        "146": function(d) { return "Luhanka"; },
        "147": function(d) { return "Lumijoki"; },
        "148": function(d) { return "Lumparland"; },
        "149": function(d) { return "Luoto"; },
        "150": function(d) { return "Luumäki"; },
        "151": function(d) { return "Maalahti"; },
        "152": function(d) { return "Maarianhamina"; },
        "153": function(d) { return "Marttila"; },
        "154": function(d) { return "Masku"; },
        "155": function(d) { return "Merijärvi"; },
        "156": function(d) { return "Merikarvia"; },
        "157": function(d) { return "Miehikkälä"; },
        "158": function(d) { return "Mikkeli"; },
        "159": function(d) { return "Muhos"; },
        "160": function(d) { return "Multia"; },
        "161": function(d) { return "Muonio"; },
        "162": function(d) { return "Mustasaari"; },
        "163": function(d) { return "Muurame"; },
        "164": function(d) { return "Mynämäki"; },
        "165": function(d) { return "Myrskylä"; },
        "166": function(d) { return "Mäntsälä"; },
        "167": function(d) { return "Mänttä-Vilppula"; },
        "168": function(d) { return "Mäntyharju"; },
        "169": function(d) { return "Naantali"; },
        "170": function(d) { return "Nakkila"; },
        "171": function(d) { return "Nivala"; },
        "172": function(d) { return "Nokia"; },
        "173": function(d) { return "Nousiainen"; },
        "174": function(d) { return "Nurmes"; },
        "175": function(d) { return "Nurmijärvi"; },
        "176": function(d) { return "Närpiö"; },
        "177": function(d) { return "Orimattila"; },
        "178": function(d) { return "Oripää"; },
        "179": function(d) { return "Orivesi"; },
        "180": function(d) { return "Oulainen"; },
        "181": function(d) { return "Oulu"; },
        "182": function(d) { return "Outokumpu"; },
        "183": function(d) { return "Padasjoki"; },
        "184": function(d) { return "Paimio"; },
        "185": function(d) { return "Paltamo"; },
        "186": function(d) { return "Parainen"; },
        "187": function(d) { return "Parikkala"; },
        "188": function(d) { return "Parkano"; },
        "189": function(d) { return "Pedersören Kunta"; },
        "190": function(d) { return "Pelkosenniemi"; },
        "191": function(d) { return "Pello"; },
        "192": function(d) { return "Perho"; },
        "193": function(d) { return "Pertunmaa"; },
        "194": function(d) { return "Petäjävesi"; },
        "195": function(d) { return "Pieksämäki"; },
        "196": function(d) { return "Pielavesi"; },
        "197": function(d) { return "Pietarsaaren Mlk"; },
        "198": function(d) { return "Pietarsaari"; },
        "199": function(d) { return "Pihtipudas"; },
        "200": function(d) { return "Pirkkala"; },
        "201": function(d) { return "Polvijärvi"; },
        "202": function(d) { return "Pomarkku"; },
        "203": function(d) { return "Pori"; },
        "204": function(d) { return "Pornainen"; },
        "205": function(d) { return "Porvoo"; },
        "206": function(d) { return "Posio"; },
        "207": function(d) { return "Pudasjärvi"; },
        "208": function(d) { return "Pukkila"; },
        "209": function(d) { return "Punkaharju"; },
        "210": function(d) { return "Punkalaidun"; },
        "211": function(d) { return "Puolanka"; },
        "212": function(d) { return "Puumala"; },
        "213": function(d) { return "Pyhäjoki"; },
        "214": function(d) { return "Pyhäjärvi"; },
        "215": function(d) { return "Pyhäntä"; },
        "216": function(d) { return "Pyhäranta"; },
        "217": function(d) { return "Pyhtää"; },
        "218": function(d) { return "Pälkäne"; },
        "219": function(d) { return "Pöytyä"; },
        "220": function(d) { return "Raahe"; },
        "221": function(d) { return "Raasepori"; },
        "222": function(d) { return "Raisio"; },
        "223": function(d) { return "Rantasalmi"; },
        "224": function(d) { return "Ranua"; },
        "225": function(d) { return "Rauma"; },
        "226": function(d) { return "Rautalampi"; },
        "227": function(d) { return "Rautavaara"; },
        "228": function(d) { return "Rautjärvi"; },
        "229": function(d) { return "Reisjärvi"; },
        "230": function(d) { return "Riihimäki"; },
        "231": function(d) { return "Ristijärvi"; },
        "232": function(d) { return "Rovaniemi"; },
        "233": function(d) { return "Ruokolahti"; },
        "234": function(d) { return "Ruovesi"; },
        "235": function(d) { return "Rusko"; },
        "236": function(d) { return "Rääkkylä"; },
        "237": function(d) { return "Saarijärvi"; },
        "238": function(d) { return "Salla"; },
        "239": function(d) { return "Salo"; },
        "240": function(d) { return "Saltvik"; },
        "241": function(d) { return "Sastamala"; },
        "242": function(d) { return "Sauvo"; },
        "243": function(d) { return "Savitaipale"; },
        "244": function(d) { return "Savonlinna"; },
        "245": function(d) { return "Savukoski"; },
        "246": function(d) { return "Seinäjoki"; },
        "247": function(d) { return "Sievi"; },
        "248": function(d) { return "Siikainen"; },
        "249": function(d) { return "Siikajoki"; },
        "250": function(d) { return "Siikalatva"; },
        "251": function(d) { return "Siilinjärvi"; },
        "252": function(d) { return "Simo"; },
        "253": function(d) { return "Sipoo"; },
        "254": function(d) { return "Siuntio"; },
        "255": function(d) { return "Sodankylä"; },
        "256": function(d) { return "Soini"; },
        "257": function(d) { return "Somero"; },
        "258": function(d) { return "Sonkajärvi"; },
        "259": function(d) { return "Sotkamo"; },
        "260": function(d) { return "Sottunga"; },
        "261": function(d) { return "Sulkava"; },
        "262": function(d) { return "Sund"; },
        "263": function(d) { return "Suomussalmi"; },
        "264": function(d) { return "Suonenjoki"; },
        "265": function(d) { return "Sysmä"; },
        "266": function(d) { return "Säkylä"; },
        "267": function(d) { return "Taipalsaari"; },
        "268": function(d) { return "Taivalkoski"; },
        "269": function(d) { return "Taivassalo"; },
        "270": function(d) { return "Tammela"; },
        "271": function(d) { return "Tampere"; },
        "272": function(d) { return "Tervo"; },
        "273": function(d) { return "Tervola"; },
        "274": function(d) { return "Teuva"; },
        "275": function(d) { return "Tohmajärvi"; },
        "276": function(d) { return "Toholampi"; },
        "277": function(d) { return "Toivakka"; },
        "278": function(d) { return "Tornio"; },
        "279": function(d) { return "Turku"; },
        "280": function(d) { return "Tuusniemi"; },
        "281": function(d) { return "Tuusula"; },
        "282": function(d) { return "Tyrnävä"; },
        "283": function(d) { return "Ulvila"; },
        "284": function(d) { return "Urjala"; },
        "285": function(d) { return "Utajärvi"; },
        "286": function(d) { return "Utsjoki"; },
        "287": function(d) { return "Uurainen"; },
        "288": function(d) { return "Uusikaarlepyy"; },
        "289": function(d) { return "Uusikaupunki"; },
        "290": function(d) { return "Vaala"; },
        "291": function(d) { return "Vaasa"; },
        "292": function(d) { return "Valkeakoski"; },
        "293": function(d) { return "Vantaa"; },
        "294": function(d) { return "Varkaus"; },
        "295": function(d) { return "Vehmaa"; },
        "296": function(d) { return "Vesanto"; },
        "297": function(d) { return "Vesilahti"; },
        "298": function(d) { return "Veteli"; },
        "299": function(d) { return "Vieremä"; },
        "300": function(d) { return "Vihti"; },
        "301": function(d) { return "Viitasaari"; },
        "302": function(d) { return "Vimpeli"; },
        "303": function(d) { return "Virolahti"; },
        "304": function(d) { return "Virrat"; },
        "305": function(d) { return "VÃ¥rdö"; },
        "306": function(d) { return "Vöyri"; },
        "307": function(d) { return "Ylöjärvi"; },
        "308": function(d) { return "Ylitornio"; },
        "309": function(d) { return "Ylivieska"; },
        "310": function(d) { return "Ypäjä"; },
        "311": function(d) { return "Ähtäri"; },
        "312": function(d) { return "Äänekoski"; },
        "001": function(d) { return "Akaa"; },
        "002": function(d) { return "Alajärvi"; },
        "003": function(d) { return "Alavieska"; },
        "004": function(d) { return "Alavus"; },
        "005": function(d) { return "Asikkala"; },
        "006": function(d) { return "Askola"; },
        "007": function(d) { return "Aura"; },
        "008": function(d) { return "Brändö"; },
        "009": function(d) { return "Eckerö"; },
        "010": function(d) { return "Enonkoski"; },
        "011": function(d) { return "Enontekiö"; },
        "012": function(d) { return "Espoo"; },
        "013": function(d) { return "Eura"; },
        "014": function(d) { return "Eurajoki"; },
        "015": function(d) { return "Evijärvi"; },
        "016": function(d) { return "Finström"; },
        "017": function(d) { return "Forssa"; },
        "018": function(d) { return "Föglö"; },
        "019": function(d) { return "Geta"; },
        "020": function(d) { return "Haapajärvi"; },
        "021": function(d) { return "Haapavesi"; },
        "022": function(d) { return "Hailuoto"; },
        "023": function(d) { return "Halsua"; },
        "024": function(d) { return "Hamina"; },
        "025": function(d) { return "Hammarland"; },
        "026": function(d) { return "Hankasalmi"; },
        "027": function(d) { return "Hanko"; },
        "028": function(d) { return "Harjavalta"; },
        "029": function(d) { return "Hartola"; },
        "030": function(d) { return "Hattula"; },
        "031": function(d) { return "Hausjärvi"; },
        "032": function(d) { return "Heinävesi"; },
        "033": function(d) { return "Heinola"; },
        "034": function(d) { return "Helsinki"; },
        "035": function(d) { return "Hirvensalmi"; },
        "036": function(d) { return "Hollola"; },
        "037": function(d) { return "Huittinen"; },
        "038": function(d) { return "Humppila"; },
        "039": function(d) { return "Hyrynsalmi"; },
        "040": function(d) { return "Hyvinkää"; },
        "041": function(d) { return "Hämeenkyrö"; },
        "042": function(d) { return "Hämeenlinna"; },
        "043": function(d) { return "Ii"; },
        "044": function(d) { return "Iisalmi"; },
        "045": function(d) { return "Iitti"; },
        "046": function(d) { return "Ikaalinen"; },
        "047": function(d) { return "Ilmajoki"; },
        "048": function(d) { return "Ilomantsi"; },
        "049": function(d) { return "Imatra"; },
        "050": function(d) { return "Inari"; },
        "051": function(d) { return "Inkoo"; },
        "052": function(d) { return "Isojoki"; },
        "053": function(d) { return "Isokyrö"; },
        "054": function(d) { return "Janakkala"; },
        "055": function(d) { return "Joensuu"; },
        "056": function(d) { return "Jokioinen"; },
        "057": function(d) { return "Jomala"; },
        "058": function(d) { return "Joroinen"; },
        "059": function(d) { return "Joutsa"; },
        "060": function(d) { return "Juuka"; },
        "061": function(d) { return "Juupajoki"; },
        "062": function(d) { return "Juva"; },
        "063": function(d) { return "Jyväskylä"; },
        "064": function(d) { return "Jämijärvi"; },
        "065": function(d) { return "Jämsä"; },
        "066": function(d) { return "Järvenpää"; },
        "067": function(d) { return "Kaarina"; },
        "068": function(d) { return "Kaavi"; },
        "069": function(d) { return "Kajaani"; },
        "070": function(d) { return "Kalajoki"; },
        "071": function(d) { return "Kangasala"; },
        "072": function(d) { return "Kangasniemi"; },
        "073": function(d) { return "Kankaanpää"; },
        "074": function(d) { return "Kannonkoski"; },
        "075": function(d) { return "Kannus"; },
        "076": function(d) { return "Karijoki"; },
        "077": function(d) { return "Karkkila"; },
        "078": function(d) { return "Karstula"; },
        "079": function(d) { return "Karvia"; },
        "080": function(d) { return "Kaskinen"; },
        "081": function(d) { return "Kauhajoki"; },
        "082": function(d) { return "Kauhava"; },
        "083": function(d) { return "Kauniainen"; },
        "084": function(d) { return "Kaustinen"; },
        "085": function(d) { return "Keitele"; },
        "086": function(d) { return "Kemi"; },
        "087": function(d) { return "Kemijärvi"; },
        "088": function(d) { return "Kemiönsaari"; },
        "089": function(d) { return "Keminmaa"; },
        "090": function(d) { return "Kempele"; },
        "091": function(d) { return "Kerava"; },
        "092": function(d) { return "Kerimäki"; },
        "093": function(d) { return "Keuruu"; },
        "094": function(d) { return "Kihniö"; },
        "095": function(d) { return "Kinnula"; },
        "096": function(d) { return "Kirkkonummi"; },
        "097": function(d) { return "Kitee"; },
        "098": function(d) { return "Kittilä"; },
        "099": function(d) { return "Kiuruvesi"; }
      },
      frameMaterial: {
        "001": function(d) { return "Aluminium"; },
        "002": function(d) { return "Carbon fibre"; },
        "003": function(d) { return "Rubber"; },
        "004": function(d) { return "Glass fibre"; },
        "005": function(d) { return "Composite plastic"; },
        "006": function(d) { return "Wood"; },
        "007": function(d) { return "Steel"; },
        "008": function(d) { return "Glass fibre-reinforced wood"; }
      },
      "gender-horse": {
        "001": function(d) { return "Stallion"; },
        "002": function(d) { return "Gelding"; },
        "003": function(d) { return "Mare"; }
      },
      "gender-female": function(d) { return "Female"; },
      "gender-male": function(d) { return "Male     "; },
      homeType: {
        "001": function(d) { return "Detached house"; },
        "002": function(d) { return "Flat"; },
        "003": function(d) { return "Terraced house"; },
        "004": function(d) { return "Single-family house"; },
        "005": function(d) { return "Semi-detached house"; },
        "006": function(d) { return "Outbuilding"; },
        "007": function(d) { return "Sauna building"; },
        "008": function(d) { return "Holiday home"; }
      },
      inspectionClass: {
        "001": function(d) { return "No inspection class or condition class"; },
        "002": function(d) { return "Inspection class 1"; },
        "003": function(d) { return "Inspection class 2"; },
        "004": function(d) { return "Inspection class 3"; },
        "005": function(d) { return "Condition class"; }
      },
      insuranceCompany: {
        "001": function(d) { return "A-Vakuutus"; },
        "002": function(d) { return "Fennia"; },
        "003": function(d) { return "Folksam Vahinkovakuutus"; },
        "004": function(d) { return "If"; },
        "005": function(d) { return "LähiTapiola"; },
        "006": function(d) { return "OP"; },
        "007": function(d) { return "Pohjantähti"; },
        "008": function(d) { return "POP Vakuutus"; },
        "009": function(d) { return "Säästöpankin vakuutukset"; },
        "010": function(d) { return "Turva"; },
        "011": function(d) { return "Volvia"; },
        "012": function(d) { return "Ãlands Ãmsesidiga"; },
        "013": function(d) { return "Another incurance company"; }
      },
      insuranceIncludesMe: {
        "001": function(d) { return "Your own luggage only"; },
        "002": function(d) { return "Luggage of the whole family"; }
      },
      insuranceScope: {
        "001": function(d) { return "Illness and injury"; },
        "002": function(d) { return "Comprehensive accident"; },
        "003": function(d) { return "Accident"; }
      },
      "insured-animal": {
        "001": function(d) { return "Pedigree dog"; },
        "002": function(d) { return "Mixed-breed dog"; },
        "003": function(d) { return "Pedigree cat"; },
        "004": function(d) { return "Native breed cat"; },
        "005": function(d) { return "Horse"; }
      },
      insuredItem: {
        "001": function(d) { return "Me"; },
        "002": function(d) { return "Family member"; },
        "003": function(d) { return "Luggage only"; }
      },
      longTrip: {
        "001": function(d) { return "0-45 days"; },
        "002": function(d) { return "46-90 days"; },
        "003": function(d) { return "91-120 days"; },
        "004": function(d) { return "121-179 days"; },
        "005": function(d) { return "179+ days"; }
      },
      person: {
        "001": function(d) { return "Me"; },
        "002": function(d) { return "Another adult"; },
        "003": function(d) { return "Child"; },
        "004": function(d) { return "Unborn child or twins"; }
      },
      primaryEngines: {
        "001": function(d) { return "1"; },
        "002": function(d) { return "2"; },
        "003": function(d) { return "3"; }
      },
      purposeOfUse: {
        "001": function(d) { return "I live in an apartment I own"; },
        "002": function(d) { return "I use the apartment in my free time"; },
        "003": function(d) { return "I am a landlord"; },
        "004": function(d) { return "I am a tenant"; }
      },
      transferrableBonus: {
        "001": function(d) { return "0%"; },
        "002": function(d) { return "10%"; },
        "003": function(d) { return "20%"; },
        "004": function(d) { return "30%"; },
        "005": function(d) { return "40%"; },
        "006": function(d) { return "50%"; },
        "007": function(d) { return "60%"; },
        "008": function(d) { return "70 % or more"; }
      },
      valuableType: {
        "001": function(d) { return "Musical instrument"; },
        "002": function(d) { return "Camera and accessories"; },
        "003": function(d) { return "Lens"; },
        "004": function(d) { return "Weapon"; },
        "005": function(d) { return "Watch"; },
        "006": function(d) { return "Jewellery"; }
      },
      vehicleType: {
        "001": function(d) { return "Car"; },
        "002": function(d) { return "Van"; },
        "003": function(d) { return "Motorcycle"; },
        "004": function(d) { return "Moped or light quadricycle"; },
        "005": function(d) { return "Snowmobile"; },
        "006": function(d) { return "Trailer"; },
        "007": function(d) { return "Caravan"; },
        "008": function(d) { return "Campervan"; },
        "009": function(d) { return "Lorry"; },
        "010": function(d) { return "Tractor"; },
        "011": function(d) { return "All-terrain vehicle"; },
        "012": function(d) { return "Museum vehicle"; },
        "013": function(d) { return "Electric personal transportation device"; },
        "014": function(d) { return "Other vehicle"; }
      },
      vehicleMileage: {
        "001": function(d) { return "Up to 5,000 km"; },
        "002": function(d) { return "Up to 10,000 km"; },
        "003": function(d) { return "Up to 15,000 km"; },
        "004": function(d) { return "Up to 20,000 km"; },
        "005": function(d) { return "Up to 25,000 km"; },
        "006": function(d) { return "Up to 30,000 km"; },
        "007": function(d) { return "Up to 40,000 km"; },
        "008": function(d) { return "Over 40,000 km"; },
        "009": function(d) { return "Unknown"; }
      },
      heatingSystem: {
        "001": function(d) { return "Hydronic radiant heat"; },
        "002": function(d) { return "Other than hydronic radiant heat"; },
        "003": function(d) { return "Unknown"; }
      },
      electricity: {
        "001": function(d) { return "Connected to the electricity grid"; },
        "002": function(d) { return "Own power generation"; },
        "003": function(d) { return "No electrification"; }
      }
    },
    validInput: {
      modified: function(d) { return "Modified"; },
      modifiedAria: function(d) { return "You have edited the input field"; },
      notValid: function(d) { return "Check field"; }
    },
    url: {
      direct: function(d) { return "direct"; },
      preSelect: function(d) { return "preselect"; },
      baseName: function(d) { return "/private-customers/insurance/request-of-proposal"; },
      thankyoupage: function(d) { return "/thank-you"; }
    }
  },
  fi: {
    errorText: {
      servlet: {
        additional: {
          info: {
            too: {
              long: function(d) { return "Additional info too long"; }
            }
          }
        },
        email: {
          sending: {
            failed: function(d) { return "Email sending failed"; }
          }
        },
        locale: {
          missing: function(d) { return "Locale missing"; }
        },
        mandatory: {
          info: {
            missing: function(d) { return "Mandatory info missing"; }
          }
        },
        serializing: {
          error: function(d) { return "Serialization error"; }
        },
        token: {
          missing: function(d) { return "Token missing"; }
        }
      },
      checkSsn: function(d) { return "Tarkista vakuutuksenottajan henkilötunnus."; },
      technicalErrorTitle: function(d) { return "Häiriö palvelussa, pahoittelemme"; },
      checkValue: function(d) { return "Tarkista arvo"; },
      required: function(d) { return "Pakollinen"; },
      noResponse: function(d) { return "Ei vastausta, yritä hetken kuluttua uudestaan."; },
      initError: function(d) { return "Sovelluksen alustaminen epäonnistui."; },
      length: function(d) { return "Tarkista arvon pituus"; },
      notNumber: function(d) { return "Tarkista syötetty numero"; },
      invalidDate: function(d) { return "Virheellinen päivämäärä"; },
      invalidInput: function(d) { return "Tarkista syötetty arvo"; },
      invalidHomeInput: function(d) { return "Tarkista syötetty arvo"; },
      formContains: function(d) { return "Lomakkeen virheet: "; },
      forestArea: function(d) { return "Tarkista metsän pinta-ala."; },
      forestPropertCode: function(d) { return "Tarkista metsän kiinteistötunnus."; },
      valuableFirstYearOfService: function(d) { return "Tarkista käyttöönottovuosi. "; },
      permittedCharacters: function(d) { return "Tarkista kirjoitusasu."; },
      animalDateOfBirthDog: function(d) { return "Tarkista syntymäaika. Vakuutettavan koiran tulee olla alle 7-vuotias ja syntymäaika voi olla enintään kuluvan tai seuraavan vuoden aikana."; },
      animalDateOfBirthCat: function(d) { return "Tarkista syntymäaika. Vakuutettavan kissan tulee olla alle 7-vuotias ja syntymäaika voi olla enintään kuluvan tai seuraavan vuoden aikana."; },
      animalDateOfBirthHorse: function(d) { return "Tarkista syntymäaika. Vakuutettavan hevosen tulee olla alle 22-vuotias ja syntymäaika voi olla enintään kuluvan tai seuraavan vuoden aikana."; },
      animalValue: function(d) { return "Tarkista rahallinen arvo."; },
      personBirthDate: function(d) { return "Tarkista laskettu syntymäaika. Laskettu syntymäaika ei voi olla menneisyydessä."; },
      vehicleRegNum: function(d) { return "Tarkista rekisterinumero."; },
      muuAjoneuvoVehicleRegNum: function(d) { return "Tarkista rekisteri- tai valmistenumero."; },
      vehicleSsn: function(d) { return "Tarkista vakuutuksenottajan henkilötunnus."; },
      homeFloorArea: function(d) { return "Tarkista huoneiston pinta-ala."; },
      homeTotalFloorArea: function(d) { return "Tarkista kokonaisala."; },
      homeYourOwnTotalFloorArea: function(d) { return "Tarkista oman asuntosi kokonaisala."; },
      homeConstructionYear: function(d) { return "Tarkista rakennusvuosi."; },
      boatMake: function(d) { return "Tarkista merkki."; },
      boatModel: function(d) { return "Tarkista malli."; },
      boatManufactureYear: function(d) { return "Tarkista valmistusvuosi. "; },
      boatEnginePower: function(d) { return "Tarkista moottorin teho."; },
      engineProductionNumber: function(d) { return "Tarkista valmistenumero."; },
      engineYearOfManufacture: function(d) { return "Tarkista valmistusvuosi."; },
      checkPersonalIdentityCode: function(d) { return "Tarkista henkilötunnus."; },
      atLeastOne: function(d) { return "Valitse vähintään yksi vakuutettava kohde."; },
      technicalErrorTextOpfi: function(d) { return "Ole hyvä ja yritä uudelleen tai ota yhteyttä verkko-ostajan tukeen 010 253 6139 (ma-pe klo 8-18)."; },
      technicalErrorTextOpas: function(d) { return "Ole hyvä ja yritä hetken kuluttua uudelleen."; },
      technicalErrorSending: function(d) { return "Tarjouspyynnön lähetys epäonnistui. Ole hyvä ja yritä uudelleen."; },
      sendingProposalFailed: function(d) { return "Tarjouspyynnön lähetys ei onnistunut. Ole hyvä ja yritä kohta uudestaan. "; }
    },
    error: {
      check: {
        address: function(d) { return "Tarkista osoite."; },
        email: function(d) { return "Tarkista sähköpostiosoite."; },
        first: {
          name: function(d) { return "Tarkista etunimi."; }
        },
        last: {
          name: function(d) { return "Tarkista sukunimi."; }
        },
        phone: {
          number: function(d) { return "Tarkista puhelinnumero."; }
        },
        postal: {
          district: function(d) { return "Tarkista postitoimipaikka."; }
        },
        post: {
          code: function(d) { return "Tarkista postinumero."; }
        },
        security: {
          number: function(d) { return "Tarkista henkilötunnus."; }
        }
      },
      contact: {
        info: {
          address: function(d) { return "Kirjoita osoite."; },
          email: function(d) { return "Kirjoita sähköpostiosoite."; },
          first: {
            name: function(d) { return "Kirjoita etunimi."; }
          },
          last: {
            name: function(d) { return "Kirjoita sukunimi."; }
          },
          phone: {
            number: function(d) { return "Kirjoita puhelinnumero."; }
          },
          postal: {
            district: function(d) { return "Kirjoita postitoimipaikka."; }
          },
          postcode: function(d) { return "Kirjoita postinumero."; },
          security: {
            number: function(d) { return "Kirjoita henkilötunnus."; }
          }
        }
      },
      fill: {
        "in": {
          missing: {
            information: function(d) { return "Täytä puuttuva pakollinen tieto."; }
          }
        }
      },
      invalidCharacters: function(d) { return "Tarkista kirjoitusasu."; },
      header: {
        text: function(d) { return "Palvelu ei ole käytettävissä tällä hetkellä"; }
      },
      id: function(d) { return "Virheen tunniste"; },
      code: function(d) { return "Virhekoodi"; }
    },
    placeHolderText: {
      ppkkvvvv: function(d) { return "pp.kk.vvvv"; }
    },
    uiTitleText: {
      contactBasicDetails: function(d) { return "Omat tiedot"; },
      contactExtraDetails: function(d) { return "Lisätiedot"; },
      insuraceQuestions: function(d) { return "Vakuutettavien kohteiden tiedot"; }
    },
    uiText: {
      keepAliveModalTitle: function(d) { return "Asiointi keskeytetty"; },
      keepAliveModalBody: function(d) { return "Tekninen häiriö palvelussa."; },
      addInsurance: function(d) { return "Lisää vakuutettava kohde"; },
      all: function(d) { return "Kaikki"; },
      almost: {
        ready: function(d) { return "Melkein valmista! Täytä vielä omat tietosi ja teemme sinulle henkilökohtaisen tarjouksen."; }
      },
      animal: function(d) { return "Eläin"; },
      boat: function(d) { return "Vene"; },
      close: function(d) { return "Sulje"; },
      contactNeedContactInfo: function(d) { return "Täytä vielä yhteystietosi"; },
      contactAdditionalInfo: function(d) { return "Kirjoita lisätietoja tarvittaessa"; },
      additionalInfoMessage: function(d) { return "Ethän kirjoita tähän henkilötietoja, kuten henkilötunnuksia tai terveystietoja."; },
      creditInformation: function(d) { return "Tarjouksen tekemistä varten tarkistamme asiakastietosi Pohjola Vakuutuksen asiakasrekisteristä. Tarkistamme tarvittaessa luottotietosi Suomen Asiakastieto Oy:stä ja henkilötietosi Digi- ja väestötietovirastosta. Lisätietoa henkilötietojen käsittelystä saat Pohjola Vakuutus Oy:n ja OP-Henkivakuutus Oy:n asiakkaiden rekisterin tietosuojaselosteelta."; },
      choose: function(d) { return "- Valitse -"; },
      deleteInsuranceQuestions: function(d) { return "Poista kohde"; },
      enlarge: function(d) { return "Suurenna"; },
      filter: function(d) { return "Suodata"; },
      forest: function(d) { return "Metsä"; },
      home: function(d) { return "Koti"; },
      hideAdditionalErrorDetails: function(d) { return "Piilota virheen lisätiedot"; },
      infoboxTile: function(d) { return "Haluatko poistaa tämän kohteen tarjouspynnöltä? Myös syötetyt tiedot poistetaan."; },
      infoboxTileActive: function(d) { return "Haluatko poistaa nämä kohteet tarjouspynnöltä? Myös syötetyt tiedot poistetaan."; },
      infoboxTileActiveSecond: function(d) { return ") tarjouspynnöltä? Myös syötetyt tiedot poistetaan."; },
      lifeInsuranceIssuanceMsg: function(d) { return "Henkivakuutuksen myöntää vakuutusyhtiö OP-Henkivakuutus Oy, jonka asiamiehenä Pohjola Vakuutus Oy toimii. Muut ajoneuvojen, kodin, omaisuuden ja terveyden vakuutukset myöntää vakuutusyhtiö Pohjola Vakuutus Oy."; },
      noResults: function(d) { return "Ei yhtään osumaa"; },
      open: function(d) { return "Avaa"; },
      responsiveTable: {
        checkDate: function(d) { return "Tarkista päivämäärä"; }
      },
      toApplicationStartPage: function(d) { return "Sovelluksen aloitussivulle"; },
      toInsuranceFrontPage: function(d) { return "Vakuutusten etusivulle"; },
      returnToAuthenticatedFrontPage: function(d) { return "Palaa verkkopalveluun"; },
      linkInterruptionTitle: function(d) { return "Sovelluksesta poistuminen"; },
      linkInterruptionBodyText: function(d) { return "Olet siirtymässä pois sovelluksesta. Tallentamattomat tiedot menetetään."; },
      insuranceSelectionheader: function(d) { return "Valitse vakuutettavat kohteet"; },
      pieces: function(d) { return "kpl"; },
      startEditing: function(d) { return "Muokkaa"; },
      view: function(d) { return "Katsele"; },
      showAdditionalErrorDetails: function(d) { return "Näytä virheen lisätiedot"; },
      shrink: function(d) { return "Pienennä"; },
      one: function(d) { return "1"; },
      two: function(d) { return "2"; },
      three: function(d) { return "3"; },
      returnToReportSearch: function(d) { return "Palaa ilmoitusten hakuun"; },
      person: function(d) { return "Henkilö"; },
      travel: function(d) { return "Matka"; },
      valuable: function(d) { return "Arvotavara"; },
      vehicle: function(d) { return "Ajoneuvo"; },
      thankYou: function(d) { return "Kiitos!"; },
      questionsInfoBox: function(d) { return "Haluatko poistaa kohteen ja siihen syötetyt tiedot?"; },
      oneTargetSelected: function(d) { return "kohde valittuna"; },
      targetsSelected: function(d) { return "kohdetta valittuna"; },
      engineData: function(d) { return "Moottorin tiedot"; },
      doesnNotRequireMotorLiabilityInsuranceElectricBike: function(d) { return "Antamiesi tietojen perusteella sähköpolkupyöräsi ei tarvitse erillistä liikennevakuutusta."; },
      doesnNotRequireMotorLiabilityInsuranceElectricVehicle: function(d) { return "Antamiesi tietojen perusteella kevyt sähköajoneuvosi ei tarvitse erillistä liikennevakuutusta."; }
    },
    uitext: {
      line: function(d) { return "-"; }
    },
    email: {
      sending: {
        failed: function(d) { return "Täytä puuttuva tieto"; }
      }
    },
    buttonText: {
      previousButton: function(d) { return "Edellinen"; },
      closeButton: function(d) { return "Sulje"; },
      okButton: function(d) { return "Ok"; },
      reStart: function(d) { return "Aloita alusta"; },
      cancelQuit: function(d) { return "Keskeytä"; },
      cancel: function(d) { return "Peruuta"; },
      pdfButton: function(d) { return "Tulosta PDF"; },
      confirm: function(d) { return "Vahvista"; },
      ready: function(d) { return "Valmis"; },
      closeTab: function(d) { return "Sulje välilehti"; },
      save: function(d) { return "Tallenna"; },
      yes: function(d) { return "Kyllä"; },
      no: function(d) { return "Ei"; },
      showMore: function(d) { return "Näytä enemmän"; },
      showLess: function(d) { return "Näytä vähemmän"; },
      acceptButton: function(d) { return "Hyväksy"; },
      declineButton: function(d) { return "Hylkää"; },
      search: function(d) { return "Hae"; },
      send: function(d) { return "Lähetä"; },
      replace: function(d) { return "Korjaa"; },
      back: function(d) { return "Takaisin"; },
      "delete": function(d) { return "Poista"; },
      clear: function(d) { return "Tyhjennä"; },
      "continue": function(d) { return "Jatka"; }
    },
    unitText: {
      kw: function(d) { return "kW"; },
      cm3: function(d) { return "cm³"; },
      kg: function(d) { return "kg"; },
      euro: function(d) { return "€"; },
      horsePower: function(d) { return "hv"; },
      hectare: function(d) { return "ha"; },
      squareMetre: function(d) { return "m²"; },
      euros: function(d) { return "euroa"; }
    },
    labelText: {
      bannerTextForFixedTermTravelInsurance: function(d) { return "Voit ostaa määräaikaisen matkavakuutuksen vain op.fi-palvelusta tai OP-mobiilista."; },
      fixedTermLinkUrl: function(d) { return "/henkiloasiakkaat/vakuutukset/henkilovakuutus/matkavakuutus"; },
      fixedTemLinkText: function(d) { return "Siirry ostamaan määräaikainen matkavakuutus"; },
      boatUsedInCompetitionsOrRaces: function(d) { return "Onko vene kilpailukäytössä?"; },
      boatFinanceCompany: function(d) { return "Rahoitusyhtiö?"; },
      ownedByFinanceCompany: function(d) { return "Omistaako veneen rahoitusyhtiö?"; },
      registrationNumber: function(d) { return "Rekisterinumero"; },
      manufacturingMethod: function(d) { return "Valmistustapa"; },
      highRiskSports: function(d) { return "Harrastatko urheilun erikoislajeja tai riskialttiita urheilulajeja?"; },
      highRiskSportsMe: function(d) { return "Harrastatko urheilun erikoislajeja tai riskialttiita urheilulajeja?"; },
      whichHighRiskSports: function(d) { return "Kerro, mikä urheilulaji tai -lajit on kyseessä"; },
      forestNameOfTheForestEstateAndLocality: function(d) { return "Metsän tilan ja kylän nimi"; },
      animalUELN: function(d) { return "Hevosen UELN-numero"; },
      animalPurposeOfHorse: function(d) { return "Mikä on hevosen käyttötarkoitus?"; },
      AddNewInsurance: function(d) { return "Valitse lisättävä kohde"; },
      BonusAuthorisedQuestionOtherPerson: function(d) { return "Onko vakuutuksenottaja antanut luvan vakuutus- ja vahinkohistoriansa tarkistamiseen bonuksen laskemista varten?"; },
      bannerTextForTotalOffer: function(d) { return "Jos haluat pyytää tarjouksen myös puolison tai perheenjäsenen ajoneuvovakuutuksista, voit soittaa yhdessä hänen kanssaan asiakaspalveluumme. Tarvitsemme hänen suostumuksen tarjouksen tekemiseen."; },
      aspaLinkText: function(d) { return "Ota yhteyttä asiakaspalveluumme"; },
      aspaLinkUrl: function(d) { return "/henkiloasiakkaat/asiakaspalvelu/ota-yhteytta/verkko-ostajan-tuki"; },
      noElectricMotorAssistanceOver25Kph: function(d) { return "Kytkeytyykö polkupyörän moottorin sähköavustus pois päältä, kun pyörä saavuttaa 25 km/h nopeuden?"; },
      motorPowerOver250W: function(d) { return "Onko moottorin teho yli 250 W?"; },
      weighMoreThan25Kg: function(d) { return "Painaako pyörä yli 25 kg?"; },
      scooterWeighMoreThan25Kg: function(d) { return "Painaako sähköajoneuvo yli 25 kg?"; },
      topSpeedOver25Kph: function(d) { return "Kulkeeko sähköajoneuvo yli 25 km/h?"; },
      DamageCoverage: function(d) { return "Haluatko vakuutuksen kattavan ajoneuvolle kolaroinnista tai törmäyksestä aiheutuneet vahingot?"; },
      vvhConsent: function(d) { return "Annan luvan liikennevakuutuksen bonuksen laskemiseksi vakuutus- ja vahinkohistoriani perusteella"; },
      FirstYearOfService: function(d) { return "Käyttöönottovuosi"; },
      electricPersonalTransportationDeviceFirstYearOfService: function(d) { return "Käyttöönottovuosi"; },
      Health: function(d) { return "Terveysvakuutus"; },
      HealthCoverage: function(d) { return "Terveysvakuutuksen laajuus"; },
      Life: function(d) { return "OP Henkivakuutus"; },
      LifeAria: function(d) { return "Lisätietoa: OP Henkivakuutus"; },
      LifeAdditionalInsurances: function(d) { return "Henkivakuutuksen lisävakuutukset (vapaaehtoinen)"; },
      LifeAdditionalInsurancesAria: function(d) { return "Lisätietoa: Henkivakuutuksen lisävakuutukset"; },
      AdditionalLifeInsurancesSeriousIllness: function(d) { return "Vakavan sairauden vakuutus"; },
      AdditionalLifeInsurancesSeriousIllnessAria: function(d) { return "Lisätietoa: Vakavan sairauden vakuutus"; },
      AdditionalLifeInsurancesTemporaryDisability: function(d) { return "Ohimenevän työkyvyttömyyden vakuutus"; },
      AdditionalLifeInsurancesTemporaryDisabilityAria: function(d) { return "Lisätietoa: Ohimenevän työkyvyttömyyden vakuutus"; },
      AdditionalLifeInsurancesPermanentDisability: function(d) { return "Pysyvän työkyvyttömyyden vakuutus"; },
      AdditionalLifeInsurancesPermanentDisabilityAria: function(d) { return "Lisätietoa: Pysyvän työkyvyttömyyden vakuutus"; },
      PolicyToOwnName: function(d) { return "Otatko vakuutuksen omiin nimiisi?"; },
      PolicyholderSSN: function(d) { return "Vakuutuksenottajan henkilötunnus"; },
      PolicyToOwnNameCarText: function(d) { return "Tarkistamme vakuutus- ja vahinkohistoriasi, jotta voimme laskea sinulle henkilökohtaisen bonuksesi sekä parhaan mahdollisen hinnan."; },
      RegisteredOtherVehicle: function(d) { return "Onko ajoneuvo rekisteröity?"; },
      RegistrationNumber: function(d) { return "Rekisterinumero"; },
      MuuAjoneuvoRegistrationNumber: function(d) { return "Rekisteri- tai valmistenumero"; },
      museumVehicleType: function(d) { return "Mikä ajoneuvo on kyseessä?"; },
      electricPersonalTransportationDeviceVehicleType: function(d) { return "Liikkumisvälineen tyyppi"; },
      HomeAddress: function(d) { return "Vakuutettavan kohteen osoite"; },
      FullName: function(d) { return "Nimi"; },
      FirstName: function(d) { return "Etunimi"; },
      LastName: function(d) { return "Sukunimi"; },
      SecurityId: function(d) { return "Henkilötunnus"; },
      BasicDetailsAddress: function(d) { return "Osoite"; },
      BasicDetailsPostCode: function(d) { return "Postinumero"; },
      BasicDetailsPost: function(d) { return "Postitoimipaikka"; },
      BasicDetailsPhoneNumber: function(d) { return "Puhelinnumero"; },
      BasicDetailsEmail: function(d) { return "Sähköposti"; },
      BasicDetailsKela: function(d) { return "Do you have a KELA card?"; },
      BasicDetailsPermanentResidenceInFinland: function(d) { return "Do you have permanent residence in Finland?"; },
      BasicDetailsNationality: function(d) { return "Nationality"; },
      boatType: function(d) { return "Vakuutettava vene"; },
      motorBoatType: function(d) { return "Venetyyppi"; },
      engineBrand: function(d) { return "Moottorin merkki"; },
      engineProductionNumber: function(d) { return "Valmistenumero"; },
      engineYearOfManufacture: function(d) { return "Valmistusvuosi"; },
      enginePower: function(d) { return "Moottorin teho"; },
      electricPersonalTransportationDevicEnginePower: function(d) { return "Teho (W)"; },
      boatValue: function(d) { return "Veneen ja varusteiden arvo"; },
      boatMunicipality: function(d) { return "Veneen käyttökunta"; },
      boatEngine: function(d) { return "Onko purjeveneessä moottori?"; },
      bonuses: function(d) { return "Haluatko, että vakuutuksen hinnassa huomioidaan bonuksesi toisesta vakuutusyhtiöstä?"; },
      "breed-horse": function(d) { return "Roturyhmä"; },
      breed: function(d) { return "Rotu"; },
      calculatedDueDate: function(d) { return "Laskettu syntymäaika"; },
      competitiveSports: function(d) { return "Kilpaurheileeko hän?"; },
      competitiveSportsMe: function(d) { return "Kilpaurheiletko?"; },
      highRiskSportsMeSecond: function(d) { return "Urheilun erikoislajit ja riskialttiit lajit"; },
      competitiveSportsModalHeader: function(d) { return "Urheilun erikoislajit ja riskialttiit lajit"; },
      competitiveSportsModalItemAdditionalCover: function(d) { return "Urheilulajit, jotka vaativat lisäturvaa"; },
      competitiveSportsModalTitleAviationSports: function(d) { return "Ilmailulajit, kuten"; },
      competitiveSportsModalItemHotAirBalloonAndGasbagFlight: function(d) { return "kuumailma- ja kaasupallolentäminen"; },
      competitiveSportsModalItemMotorisedFlying: function(d) { return "moottorilentäminen"; },
      competitiveSportsModalItemHangGlidingAndParagliding: function(d) { return "riippu- ja varjoliito"; },
      competitiveSportsModalItemMicroLightFlying: function(d) { return "ultrakevytlentäminen"; },
      competitiveSportsModalItemSkydiving: function(d) { return "laskuvarjohyppääminen"; },
      competitiveSportsModalItemIndoorSkydiving: function(d) { return "tuulitunnelilentäminen"; },
      competitiveSportsModalItemFlyingWithAmateurBuiltAircraft: function(d) { return "harrasterakenteisella lentokoneella lentäminen"; },
      competitiveSportsModalItemGlidingAndMotorsailing: function(d) { return "purjelento ja moottoripurjelento"; },
      competitiveSportsModalItemParasailing: function(d) { return "vetovarjolla lentäminen"; },
      competitiveSportsModalTitleTeamSports: function(d) { return "Joukkuelajeista"; },
      competitiveSportsModalItemAmericanFootball: function(d) { return "amerikkalainen jalkapallo"; },
      competitiveSportsModalItemAustralianFootball: function(d) { return "australialainen jalkapallo"; },
      competitiveSportsModalItemRugby: function(d) { return "rugby"; },
      competitiveSportsModalItemlLacrosse: function(d) { return "lacrosse"; },
      competitiveSportsModalItemRollerDerby: function(d) { return "roller derby"; },
      competitiveSportsModalTitleCombatSports: function(d) { return "Kamppailu-, itsepuolustus- tai taistelulajit mukaan lukien"; },
      competitiveSportsModalItemMixedMartialArts: function(d) { return "vapaaottelu"; },
      competitiveSportsModalItemWrestling: function(d) { return "wrestling"; },
      competitiveSportsModalTitleClimbingSports: function(d) { return "Kiipeilylajeista"; },
      competitiveSportsModalItemIceAndRockClimbing: function(d) { return "jää- ja kalliokiipeily"; },
      competitiveSportsModalItemGlacierAndMountainClimbing: function(d) { return "jäätikkö- ja vuorikiipeily"; },
      competitiveSportsModalTitleDivingSports: function(d) { return "Sukelluslajeista"; },
      competitiveSportsModalItemScubaDiving: function(d) { return "laitesukelluslajit"; },
      competitiveSportsModalItemFreediving: function(d) { return "vapaasukellus"; },
      competitiveSportsModalTitleWinterSports: function(d) { return "Talviurheilulajeista"; },
      competitiveSportsModalItemSledding: function(d) { return "kelkkailu"; },
      competitiveSportsModalItemFreestyleSkiing: function(d) { return "freestylehiihto"; },
      competitiveSportsModalItemSpeedAndDownhillSkiing: function(d) { return "nopeus- ja syöksylasku"; },
      competitiveSportsModalItemOffPisteSkiing: function(d) { return "off-pistelasku"; },
      competitiveSportsModalItemDownhillSkating: function(d) { return "alamäkiluistelu"; },
      competitiveSportsModalTitleStrengthSports: function(d) { return "Voimailulajeista"; },
      competitiveSportsModalItemStrengthAthletics: function(d) { return "voimamieslajit"; },
      competitiveSportsModalItemPowerlifting: function(d) { return "voimanosto"; },
      competitiveSportsModalItemWeightlifting: function(d) { return "painonnosto"; },
      competitiveSportsModalItemBodybuilding: function(d) { return "kehonrakennus"; },
      competitiveSportsModalTitleOtherSeparatelyInsuredSports: function(d) { return "Muut erikseen vakuutettavat lajit"; },
      competitiveSportsModalItemBmxCycling: function(d) { return "BMX-pyöräily"; },
      competitiveSportsModalItemBungeeJumping: function(d) { return "benjihyppy"; },
      competitiveSportsModalItemSkimbatOrKiteSurfing: function(d) { return "siipi- ja leijapurjehdus"; },
      competitiveSportsModalItemSailboardingAndFlyboarding: function(d) { return "lentopurjehdus tai -lautailu"; },
      competitiveSportsModalItemParkour: function(d) { return "parkour"; },
      competitiveSportsModalItemAbseiling: function(d) { return "köysilaskeutuminen"; },
      competitiveSportsModalItemAcrobatics: function(d) { return "akrobatia"; },
      competitiveSportsModalItemFreeRunning: function(d) { return "free running"; },
      competitiveSportsModalItemDownhillBiking: function(d) { return "alamäkipyöräily"; },
      competitiveSportsModalItemOceanSailing: function(d) { return "valtameripurjehdus"; },
      competitiveSportsModalItemBaseJumping: function(d) { return "BASE-hyppy"; },
      competitiveSportsModalItemTrekking: function(d) { return "vaellus asumattomalla seudulla, kuten vaellukset ja tutkimusretket ulkomailla vuoristoon, viidakkoon, aavikolle, erämaahan tai muille vastaaville seuduille"; },
      competitiveSportsModalItemWildwaterCanoeing: function(d) { return "koskisyöksy"; },
      competitiveSportsModalTitleOtherSportsOfComparableLevelOfRisk: function(d) { return "Muut vastaavan riskitason riskialttiit urheilulajit"; },
      constructionYear: function(d) { return "Rakennusvuosi"; },
      damageCover: function(d) { return "Haluatko vakuutuksen kattavan esimerkiksi karilleajosta tai törmäyksestä aiheutuneet vahingot?"; },
      ExtraDetailsAdditionalInfo: function(d) { return "Kirjoita lisätietoja tarvittaessa (vapaaehtoinen)."; },
      floorArea: function(d) { return "Huoneiston pinta-ala"; },
      forestArea: function(d) { return "Metsän pinta-ala (ha)"; },
      forestPropertCode: function(d) { return "Metsän kiinteistötunnus"; },
      forestGrowthStage: function(d) { return "Metsän kasvuvaihe"; },
      forestIndemnity: function(d) { return "Korvausten laajuus"; },
      forestMunicipality: function(d) { return "Metsän sijaintikunta"; },
      frameMaterial: function(d) { return "Rungon materiaali"; },
      AnimalGender: function(d) { return "Sukupuoli"; },
      homeType: function(d) { return "Vakuutettava koti tai rakennus"; },
      housingCompany: function(d) { return "Onko kyseessä asunto-osakeyhtiö?"; },
      inspectionClass: function(d) { return "Katsastusluokka tai kuntokartoitus"; },
      insuranceCompany: function(d) { return "Mistä vakuutusyhtiöstä haluat siirtää bonuksen?"; },
      insuranceIncludesPackages: function(d) { return "Vakuutettavat matkatavarat"; },
      insuranceScope: function(d) { return "Vakuutuksen laajuus"; },
      "insured-animal": function(d) { return "Vakuutettava eläin"; },
      insuredItem: function(d) { return "Vakuutettava kohde"; },
      longTrip: function(d) { return "Pitkäkestoisin matka"; },
      luggageInsuranceFamily: function(d) { return "Haluatko vakuuttaa perheesi matkatavarat?"; },
      luggageInsuranceMe: function(d) { return "Vakuutatko matkatavarat?"; },
      make: function(d) { return "Merkki"; },
      electricPersonalTransportationDeviceMake: function(d) { return "Merkki"; },
      manufactureYear: function(d) { return "Valmistusvuosi"; },
      model: function(d) { return "Malli"; },
      electricPersonalTransportationDeviceModel: function(d) { return "Malli"; },
      "monetary-value-horse": function(d) { return "Hevosen rahallinen arvo"; },
      "monetary-value-dog": function(d) { return "Koiran rahallinen arvo"; },
      "monetary-value-pedigree-cat": function(d) { return "Kissan rahallinen arvo"; },
      AnimalName: function(d) { return "Kutsumanimi"; },
      person: function(d) { return "Vakuutettava henkilö"; },
      pipeRenewalYear: function(d) { return "Käyttövesiputkiston asennus- tai  uusimisvuosi"; },
      pipeSystem: function(d) { return "Onko rakennuksessa Käyttövesiputkisto?"; },
      postcode: function(d) { return "Vakuutettavan kohteen postinumero"; },
      primaryEngines: function(d) { return "Päämoottorien lukumäärä"; },
      purposeOfUse: function(d) { return "Käyttötarkoitus"; },
      "time-of-birth": function(d) { return "Syntymäaika"; },
      totalFloorArea: function(d) { return "Kokonaisala"; },
      "totalFloorAreaOwnHomeSemi-detached": function(d) { return "Oman asuntosi kokonaisala"; },
      transferrableBonus: function(d) { return "Siirrettävä bonus"; },
      valuableType: function(d) { return "Vakuutettava arvotavara"; },
      valueCamera: function(d) { return "Kameran ja varusteiden arvo"; },
      valueInstrument: function(d) { return "Soittimen arvo"; },
      valueJewellery: function(d) { return "Korun arvo"; },
      valueLens: function(d) { return "Objektiivin arvo"; },
      valueWatch: function(d) { return "Kellon arvo"; },
      valueWeapon: function(d) { return "Aseen arvo"; },
      vehicleType: function(d) { return "Vakuutettava ajoneuvo"; },
      vehicleValue: function(d) { return "Ajoneuvon arvo"; },
      vehicleMileage: function(d) { return "Arvioi kuinka monta kilometriä autolla ajetaan vuodessa"; },
      whichSports: function(d) { return "Kerro, mikä urheilulaji tai -lajit on kyseessä"; },
      personUnbornMotherChild: function(d) { return "Oletko syntyvän lapsen äiti?"; },
      mothersIdentificationNumber: function(d) { return "Äidin henkilötunnus"; },
      waterPipeSystem: function(d) { return "Onko rakennuksessa käyttövesiputkisto?"; },
      heatingSystem: function(d) { return "Onko rakennuksessa lämmitystä?"; },
      electricityType: function(d) { return "Onko rakennuksessa sähköt?"; },
      YearOfWaterPipeSystem: function(d) { return "Käyttövesiputkiston asennus- tai uusimisvuosi"; },
      YearOfHeatingSystem: function(d) { return "Lämmitysputkiston asennus- tai uusimisvuosi"; },
      ContactInfo: function(d) { return "Yhteystiedot"; },
      electricPersonalTransportationDeviceSerialNumber: function(d) { return "Valmiste- tai runkonumero"; },
      electricPersonalTransportationDeviceMaximumDesignSpeed: function(d) { return "Rakenteellinen huippunopeus (km/h)"; },
      electricPersonalTransportationDeviceTotalWeight: function(d) { return "Laitteen kokonaispaino (kg)"; },
      electricPersonalTransportationDeviceValue: function(d) { return "Liikkumisvälineen arvo"; },
      electricPersonalTransportationDeviceAgeUnder24: function(d) { return "Käyttääkö ajoneuvoa alle 24-vuotias?"; },
      electricPersonalTransportationDeviceCollisionCrashCoverage: function(d) { return "Haluatko vakuutuksen kattavan liikkumisvälineelle kolaroinnista tai törmäyksestä aiheutuneet vahingot?"; },
      tractorInPrivateUse: function(d) { return "Onko traktori yksityiskäytössä?"; },
      monthlyRent: function(d) { return "Kuukausivuokra"; },
      deviceNumber: function(d) { return "Laitenumero"; },
      serialNumber: function(d) { return "Sarjanumero"; },
      whichJewellery: function(d) { return "Mikä koru?"; }
    },
    hintText: {
      boatUsedInCompetitionsOrRaces: function(d) { return "Huomaathan, että vakuutus ei ole voimassa kilpailun aikana."; },
      registrationNumber: function(d) { return "Rekisterinumeron löydät rekisteröintitodistuksesta."; },
      animalUELN: function(d) { return "UELN-numero on hevosen yksilöintitunnus, joka voi sisältää kirjaimia ja numeroita."; },
      tractorInPrivateUse: function(d) { return "Yksityiskäytössä olevalla traktorilla tarkoitetaan traktoria, joka ei ole yrityksen maatalous- tai tuotantokäytössä. Sitä käytetään esimerkiksi oman pihan auraukseen, omien polttopuiden kuljetukseen tai muuhun omaan käyttöön."; },
      electricPersonalTransportationDeviceValue: function(d) { return "Ilmoita arvio liikkumisvälineen euromääräisestä arvosta."; },
      electricPersonalTransportationDeviceTotalWeight: function(d) { return "Esimerkiksi kirjoita polkupyörän kokonaispaino akun kanssa."; },
      bannerTextForTotalOffer: function(d) { return "Kokonaisala on asunnon kaikkien kerrosten ulkomittojen mukaan laskettujen pinta-alojen summa, jossa huomioidaan vähintään 160 cm korkeat tilat.  Kokonaisalan voit tarkistaa esimerkiksi rakennuspiirustuksista."; },
      extra: {
        information: function(d) { return "Voit halutessasi täydentää tarjouspyyntöäsi lisätiedoilla."; }
      },
      BonusAuthorisedQuestionOtherPerson: function(d) { return "Vastaamalla myöntävästi vakuutat, että olet saanut vakuutuksenottajalta luvan hänen vakuutus- ja vahinkohistoriansa tarkistamiseen. Tarkistamme historian henkilötunnuksen avulla vakuutusyhtiöiden yhteisistä vakuutus- ja vahinkohistoriatiedoista, ja käytämme sitä henkilökohtaisen liikennevakuutuksen bonuksen laskemiseen."; },
      DamageCoverage: function(d) { return "Korvausten laajuus riippuu vakuutuksesta, joten voimme valinnan perusteella tarjota ajoneuvolle sopivan laajuista kaskoa. Liikennevakuutus korvaa ainoastaan vastapuolelle kolaroinnista tai törmäyksestä aiheutuneet vahingot kaskon korvatessa myös omalle ajoneuvolle aiheutuneita vahinkoja."; },
      vvhConsent: function(d) { return "Muodostamme henkilökohtaisen liikennevakuutuksen bonuksesi vakuutus- ja vahinkohistoriasi perusteella. Tarkistamme historiasi henkilötunnuksellasi vakuutusyhtiöiden yhteisistä vakuutus- ja vahinkohistoriatiedoista."; },
      vehicleValue: function(d) { return "Ilmoita arvio ajoneuvon euromääräisestä arvosta. Suosittelemme sopivaa kaskoa ajoneuvosi arvoon perustuen. Esimerkiksi Kevytkaskosta korvataan vahinkoja 15 000 euroon asti."; },
      vehicleMileage: function(d) { return "Arvioi kuinka paljon vakuutettavalla autolla ajetaan enintään vuodessa. Jos ajomäärässä tapahtuu muutoksia, voit ilmoittaa muuttuneen ajomäärän verkkopalvelussa. Voit aina ajaa huoletta, sillä auton ajomäärä vaikuttaa vakuutuksen hintaan, mutta ei vakuutuksen sisältöön."; },
      FirstYearOfService: function(d) { return "Käyttöönottovuosi tarkoittaa ajankohtaa, jolloin arvotavara on valmistettu tai otettu ensimmäisen kerran käyttöön."; },
      Health: function(d) { return "Terveysvakuutus on henkilövakuutus, josta voidaan korvata valitsemasi laajuuden mukaan sairauksien ja tapaturmien tai pelkkien tapaturmien hoitokuluja."; },
      HealthCoverageTitle: function(d) { return "Valitse, mitä haluat vakuutuksesi kattavan:"; },
      HealthCoverageFirst: function(d) { return "Sairaus ja tapaturma: Laajin vaihtoehto antaa parhaan turvan sairauksilta ja tapaturmilta. Korvaa esimerkiksi niin flunssan kuin syövän hoitoa, lääkärikäyntejä ja lääkkeitä."; },
      HealthCoverageSecond: function(d) { return "Kattava tapaturma: Antaa kattavan turvan tapaturmille sekä ehdoissa yksilöidyille sairauksille, jotka usein oireilevat tapaturmien yhteydessä."; },
      HealthCoverageThird: function(d) { return "Tapaturma: Korvaa tapaturmaisten vammojen hoitoa ja lääkkeitä. Ei korvaa sairauksia, joita laajempi vakuutus korvaisi."; },
      Life: function(d) { return "Korvaus henkivakuutuksesta maksetaan edunsaajalle. Edunsaajan voit nimetä itse."; },
      LifeSecond: function(d) { return "OP Henkivakuutuksen korvaus auttaa läheisiäsi, jos kuolet vakuutuksen voimassaoloaikana. OP Henkivakuutuksen yhteyteen voit lisäksi valita vakavan sairauden ja työkyvyttömyyden vakuutukset. Voit pyytää tarjoukset samalla kaikista vakuutuksista. "; },
      LifeAdditionalInsurances: function(d) { return "Korvaus lisävakuutuksista maksetaan sinulle kertakorvauksena tai kuukausittain. "; },
      AdditionalLifeInsurancesSeriousIllness: function(d) { return "Maksamme sovitun kertakorvauksen, jos sinulla todetaan vakuutusehdoissa määritelty vakava sairaus tai tehdään ehdoissa määritelty toimenpide. "; },
      AdditionalLifeInsurancesTemporaryDisability: function(d) { return "Ohimenevän työkyvyttömyyden vakuutuksesta saat päiväkohtaista korvausta, jos et sairauden tai vamman vuoksi pysty tekemään työtäsi ja joudut jäämään sairauslomalle. "; },
      AdditionalLifeInsurancesPermanentDisability: function(d) { return "Pysyvän työkyvyttövyyden vakuutuksesta saat kertakorvauksen, jos olet vakuutuksen voimassa ollessa vamman tai sairauden vuoksi menettänyt lopullisesti kykysi tehdä työtä. "; },
      PolicyToOwnName: function(d) { return "Vakuutuksenottaja voi olla sinun lisäksesi ajoneuvon toinen omistaja tai haltija. Lisää toinen omistaja tai haltija vakuutuksenottajaksi, mikäli uusi vakuutus tulee hänen nimiinsä tai nykyinen vakuutus on hänen nimissään."; },
      boatValue: function(d) { return "Kirjoita rahallinen arvo, josta vene, moottori ja varusteet vakuutetaan. Arvo vastaa kaluston enimmäiskorvausta. Aseta uudehkon veneen arvoksi vastaavan uuden kaluston hankintahinta ja vanhemman veneen arvoksi sen tämän hetkinen jälleenmyyntiarvo."; },
      boatMunicipality: function(d) { return "Merkitse veneesi käyttökunnaksi kunta, jonka alueella venettäsi pääasiallisesti käytetään."; },
      bonuses: function(d) { return "Voit siirtää omissa nimissäsi olevat bonukset uuteen vakuutukseen toisesta vakuutusyhtiöstä. Valitse siirrettäväksi bonukseksi 0 % - 70 %."; },
      competitiveSports: function(d) { return "Kilpaurheiluun kuuluvat urheiluliiton tai -seuran järjestämät kilpailut ja ottelut, valmennusohjelman mukaiset harjoitukset sekä näihin välittömästi liittyvät matkat kilpaurheilun tasosta tai vakuutetun iästä riippumatta."; },
      damageCover: function(d) { return "Korvausten laajuus riippuu vakuutuksesta, joten voimme valinnan perusteella tarjota veneelle sopivaa vakuutusta. Venevahinko -turva korvaa veneilyssä aiheutuneiden vahinkojen lisäksi esimerkiksi myrskyvahinkoja tai maissa säilytetylle veneelle aiheutuneita vahinkoja."; },
      forestPropertCode: function(d) { return "Jos omistat useita metsätiloja, vakuuta metsät erikseen omilla kiinteistötunnuksillaan."; },
      forestArea: function(d) { return "Huomioi, etteivät kitu- ja joutomaat kuulu metsän pinta-alaan."; },
      forestGrowthStage: function(d) { return "Myrskyvahinkojen enimmäiskorvaus muodostetaan metsän kasvuvaiheen mukaan."; },
      forestIndemnity: function(d) { return "Korvausten laajuus riippuu vakuutukseesi sisällytetyistä turvista. Vakuutuksen sisältämät turvat korvaavat puustolle, taimikolle, puutavaralle, istutettaville taimille ja hakkuutähteille aiheutuvia vahinkoja."; },
      inspectionClass: function(d) { return "Saat vakuutuksestasi alennusta, kun katsastutat veneesi tai teetät kuntokartoituksen (Finnboat) vuosittain."; },
      insuranceIncludes: function(d) { return "Henkilökohtainen matkatavaravakuutuksesi kattaa kanssasi samassa taloudessa asuvien perheenjäsentesi matkatavarat, kun matkustatte yhdessä. Koko perheen matkatavaravakuutus kattaa samassa taloudessa asuvien perheenjäsenten matkatavarat, vaikka he eivät matkustaisikaan yhdessä."; },
      insuranceScope: function(d) { return "Valitse, mitä haluat vakuutuksen kattavan, jotta voimme tarjota sopivaa henkilövakuutusta. Henkilövakuutuksesta voidaan korvata sekä sairauksien että tapaturmien tai pelkkien tapaturmien hoitokuluja."; },
      longTrip: function(d) { return "Mikäli yksittäisen matkan kesto on yli 45 vuorokautta, tulee tämä huomioida matkavakuutuksessa."; },
      luggageInsuranceFamily: function(d) { return "Voit vakuuttaa kaikkien kanssasi samassa taloudessa asuvien perheenjäsenten matkatavarat, vaikka ette matkustaisi yhdessä tai matkustaisitte eri kohteisiin."; },
      model: function(d) { return "Ilmoita veneen mallitiedot mahdollisimman tarkasti (esimerkiksi 520 DC)."; },
      "monetary-value": function(d) { return "Eläimen rahallinen arvo kuvaa eläimen menetyksestä maksettua korvausta. Rahallinen arvo muodostuu eläimen ostohinnasta tai esimerkiksi kilpailu-, näyttely- tai jalostustaustan muodostamasta lisäarvosta."; },
      pipeSystem: function(d) { return "Jos rakennuksessa on Käyttövesiputkisto, vesi kulkee vesipisteisiin. Putkiston ikä vaikuttaa vuotovahingon sattuessa maksettavaan korvaukseen."; },
      totalFloorArea: function(d) { return "Kokonaisala on rakennuksen kaikkien kerrosten ulkomittojen mukaan laskettujen pinta-alojen summa, jossa huomioidaan vähintään 160 cm korkeat tilat.  Kokonaisalan voit tarkistaa esimerkiksi rakennuspiirustuksista."; },
      value: function(d) { return "Kirjoita rahallinen arvo, josta arvotavarasi vakuutetaan. Arvo vastaa arvotavaran enimmäiskorvausta, joten arvoksi on hyvä asettaa uuden vastaavan arvotavaran hankintahinta."; },
      BonusAuthorisedQuestionOtherPersonCarExtraText: function(d) { return "Soitamme sinulle, sillä tarvitsemme vakuutuksenottajan luvan hänen vakuutus- ja vahinkohistoriansa tarkistamiseen. Näin voimme laskea hänelle henkilökohtaisen bonuksen sekä parhaan mahdollisen hinnan."; },
      PolicyToOwnNameCarHint: function(d) { return "Muodostamme henkilökohtaisen liikennevakuutuksen bonuksesi vakuutus- ja vahinkohistoriasi perusteella. Tarkistamme historiasi henkilötunnuksellasi vakuutusyhtiöiden yhteisistä vakuutus- ja vahinkohistoriatiedoista."; },
      phoneNumberContactInfo: function(d) { return "Kirjoita puhelinnumerosi ilman välilyöntejä. Jos liittymäsi on ulkomaalainen, muista maatunnus."; },
      mothersIdentificationNumber: function(d) { return "Laskemme äidin henkilötunnuksen avulla vakuutuksen tarkan hinnan alennuksineen ja saamme hänen osoitetietonsa Pohjola Vakuutuksen asiakasrekisteristä, muiden OP Ryhmän yhteisöjen asiakasrekistereistä tai väestötietojärjestelmästä. Lisäksi lähetämme hänelle terveysselvityslomakkeen."; },
      heatingSystem: function(d) { return "Vesikiertoinen lämmönjako tarkoittaa, että vesi kiertää pattereissa tai lattialämmitysputkissa. Huom! Jos edes yhdessä osassa taloa (esim. kylpyhuoneessa) on vesikiertoinen lämmönjako, valitse vesikiertoinen lämmönjako."; },
      waterPipeSystem: function(d) { return "Käyttövesiputkisto tarkoittaa putkia, joissa vesi kulkee vesipisteisiin (esim. hanoihin). Huomaathan, että putkien ikä vaikuttaa vuotovahingon korvaukseen."; },
      electricityType: function(d) { return "Kytketty sähköverkkoon tarkoittaa, että sähkö tulee valtakunnallisesta verkosta. Oma sähköntuotanto tarkoittaa, että sähkö ei tule valtakunnallisesta verkosta vaan esim. aurinkopaneelista tai aggregaatista. Ei sähköistetty tarkoittaa tilannetta, että rakennukseen ei tule sähköä lainkaan."; },
      YearOfWaterPipeSystem: function(d) { return "Jos käyttövesiputkisto on uusittu vain osittain, kirjoita putkiston alkuperäinen asennusvuosi"; },
      YearOfHeatingSystem: function(d) { return "Jos lämmitysputkisto on uusittu vain osittain, kirjoita putkiston alkuperäinen asennusvuosi"; },
      electricPersonalTransportationDeviceSerialNumber: function(d) { return "Tarvitsemme valmiste- tai runkonumeron, jotta laite voidaan vakuuttaa."; }
    },
    option: {
      true: function(d) { return "Kyllä"; },
      false: function(d) { return "Ei"; },
      yes: function(d) { return "Kyllä"; },
      no: function(d) { return "Ei"; },
      manufacturingMethod: {
        "001": function(d) { return "Tehdasrakenteinen"; },
        "002": function(d) { return "Itse rakennettu"; }
      },
      animalPurposeOfHorse: {
        "001": function(d) { return "Este- tai kenttäratsastus"; },
        "002": function(d) { return "Harrastekäyttö"; },
        "003": function(d) { return "Kouluratsastus"; },
        "004": function(d) { return "Raviurheilu"; },
        "005": function(d) { return "Siitoskäyttö"; },
        "006": function(d) { return "Muu"; }
      },
      HealthCoverage: {
        "001": function(d) { return "Sairaus ja tapaturma"; },
        "002": function(d) { return "Kattava tapaturma"; },
        "003": function(d) { return "Tapaturma"; }
      },
      museumVehicleType: {
        "001": function(d) { return "Henkilöauto"; },
        "002": function(d) { return "Pakettiauto"; },
        "003": function(d) { return "Moottoripyörä"; },
        "004": function(d) { return "Mopo tai mopoauto"; },
        "005": function(d) { return "Moottorikelkka"; },
        "006": function(d) { return "Perävaunu"; },
        "007": function(d) { return "Matkailuvaunu"; },
        "008": function(d) { return "Matkailuauto"; },
        "009": function(d) { return "Kuorma-auto"; },
        "010": function(d) { return "Traktori"; },
        "011": function(d) { return "Mönkijä"; }
      },
      electricPersonalTransportationDeviceVehicleType: {
        "001": function(d) { return "Sähköpolkupyörä"; },
        "002": function(d) { return "Kevyt sähköajoneuvo"; }
      },
      boatType: {
        "001": function(d) { return "Moottorivene"; },
        "002": function(d) { return "Moottoripurjehtija"; },
        "003": function(d) { return "Purjevene"; }
      },
      motorBoatType: {
        "001": function(d) { return "Perämoottorivene"; },
        "002": function(d) { return "Sisämoottorivene"; },
        "003": function(d) { return "Sisäperämoottorivene"; }
      },
      "breed-horse": {
        "001": function(d) { return "Lämminverinen tai puoliverinen"; },
        "002": function(d) { return "Kylmäverinen"; },
        "003": function(d) { return "Poni"; }
      },
      "breed-pedigree-cat": {
        "001": function(d) { return "Abessinialainen"; },
        "002": function(d) { return "American Curl"; },
        "003": function(d) { return "Balineesi"; },
        "004": function(d) { return "Bengali"; },
        "005": function(d) { return "Brittiläinen"; },
        "006": function(d) { return "Burma"; },
        "007": function(d) { return "Burmilla"; },
        "008": function(d) { return "Cornish rex"; },
        "009": function(d) { return "Colourpoint hybridi"; },
        "010": function(d) { return "Cymric"; },
        "011": function(d) { return "Devon rex"; },
        "012": function(d) { return "Don Sfinx"; },
        "013": function(d) { return "Egyptin mau"; },
        "014": function(d) { return "Eurooppalainen"; },
        "015": function(d) { return "Exotic"; },
        "016": function(d) { return "German rex"; },
        "017": function(d) { return "Itämainen"; },
        "018": function(d) { return "Itämainen lyhytkarvainen"; },
        "019": function(d) { return "Itämainen pitkäkarvainen"; },
        "020": function(d) { return "Japanin bobtail"; },
        "021": function(d) { return "Javaneesi"; },
        "022": function(d) { return "Kartusiaani"; },
        "023": function(d) { return "Korat"; },
        "024": function(d) { return "Kurilian bobtail"; },
        "025": function(d) { return "Maine Coon"; },
        "026": function(d) { return "Manx"; },
        "027": function(d) { return "Neva Masquarade"; },
        "028": function(d) { return "Norjalainen metsäkissa"; },
        "029": function(d) { return "Ocicat"; },
        "030": function(d) { return "Persialainen"; },
        "031": function(d) { return "Peterbald"; },
        "032": function(d) { return "Pyhä birma"; },
        "033": function(d) { return "Ragdoll"; },
        "034": function(d) { return "Scottish fold"; },
        "035": function(d) { return "Selkirk Rex"; },
        "036": function(d) { return "Seychellien lyhytkarva"; },
        "037": function(d) { return "Seychellien pitkäkarva"; },
        "038": function(d) { return "Sfinx"; },
        "039": function(d) { return "Siamilainen"; },
        "040": function(d) { return "Singapura"; },
        "041": function(d) { return "Siperiankissa"; },
        "042": function(d) { return "Snow shoe"; },
        "043": function(d) { return "Sokoke"; },
        "044": function(d) { return "Somali"; },
        "045": function(d) { return "Thai"; },
        "046": function(d) { return "Turkkilainen"; },
        "047": function(d) { return "Turkkilainen angora"; },
        "048": function(d) { return "Turkkilainen van"; },
        "049": function(d) { return "Venäjänsininen"; },
        "050": function(d) { return "Rotu ei tiedossa"; }
      },
      "breed-pedigree-dog": {
        "100": function(d) { return "Gascognenbassetti"; },
        "101": function(d) { return "Glen of imaalinterrieri"; },
        "102": function(d) { return "Gordoninsetteri"; },
        "103": function(d) { return "Grand basset griffon vendéen"; },
        "104": function(d) { return "Griffon belge"; },
        "105": function(d) { return "Griffon bruxellois"; },
        "106": function(d) { return "Griffon fauve de bretagne"; },
        "107": function(d) { return "Grönlanninkoira"; },
        "108": function(d) { return "Grosspitz"; },
        "109": function(d) { return "Haldeninajokoira"; },
        "110": function(d) { return "Hälleforsinkoira"; },
        "111": function(d) { return "Hamiltoninajokoira"; },
        "112": function(d) { return "Hannoverinvihikoira"; },
        "113": function(d) { return "Harmaa norjanhirvikoira"; },
        "114": function(d) { return "Harrieri"; },
        "115": function(d) { return "Havannankoira"; },
        "116": function(d) { return "Hokkaidonkoira"; },
        "117": function(d) { return "Hollanninpaimenkoira"; },
        "118": function(d) { return "Hollanninpaimenkoira,karkeakarv."; },
        "119": function(d) { return "Hollanninpaimenkoira,lyhytk."; },
        "120": function(d) { return "Hollanninpaimenkoira,pitkäkarv."; },
        "121": function(d) { return "Hollanninrottakoira"; },
        "122": function(d) { return "Hovawart"; },
        "123": function(d) { return "Hygeninajokoira"; },
        "124": function(d) { return "Ibizanpodenco"; },
        "125": function(d) { return "Irlanninsusikoira"; },
        "126": function(d) { return "Irlanninterrieri"; },
        "127": function(d) { return "Irlanninvesispanieli"; },
        "128": function(d) { return "Islanninlammaskoira"; },
        "129": function(d) { return "Iso gascognenajokoira"; },
        "130": function(d) { return "Isomünsterinseisoja"; },
        "131": function(d) { return "Isosveitsinpaimenkoira"; },
        "132": function(d) { return "Isovillakoira"; },
        "133": function(d) { return "Italianajokoira, karkeakarv."; },
        "134": function(d) { return "Italianajokoira, lyhytkarvainen"; },
        "135": function(d) { return "Italianvinttikoira"; },
        "136": function(d) { return "Itäsiperianlaika"; },
        "137": function(d) { return "Itävallanpinseri"; },
        "138": function(d) { return "Jackrusselinterrieri"; },
        "139": function(d) { return "Jämtlanninpystykorva"; },
        "140": function(d) { return "Japanese chin"; },
        "141": function(d) { return "Japaninpystykorva"; },
        "142": function(d) { return "Kaanaankoira"; },
        "143": function(d) { return "Kääpiöbullterrieri"; },
        "144": function(d) { return "Kääpiöpinseri"; },
        "145": function(d) { return "Kääpiösnautseri"; },
        "146": function(d) { return "Kääpiövillakoira"; },
        "147": function(d) { return "Kai"; },
        "148": function(d) { return "Kanariandoggi"; },
        "149": function(d) { return "Kangalinkoira"; },
        "150": function(d) { return "Karjalankarhukoira"; },
        "151": function(d) { return "Karkeakarvainen istrianajokoira"; },
        "152": function(d) { return "Karkeakarvainen kääpiömäyräkoira"; },
        "153": function(d) { return "Karkeakarvainen kaniinimäyräkoira"; },
        "154": function(d) { return "Karkeakarvainen kettuterrieri"; },
        "155": function(d) { return "Karkeakarvainen mäyräkoira"; },
        "156": function(d) { return "Karkeakarvainen saksanseisoja"; },
        "157": function(d) { return "Katalonianpaimenkoira"; },
        "158": function(d) { return "Kaukasiankoira"; },
        "159": function(d) { return "Keeshond"; },
        "160": function(d) { return "Kerrynterrieri"; },
        "161": function(d) { return "Keskiaasiankoira"; },
        "162": function(d) { return "Keskikokoinen villakoira"; },
        "163": function(d) { return "Kiharakarvainen noutaja"; },
        "164": function(d) { return "Kiinanharjakoira"; },
        "165": function(d) { return "Kiinanharjakoira/powder puff"; },
        "166": function(d) { return "Kiinanpalatsikoira"; },
        "167": function(d) { return "Kingcharlesinspanieli"; },
        "168": function(d) { return "Kishu"; },
        "169": function(d) { return "Kleinspitz"; },
        "170": function(d) { return "Komondor"; },
        "171": function(d) { return "Kooikerhondje"; },
        "172": function(d) { return "Korthalsingriffoni"; },
        "173": function(d) { return "Kreikanajokoira"; },
        "174": function(d) { return "Kroatianpaimenkoira"; },
        "175": function(d) { return "Kromfohrländer"; },
        "176": function(d) { return "Kultainennoutaja"; },
        "177": function(d) { return "Kuvasz"; },
        "178": function(d) { return "Labradorinnoutaja"; },
        "179": function(d) { return "Lagotto romagnolo"; },
        "180": function(d) { return "Lakelandinterrieri"; },
        "181": function(d) { return "Lancashirenkarjakoira"; },
        "182": function(d) { return "Landseer"; },
        "183": function(d) { return "Länsigöötanmaanpystykorva"; },
        "184": function(d) { return "Länsisiperianlaika"; },
        "185": function(d) { return "Lapinporokoira"; },
        "186": function(d) { return "Leonberginkoira"; },
        "187": function(d) { return "Lhasa apso"; },
        "188": function(d) { return "Löwchen"; },
        "189": function(d) { return "Lunnikoira"; },
        "190": function(d) { return "Luzerninajokoira"; },
        "191": function(d) { return "Lyhytkarv. bernhardinkoira"; },
        "192": function(d) { return "Lyhytkarv. chihuahua"; },
        "193": function(d) { return "Lyhytkarv. kääpiömäyräkoira"; },
        "194": function(d) { return "Lyhytkarv. kaniinimäyräkoira"; },
        "195": function(d) { return "Lyhytkarv. mäyräkoira"; },
        "196": function(d) { return "Lyhytkarvainen saksanseisoja"; },
        "197": function(d) { return "Mallorcandoggi"; },
        "198": function(d) { return "Maltankoira"; },
        "199": function(d) { return "Manchesterinterrieri"; },
        "200": function(d) { return "Maremmano-abruzzese"; },
        "201": function(d) { return "Mastiffi"; },
        "202": function(d) { return "Mäyräkoira"; },
        "203": function(d) { return "Meksikonkarvatonkoira"; },
        "204": function(d) { return "Mittelspitz"; },
        "205": function(d) { return "Mopsi"; },
        "206": function(d) { return "Mudi"; },
        "207": function(d) { return "Musta norjanhirvikoira"; },
        "208": function(d) { return "Napolinmastiffi"; },
        "209": function(d) { return "Newfoundlandinkoira"; },
        "210": function(d) { return "Norfolkinterrieri"; },
        "211": function(d) { return "Norwichinterrieri"; },
        "212": function(d) { return "Novascotiannoutaja"; },
        "213": function(d) { return "Owczarek podhalanski"; },
        "214": function(d) { return "Papillon"; },
        "215": function(d) { return "Parsonrussellinterrieri"; },
        "216": function(d) { return "Partacollie"; },
        "217": function(d) { return "Perunkarvatonkoira"; },
        "218": function(d) { return "Pesukarhukoira"; },
        "219": function(d) { return "Petit basset griffon vendéen"; },
        "220": function(d) { return "Phalène"; },
        "221": function(d) { return "Picardienpaimenkoira"; },
        "222": function(d) { return "Picardienspanieli"; },
        "223": function(d) { return "Pieni gascognenajokoira"; },
        "224": function(d) { return "Pienimünsterinseisoja"; },
        "225": function(d) { return "Pinseri"; },
        "226": function(d) { return "Pitkäkarv. bernhardinkoira"; },
        "227": function(d) { return "Pitkäkarv. chihuahua"; },
        "228": function(d) { return "Pitkäkarv. kääpiömäyräkoira"; },
        "229": function(d) { return "Pitkäkarv. kaniinimäyräkoira"; },
        "230": function(d) { return "Pitkäkarv. mäyräkoira"; },
        "231": function(d) { return "Pitkäkarv. saksanseisoja"; },
        "232": function(d) { return "Plottinajokoira"; },
        "233": function(d) { return "Pohjanpystykorva"; },
        "234": function(d) { return "Pointteri"; },
        "235": function(d) { return "Polski owczarek nizinny"; },
        "236": function(d) { return "Pomeranian"; },
        "237": function(d) { return "Pont-audemerinspanieli"; },
        "238": function(d) { return "Porcelaine"; },
        "239": function(d) { return "Portugalinpodengo karkeak. keskik."; },
        "240": function(d) { return "Portugalinpodengo karkeak. pieni"; },
        "241": function(d) { return "Portugalinpodengo lyhytk. iso"; },
        "242": function(d) { return "Portugalinpodengo lyhytk. keskik."; },
        "243": function(d) { return "Portugalinpodengo lyhytk. pieni"; },
        "244": function(d) { return "Portugalinseisoja"; },
        "245": function(d) { return "Portugalinvesikoira"; },
        "246": function(d) { return "Posavinanajokoira"; },
        "247": function(d) { return "Prahanrottakoira"; },
        "248": function(d) { return "Puli"; },
        "249": function(d) { return "Pumi"; },
        "250": function(d) { return "Punainen irlanninsetteri"; },
        "251": function(d) { return "Punavalkoinen irlanninsetteri"; },
        "252": function(d) { return "Puolanajokoira"; },
        "253": function(d) { return "Puolanvinttikoira"; },
        "254": function(d) { return "Pyreneittenkoira"; },
        "255": function(d) { return "Pyreneittenmastiffi"; },
        "256": function(d) { return "Pyreneittenpaimenkoira,lyhytkarv."; },
        "257": function(d) { return "Pyreneittenpaimenkoira,pitkäk."; },
        "258": function(d) { return "Ranskanbulldoggi"; },
        "259": function(d) { return "Ranskanseisoja, pyreneläistyyppi"; },
        "260": function(d) { return "Ranskanspanieli"; },
        "261": function(d) { return "Rhodesiankoira"; },
        "262": function(d) { return "Romanianpaimenkoira"; },
        "263": function(d) { return "Rottweiler"; },
        "264": function(d) { return "Ruotsinlapinkoira"; },
        "265": function(d) { return "Saarloos wolfhond"; },
        "266": function(d) { return "Saksanajokoira"; },
        "267": function(d) { return "Saksanmetsästysterrieri"; },
        "268": function(d) { return "Saksanpaimenkoira"; },
        "269": function(d) { return "Saksanpaimenkoira, pitkäkarvainen"; },
        "270": function(d) { return "Saluki"; },
        "271": function(d) { return "Samojedinkoira"; },
        "272": function(d) { return "São miguelinfila"; },
        "273": function(d) { return "Sarplaninac"; },
        "274": function(d) { return "Sauerlandinajokoira"; },
        "275": function(d) { return "Saukkokoira"; },
        "276": function(d) { return "Schapendoes"; },
        "277": function(d) { return "Schipperke"; },
        "278": function(d) { return "Sealyhaminterrieri"; },
        "279": function(d) { return "Serra de airesinpaimenkoira"; },
        "280": function(d) { return "Shar pei"; },
        "281": function(d) { return "Shetlanninlammaskoira"; },
        "282": function(d) { return "Shiba"; },
        "283": function(d) { return "Shih tzu"; },
        "284": function(d) { return "Shikokunkoira"; },
        "285": function(d) { return "Shillerinajokoira"; },
        "286": function(d) { return "Sileäkarvainen kettuterrieri"; },
        "287": function(d) { return "Sileäkarvainen noutaja"; },
        "288": function(d) { return "Silkkiterrieri"; },
        "289": function(d) { return "Sininenpicardienseisoja"; },
        "290": function(d) { return "Siperianhusky"; },
        "291": function(d) { return "Skotlanninhirvikoira"; },
        "292": function(d) { return "Skotlanninpaimenkoira/Sileäkarvainen Collie"; },
        "293": function(d) { return "Skotlanninterrieri"; },
        "294": function(d) { return "Skyenterrieri"; },
        "295": function(d) { return "Sloughi"; },
        "296": function(d) { return "Slovakiancuvac"; },
        "297": function(d) { return "Smoolanninajokoira"; },
        "298": function(d) { return "Snautseri"; },
        "299": function(d) { return "Spinone"; },
        "300": function(d) { return "Stabijhoun"; },
        "301": function(d) { return "Staffordshirenbullterrieri"; },
        "302": function(d) { return "Suomenajokoira"; },
        "303": function(d) { return "Suomenlapinkoira"; },
        "304": function(d) { return "Suomenpystykorva"; },
        "305": function(d) { return "Sussexinspanieli"; },
        "306": function(d) { return "Suursnautseri"; },
        "307": function(d) { return "Sveitsinajokoira"; },
        "308": function(d) { return "Tanskalais-ruotsalainen pihakoira"; },
        "309": function(d) { return "Tanskandoggi"; },
        "310": function(d) { return "Thai ridgeback"; },
        "311": function(d) { return "Tiibetinmastiffi"; },
        "312": function(d) { return "Tiibetinspanieli"; },
        "313": function(d) { return "Tiibetinterrieri"; },
        "314": function(d) { return "Tornjak"; },
        "315": function(d) { return "Tosa inu"; },
        "316": function(d) { return "Toyvillakoira"; },
        "317": function(d) { return "T?ekinpaimenkoira"; },
        "318": function(d) { return "T?ekinseisoja"; },
        "319": function(d) { return "Unkarinajokoira"; },
        "320": function(d) { return "Unkarinvinttikoira"; },
        "321": function(d) { return "Unkarinvizsla"; },
        "322": function(d) { return "Uruguayncimarrón"; },
        "323": function(d) { return "Valkoinen länsiylämaanterrieri"; },
        "324": function(d) { return "Valkoinen ruotsinhirvikoira"; },
        "325": function(d) { return "Valkoinenpaimenkoira"; },
        "326": function(d) { return "Vanhaenglanninbulldoggi"; },
        "327": function(d) { return "Vanhaenglanninlammaskoira"; },
        "328": function(d) { return "Vanhatanskankanakoira"; },
        "329": function(d) { return "Vehnäterrieri"; },
        "330": function(d) { return "Venäjänajokoira"; },
        "331": function(d) { return "Venäjänbolonka"; },
        "332": function(d) { return "Venäjänmustaterrieri"; },
        "333": function(d) { return "Venäjäntoyterrieri"; },
        "334": function(d) { return "Venäjänvinttikoira"; },
        "335": function(d) { return "Venäläis-eurooppalainen laika"; },
        "336": function(d) { return "Vihikoira"; },
        "337": function(d) { return "Viiriäiskoira"; },
        "338": function(d) { return "Villakoira"; },
        "339": function(d) { return "Villakoirapointteri"; },
        "340": function(d) { return "Volpino italiano"; },
        "341": function(d) { return "Walesinspringerspanieli"; },
        "342": function(d) { return "Walesinterrieri"; },
        "343": function(d) { return "Weimarinseisoja"; },
        "344": function(d) { return "Welsh corgi"; },
        "345": function(d) { return "Welsh corgi,cardigan"; },
        "346": function(d) { return "Welsh corgi,pembroke"; },
        "347": function(d) { return "Whippet"; },
        "348": function(d) { return "Yorkshirenterrieri"; },
        "349": function(d) { return "Rotu ei tiedossa"; },
        "001": function(d) { return "Affenpinseri"; },
        "002": function(d) { return "Afgaaninvinttikoira"; },
        "003": function(d) { return "Airedalenterrieri"; },
        "004": function(d) { return "Akita"; },
        "005": function(d) { return "Alaskan malamuutti"; },
        "006": function(d) { return "Alppien ajokoira"; },
        "007": function(d) { return "Amerikanakita"; },
        "008": function(d) { return "Amerikancockerspanieli"; },
        "009": function(d) { return "Amerikankääpiökettuterrieri"; },
        "010": function(d) { return "Amerikankarvatonterrieri"; },
        "011": function(d) { return "Amerikankettukoira"; },
        "012": function(d) { return "Amerikanstaffordshirenterrieri"; },
        "013": function(d) { return "Amerikanvesispanieli"; },
        "014": function(d) { return "Andalusianrottakoira"; },
        "015": function(d) { return "Appenzellinpaimenkoira"; },
        "016": function(d) { return "Australiankarjakoira"; },
        "017": function(d) { return "Australiankelpie"; },
        "018": function(d) { return "Australianpaimenkoira"; },
        "019": function(d) { return "Australianterrieri"; },
        "020": function(d) { return "Auvergnenseisoja"; },
        "021": function(d) { return "Azawakh"; },
        "022": function(d) { return "Baijerinvuoristovihikoira"; },
        "023": function(d) { return "Barbet"; },
        "024": function(d) { return "Basenji"; },
        "025": function(d) { return "Basset artésien normand"; },
        "026": function(d) { return "Basset griffon vendéen"; },
        "027": function(d) { return "Basset hound"; },
        "028": function(d) { return "Beagle"; },
        "029": function(d) { return "Beagle-harrier"; },
        "030": function(d) { return "Beauceron"; },
        "031": function(d) { return "Bedlingtoninterrieri"; },
        "032": function(d) { return "Belgianpaimenkoira"; },
        "033": function(d) { return "Belgianpaimenkoira, groenendael"; },
        "034": function(d) { return "Belgianpaimenkoira, lakenois"; },
        "035": function(d) { return "Belgianpaimenkoira, malinois"; },
        "036": function(d) { return "Belgianpaimenkoira, tervueren"; },
        "037": function(d) { return "Bergamasco"; },
        "038": function(d) { return "Bernhardinkoira"; },
        "039": function(d) { return "Berninpaimenkoira"; },
        "040": function(d) { return "Bichon frisé"; },
        "041": function(d) { return "Bokseri"; },
        "042": function(d) { return "Bolognese"; },
        "043": function(d) { return "Bordeaux?ndoggi"; },
        "044": function(d) { return "Bordercollie"; },
        "045": function(d) { return "Borderterrieri"; },
        "046": function(d) { return "Bostoninterrieri"; },
        "047": function(d) { return "Bourbonnais`nseisoja"; },
        "048": function(d) { return "Bouvier"; },
        "049": function(d) { return "Brabantingriffoni"; },
        "050": function(d) { return "Bracco italiano"; },
        "051": function(d) { return "Brasilianterrieri"; },
        "052": function(d) { return "Bretagnenbassetti"; },
        "053": function(d) { return "Bretoni"; },
        "054": function(d) { return "Briardi"; },
        "055": function(d) { return "Broholmer"; },
        "056": function(d) { return "Buhund"; },
        "057": function(d) { return "Bullmastiffi"; },
        "058": function(d) { return "Bullterrieri"; },
        "059": function(d) { return "Burgosinseisoja"; },
        "060": function(d) { return "Cairnterrieri"; },
        "061": function(d) { return "Cane Corso"; },
        "062": function(d) { return "Cavalier kingcharlesinspanieli"; },
        "063": function(d) { return "Ceskoslovenský vlcak"; },
        "064": function(d) { return "Ceskyterrieri"; },
        "065": function(d) { return "Chesapeakelahdennoutaja"; },
        "066": function(d) { return "Chihuahua"; },
        "067": function(d) { return "Chow chow"; },
        "068": function(d) { return "Chow chow, lyhytkarvainen"; },
        "069": function(d) { return "Clumberinspanieli"; },
        "070": function(d) { return "Cockerspanieli"; },
        "071": function(d) { return "Collie"; },
        "072": function(d) { return "Collie, pitkäkarvainen"; },
        "073": function(d) { return "Coton de tuléar"; },
        "074": function(d) { return "Dalmatiankoira"; },
        "075": function(d) { return "Dandiedinmontinterrieri"; },
        "076": function(d) { return "Dobermanni"; },
        "077": function(d) { return "Dogo argentino"; },
        "078": function(d) { return "Dreeveri"; },
        "079": function(d) { return "Dunkerinajokoira"; },
        "080": function(d) { return "Eestinajokoira"; },
        "081": function(d) { return "Englanninbulldoggi"; },
        "082": function(d) { return "Englanninkääpiöterrieri"; },
        "083": function(d) { return "Englanninkettukoira"; },
        "084": function(d) { return "Englanninsetteri"; },
        "085": function(d) { return "Englanninspringerspanieli"; },
        "086": function(d) { return "Englanninvinttikoira"; },
        "087": function(d) { return "Englantilais-venäläinen ajokoira"; },
        "088": function(d) { return "Entlebuchinpaimenkoira"; },
        "089": function(d) { return "Espanjanmastiffi"; },
        "090": function(d) { return "Espanjanvesikoira"; },
        "091": function(d) { return "Espanjanvinttikoira"; },
        "092": function(d) { return "Estrelanvuoristokoira"; },
        "093": function(d) { return "Etelävenäjänpaimenkoira"; },
        "094": function(d) { return "Etnankoira"; },
        "095": function(d) { return "Eurasier"; },
        "096": function(d) { return "Faaraokoira"; },
        "097": function(d) { return "Fieldspanieli"; },
        "098": function(d) { return "Fila brasileiro"; },
        "099": function(d) { return "Friisinvesikoira"; }
      },
      enginebrand: {
        "001": function(d) { return "Alamarin-Jet"; },
        "002": function(d) { return "Alona"; },
        "003": function(d) { return "Archimedes"; },
        "004": function(d) { return "Arona"; },
        "005": function(d) { return "Bedford"; },
        "006": function(d) { return "Betamarine"; },
        "007": function(d) { return "Bmw"; },
        "008": function(d) { return "Bombardier-Rotax"; },
        "009": function(d) { return "Bukh"; },
        "010": function(d) { return "Castoldi Jet"; },
        "011": function(d) { return "Caterpillar"; },
        "012": function(d) { return "Chevrolet"; },
        "013": function(d) { return "Chrysler"; },
        "014": function(d) { return "Crusader"; },
        "015": function(d) { return "Cummins"; },
        "016": function(d) { return "Cummins Industrial"; },
        "017": function(d) { return "Detroit Diesel"; },
        "018": function(d) { return "Deutz"; },
        "019": function(d) { return "Deutz Marine"; },
        "020": function(d) { return "Ekström"; },
        "021": function(d) { return "Evinrude"; },
        "022": function(d) { return "Ford"; },
        "023": function(d) { return "Ford Power"; },
        "024": function(d) { return "Hamilton Jet"; },
        "025": function(d) { return "Hanomag"; },
        "026": function(d) { return "Honda"; },
        "027": function(d) { return "Industrial-Ford"; },
        "028": function(d) { return "Iveco"; },
        "029": function(d) { return "Iveco Aifo"; },
        "030": function(d) { return "Johnson"; },
        "031": function(d) { return "Kawasaki"; },
        "032": function(d) { return "Kubota Beta Marine"; },
        "033": function(d) { return "Kubota Nanni"; },
        "034": function(d) { return "Kubota Nanni Marine"; },
        "035": function(d) { return "Leyland"; },
        "036": function(d) { return "Lister"; },
        "037": function(d) { return "Lombardini"; },
        "038": function(d) { return "MAN"; },
        "039": function(d) { return "Mariner"; },
        "040": function(d) { return "Mariner Power"; },
        "041": function(d) { return "Mercedez-Benz"; },
        "042": function(d) { return "MerCruiser"; },
        "043": function(d) { return "Mercury"; },
        "044": function(d) { return "Mitsubishi"; },
        "045": function(d) { return "Monark"; },
        "046": function(d) { return "Motor"; },
        "047": function(d) { return "MTU"; },
        "048": function(d) { return "Najad 340"; },
        "049": function(d) { return "Nissan"; },
        "050": function(d) { return "Olympia"; },
        "051": function(d) { return "OMC"; },
        "052": function(d) { return "OMC Cobra Diesel"; },
        "053": function(d) { return "OMC-Cobra"; },
        "054": function(d) { return "OMC-King Cobra"; },
        "055": function(d) { return "Peninsular"; },
        "056": function(d) { return "Perkins"; },
        "057": function(d) { return "Rotax"; },
        "058": function(d) { return "Ruggesriine"; },
        "059": function(d) { return "Sabre Lehman"; },
        "060": function(d) { return "Scania"; },
        "061": function(d) { return "Seagull"; },
        "062": function(d) { return "Seatoy-Toyota"; },
        "063": function(d) { return "Selva"; },
        "064": function(d) { return "Sole Diesel"; },
        "065": function(d) { return "Status"; },
        "066": function(d) { return "Suzuki"; },
        "067": function(d) { return "Tamdee"; },
        "068": function(d) { return "Tohatsu"; },
        "069": function(d) { return "Toyota"; },
        "070": function(d) { return "Valmet"; },
        "071": function(d) { return "Vetus"; },
        "072": function(d) { return "Vetus Deutz"; },
        "073": function(d) { return "Vire"; },
        "074": function(d) { return "Volvo Penta"; },
        "075": function(d) { return "Westerbeke"; },
        "076": function(d) { return "Wickström"; },
        "077": function(d) { return "Yamaha"; },
        "078": function(d) { return "Yanmar"; }
      },
      forestGrowthStage: {
        "001": function(d) { return "Hakkuukypsä metsä"; },
        "002": function(d) { return "Kasvatusvaltainen metsä"; },
        "003": function(d) { return "Taimikkovaltainen metsä"; }
      },
      forestIndemnity: {
        "001": function(d) { return "Myrsky-, lumi-, palo-, salamanisku- ja muut vahingot"; },
        "002": function(d) { return "Myrsky-, lumi-, palo- ja salamaniskuvahingot"; },
        "003": function(d) { return "Myrsky-, palo- ja salamaniskuvahingot"; },
        "004": function(d) { return "Myrsky- ja lumivahingot"; },
        "005": function(d) { return "Myrskyvahingot"; }
      },
      municipality: {
        "100": function(d) { return "Kivijärvi"; },
        "101": function(d) { return "Kokemäki"; },
        "102": function(d) { return "Kokkola"; },
        "103": function(d) { return "Kolari"; },
        "104": function(d) { return "Konnevesi"; },
        "105": function(d) { return "Kontiolahti"; },
        "106": function(d) { return "Korsnäs"; },
        "107": function(d) { return "Koski Tl"; },
        "108": function(d) { return "Kotka"; },
        "109": function(d) { return "Kouvola"; },
        "110": function(d) { return "Kristiinankaupunki"; },
        "111": function(d) { return "Kruunupyy"; },
        "112": function(d) { return "Kuhmo"; },
        "113": function(d) { return "Kuhmoinen"; },
        "114": function(d) { return "Kumlinge"; },
        "115": function(d) { return "Kuopio"; },
        "116": function(d) { return "Kuortane"; },
        "117": function(d) { return "Kurikka"; },
        "118": function(d) { return "Kustavi"; },
        "119": function(d) { return "Kuusamo"; },
        "120": function(d) { return "Kyyjärvi"; },
        "121": function(d) { return "Kärkölä"; },
        "122": function(d) { return "Kärsämäki"; },
        "123": function(d) { return "Kökar"; },
        "124": function(d) { return "Lahti"; },
        "125": function(d) { return "Laihia"; },
        "126": function(d) { return "Laitila"; },
        "127": function(d) { return "Lapinjärvi"; },
        "128": function(d) { return "Lapinlahti"; },
        "129": function(d) { return "Lappajärvi"; },
        "130": function(d) { return "Lappeenranta"; },
        "131": function(d) { return "Lapua"; },
        "132": function(d) { return "Laukaa"; },
        "133": function(d) { return "Lemi"; },
        "134": function(d) { return "Lemland"; },
        "135": function(d) { return "Lempäälä"; },
        "136": function(d) { return "Leppävirta"; },
        "137": function(d) { return "Lestijärvi"; },
        "138": function(d) { return "Lieksa"; },
        "139": function(d) { return "Lieto"; },
        "140": function(d) { return "Liminka"; },
        "141": function(d) { return "Liperi"; },
        "142": function(d) { return "Lohja"; },
        "143": function(d) { return "Loimaa"; },
        "144": function(d) { return "Loppi"; },
        "145": function(d) { return "Loviisa"; },
        "146": function(d) { return "Luhanka"; },
        "147": function(d) { return "Lumijoki"; },
        "148": function(d) { return "Lumparland"; },
        "149": function(d) { return "Luoto"; },
        "150": function(d) { return "Luumäki"; },
        "151": function(d) { return "Maalahti"; },
        "152": function(d) { return "Maarianhamina"; },
        "153": function(d) { return "Marttila"; },
        "154": function(d) { return "Masku"; },
        "155": function(d) { return "Merijärvi"; },
        "156": function(d) { return "Merikarvia"; },
        "157": function(d) { return "Miehikkälä"; },
        "158": function(d) { return "Mikkeli"; },
        "159": function(d) { return "Muhos"; },
        "160": function(d) { return "Multia"; },
        "161": function(d) { return "Muonio"; },
        "162": function(d) { return "Mustasaari"; },
        "163": function(d) { return "Muurame"; },
        "164": function(d) { return "Mynämäki"; },
        "165": function(d) { return "Myrskylä"; },
        "166": function(d) { return "Mäntsälä"; },
        "167": function(d) { return "Mänttä-Vilppula"; },
        "168": function(d) { return "Mäntyharju"; },
        "169": function(d) { return "Naantali"; },
        "170": function(d) { return "Nakkila"; },
        "171": function(d) { return "Nivala"; },
        "172": function(d) { return "Nokia"; },
        "173": function(d) { return "Nousiainen"; },
        "174": function(d) { return "Nurmes"; },
        "175": function(d) { return "Nurmijärvi"; },
        "176": function(d) { return "Närpiö"; },
        "177": function(d) { return "Orimattila"; },
        "178": function(d) { return "Oripää"; },
        "179": function(d) { return "Orivesi"; },
        "180": function(d) { return "Oulainen"; },
        "181": function(d) { return "Oulu"; },
        "182": function(d) { return "Outokumpu"; },
        "183": function(d) { return "Padasjoki"; },
        "184": function(d) { return "Paimio"; },
        "185": function(d) { return "Paltamo"; },
        "186": function(d) { return "Parainen"; },
        "187": function(d) { return "Parikkala"; },
        "188": function(d) { return "Parkano"; },
        "189": function(d) { return "Pedersören Kunta"; },
        "190": function(d) { return "Pelkosenniemi"; },
        "191": function(d) { return "Pello"; },
        "192": function(d) { return "Perho"; },
        "193": function(d) { return "Pertunmaa"; },
        "194": function(d) { return "Petäjävesi"; },
        "195": function(d) { return "Pieksämäki"; },
        "196": function(d) { return "Pielavesi"; },
        "197": function(d) { return "Pietarsaaren Mlk"; },
        "198": function(d) { return "Pietarsaari"; },
        "199": function(d) { return "Pihtipudas"; },
        "200": function(d) { return "Pirkkala"; },
        "201": function(d) { return "Polvijärvi"; },
        "202": function(d) { return "Pomarkku"; },
        "203": function(d) { return "Pori"; },
        "204": function(d) { return "Pornainen"; },
        "205": function(d) { return "Porvoo"; },
        "206": function(d) { return "Posio"; },
        "207": function(d) { return "Pudasjärvi"; },
        "208": function(d) { return "Pukkila"; },
        "209": function(d) { return "Punkaharju"; },
        "210": function(d) { return "Punkalaidun"; },
        "211": function(d) { return "Puolanka"; },
        "212": function(d) { return "Puumala"; },
        "213": function(d) { return "Pyhäjoki"; },
        "214": function(d) { return "Pyhäjärvi"; },
        "215": function(d) { return "Pyhäntä"; },
        "216": function(d) { return "Pyhäranta"; },
        "217": function(d) { return "Pyhtää"; },
        "218": function(d) { return "Pälkäne"; },
        "219": function(d) { return "Pöytyä"; },
        "220": function(d) { return "Raahe"; },
        "221": function(d) { return "Raasepori"; },
        "222": function(d) { return "Raisio"; },
        "223": function(d) { return "Rantasalmi"; },
        "224": function(d) { return "Ranua"; },
        "225": function(d) { return "Rauma"; },
        "226": function(d) { return "Rautalampi"; },
        "227": function(d) { return "Rautavaara"; },
        "228": function(d) { return "Rautjärvi"; },
        "229": function(d) { return "Reisjärvi"; },
        "230": function(d) { return "Riihimäki"; },
        "231": function(d) { return "Ristijärvi"; },
        "232": function(d) { return "Rovaniemi"; },
        "233": function(d) { return "Ruokolahti"; },
        "234": function(d) { return "Ruovesi"; },
        "235": function(d) { return "Rusko"; },
        "236": function(d) { return "Rääkkylä"; },
        "237": function(d) { return "Saarijärvi"; },
        "238": function(d) { return "Salla"; },
        "239": function(d) { return "Salo"; },
        "240": function(d) { return "Saltvik"; },
        "241": function(d) { return "Sastamala"; },
        "242": function(d) { return "Sauvo"; },
        "243": function(d) { return "Savitaipale"; },
        "244": function(d) { return "Savonlinna"; },
        "245": function(d) { return "Savukoski"; },
        "246": function(d) { return "Seinäjoki"; },
        "247": function(d) { return "Sievi"; },
        "248": function(d) { return "Siikainen"; },
        "249": function(d) { return "Siikajoki"; },
        "250": function(d) { return "Siikalatva"; },
        "251": function(d) { return "Siilinjärvi"; },
        "252": function(d) { return "Simo"; },
        "253": function(d) { return "Sipoo"; },
        "254": function(d) { return "Siuntio"; },
        "255": function(d) { return "Sodankylä"; },
        "256": function(d) { return "Soini"; },
        "257": function(d) { return "Somero"; },
        "258": function(d) { return "Sonkajärvi"; },
        "259": function(d) { return "Sotkamo"; },
        "260": function(d) { return "Sottunga"; },
        "261": function(d) { return "Sulkava"; },
        "262": function(d) { return "Sund"; },
        "263": function(d) { return "Suomussalmi"; },
        "264": function(d) { return "Suonenjoki"; },
        "265": function(d) { return "Sysmä"; },
        "266": function(d) { return "Säkylä"; },
        "267": function(d) { return "Taipalsaari"; },
        "268": function(d) { return "Taivalkoski"; },
        "269": function(d) { return "Taivassalo"; },
        "270": function(d) { return "Tammela"; },
        "271": function(d) { return "Tampere"; },
        "272": function(d) { return "Tervo"; },
        "273": function(d) { return "Tervola"; },
        "274": function(d) { return "Teuva"; },
        "275": function(d) { return "Tohmajärvi"; },
        "276": function(d) { return "Toholampi"; },
        "277": function(d) { return "Toivakka"; },
        "278": function(d) { return "Tornio"; },
        "279": function(d) { return "Turku"; },
        "280": function(d) { return "Tuusniemi"; },
        "281": function(d) { return "Tuusula"; },
        "282": function(d) { return "Tyrnävä"; },
        "283": function(d) { return "Ulvila"; },
        "284": function(d) { return "Urjala"; },
        "285": function(d) { return "Utajärvi"; },
        "286": function(d) { return "Utsjoki"; },
        "287": function(d) { return "Uurainen"; },
        "288": function(d) { return "Uusikaarlepyy"; },
        "289": function(d) { return "Uusikaupunki"; },
        "290": function(d) { return "Vaala"; },
        "291": function(d) { return "Vaasa"; },
        "292": function(d) { return "Valkeakoski"; },
        "293": function(d) { return "Vantaa"; },
        "294": function(d) { return "Varkaus"; },
        "295": function(d) { return "Vehmaa"; },
        "296": function(d) { return "Vesanto"; },
        "297": function(d) { return "Vesilahti"; },
        "298": function(d) { return "Veteli"; },
        "299": function(d) { return "Vieremä"; },
        "300": function(d) { return "Vihti"; },
        "301": function(d) { return "Viitasaari"; },
        "302": function(d) { return "Vimpeli"; },
        "303": function(d) { return "Virolahti"; },
        "304": function(d) { return "Virrat"; },
        "305": function(d) { return "Vårdö"; },
        "306": function(d) { return "Vöyri"; },
        "307": function(d) { return "Ylöjärvi"; },
        "308": function(d) { return "Ylitornio"; },
        "309": function(d) { return "Ylivieska"; },
        "310": function(d) { return "Ypäjä"; },
        "311": function(d) { return "Ähtäri"; },
        "312": function(d) { return "Äänekoski"; },
        "001": function(d) { return "Akaa"; },
        "002": function(d) { return "Alajärvi"; },
        "003": function(d) { return "Alavieska"; },
        "004": function(d) { return "Alavus"; },
        "005": function(d) { return "Asikkala"; },
        "006": function(d) { return "Askola"; },
        "007": function(d) { return "Aura"; },
        "008": function(d) { return "Brändö"; },
        "009": function(d) { return "Eckerö"; },
        "010": function(d) { return "Enonkoski"; },
        "011": function(d) { return "Enontekiö"; },
        "012": function(d) { return "Espoo"; },
        "013": function(d) { return "Eura"; },
        "014": function(d) { return "Eurajoki"; },
        "015": function(d) { return "Evijärvi"; },
        "016": function(d) { return "Finström"; },
        "017": function(d) { return "Forssa"; },
        "018": function(d) { return "Föglö"; },
        "019": function(d) { return "Geta"; },
        "020": function(d) { return "Haapajärvi"; },
        "021": function(d) { return "Haapavesi"; },
        "022": function(d) { return "Hailuoto"; },
        "023": function(d) { return "Halsua"; },
        "024": function(d) { return "Hamina"; },
        "025": function(d) { return "Hammarland"; },
        "026": function(d) { return "Hankasalmi"; },
        "027": function(d) { return "Hanko"; },
        "028": function(d) { return "Harjavalta"; },
        "029": function(d) { return "Hartola"; },
        "030": function(d) { return "Hattula"; },
        "031": function(d) { return "Hausjärvi"; },
        "032": function(d) { return "Heinävesi"; },
        "033": function(d) { return "Heinola"; },
        "034": function(d) { return "Helsinki"; },
        "035": function(d) { return "Hirvensalmi"; },
        "036": function(d) { return "Hollola"; },
        "037": function(d) { return "Huittinen"; },
        "038": function(d) { return "Humppila"; },
        "039": function(d) { return "Hyrynsalmi"; },
        "040": function(d) { return "Hyvinkää"; },
        "041": function(d) { return "Hämeenkyrö"; },
        "042": function(d) { return "Hämeenlinna"; },
        "043": function(d) { return "Ii"; },
        "044": function(d) { return "Iisalmi"; },
        "045": function(d) { return "Iitti"; },
        "046": function(d) { return "Ikaalinen"; },
        "047": function(d) { return "Ilmajoki"; },
        "048": function(d) { return "Ilomantsi"; },
        "049": function(d) { return "Imatra"; },
        "050": function(d) { return "Inari"; },
        "051": function(d) { return "Inkoo"; },
        "052": function(d) { return "Isojoki"; },
        "053": function(d) { return "Isokyrö"; },
        "054": function(d) { return "Janakkala"; },
        "055": function(d) { return "Joensuu"; },
        "056": function(d) { return "Jokioinen"; },
        "057": function(d) { return "Jomala"; },
        "058": function(d) { return "Joroinen"; },
        "059": function(d) { return "Joutsa"; },
        "060": function(d) { return "Juuka"; },
        "061": function(d) { return "Juupajoki"; },
        "062": function(d) { return "Juva"; },
        "063": function(d) { return "Jyväskylä"; },
        "064": function(d) { return "Jämijärvi"; },
        "065": function(d) { return "Jämsä"; },
        "066": function(d) { return "Järvenpää"; },
        "067": function(d) { return "Kaarina"; },
        "068": function(d) { return "Kaavi"; },
        "069": function(d) { return "Kajaani"; },
        "070": function(d) { return "Kalajoki"; },
        "071": function(d) { return "Kangasala"; },
        "072": function(d) { return "Kangasniemi"; },
        "073": function(d) { return "Kankaanpää"; },
        "074": function(d) { return "Kannonkoski"; },
        "075": function(d) { return "Kannus"; },
        "076": function(d) { return "Karijoki"; },
        "077": function(d) { return "Karkkila"; },
        "078": function(d) { return "Karstula"; },
        "079": function(d) { return "Karvia"; },
        "080": function(d) { return "Kaskinen"; },
        "081": function(d) { return "Kauhajoki"; },
        "082": function(d) { return "Kauhava"; },
        "083": function(d) { return "Kauniainen"; },
        "084": function(d) { return "Kaustinen"; },
        "085": function(d) { return "Keitele"; },
        "086": function(d) { return "Kemi"; },
        "087": function(d) { return "Kemijärvi"; },
        "088": function(d) { return "Kemiönsaari"; },
        "089": function(d) { return "Keminmaa"; },
        "090": function(d) { return "Kempele"; },
        "091": function(d) { return "Kerava"; },
        "092": function(d) { return "Kerimäki"; },
        "093": function(d) { return "Keuruu"; },
        "094": function(d) { return "Kihniö"; },
        "095": function(d) { return "Kinnula"; },
        "096": function(d) { return "Kirkkonummi"; },
        "097": function(d) { return "Kitee"; },
        "098": function(d) { return "Kittilä"; },
        "099": function(d) { return "Kiuruvesi"; }
      },
      frameMaterial: {
        "001": function(d) { return "Alumiini"; },
        "002": function(d) { return "Hiilikuitu"; },
        "003": function(d) { return "Kumi"; },
        "004": function(d) { return "Lasikuitu"; },
        "005": function(d) { return "Lujitemuovi"; },
        "006": function(d) { return "Puu"; },
        "007": function(d) { return "Teräs"; },
        "008": function(d) { return "Lasikuidutettu puu"; }
      },
      "gender-horse": {
        "001": function(d) { return "Ori"; },
        "002": function(d) { return "Ruuna"; },
        "003": function(d) { return "Tamma"; }
      },
      "gender-female": function(d) { return "Narttu"; },
      "gender-male": function(d) { return "Uros     "; },
      homeType: {
        "001": function(d) { return "Omakotitalo"; },
        "002": function(d) { return "Kerrostaloasunto"; },
        "003": function(d) { return "Rivitaloasunto"; },
        "004": function(d) { return "Erillistalo"; },
        "005": function(d) { return "Paritalo"; },
        "006": function(d) { return "Talousrakennus"; },
        "007": function(d) { return "Saunarakennus"; },
        "008": function(d) { return "Vapaa-ajan asunto"; }
      },
      inspectionClass: {
        "001": function(d) { return "Ei katsastusluokkaa tai kuntokartoitusta"; },
        "002": function(d) { return "Katsastusluokka 1"; },
        "003": function(d) { return "Katsastusluokka 2"; },
        "004": function(d) { return "Katsastusluokka 3"; },
        "005": function(d) { return "Kuntokartoitus"; }
      },
      insuranceCompany: {
        "001": function(d) { return "A-Vakuutus"; },
        "002": function(d) { return "Fennia"; },
        "003": function(d) { return "Folksam Vahinkovakuutus"; },
        "004": function(d) { return "If"; },
        "005": function(d) { return "LähiTapiola"; },
        "006": function(d) { return "OP"; },
        "007": function(d) { return "Pohjantähti"; },
        "008": function(d) { return "POP Vakuutus"; },
        "009": function(d) { return "Säästöpankin vakuutukset"; },
        "010": function(d) { return "Turva"; },
        "011": function(d) { return "Volvia"; },
        "012": function(d) { return "Ålands Ömsesidiga"; },
        "013": function(d) { return "Muu vakuutusyhtiö"; }
      },
      insuranceIncludesMe: {
        "001": function(d) { return "Ainoastaan omat matkatavarasi"; },
        "002": function(d) { return "Koko perheen matkatavarat"; }
      },
      insuranceScope: {
        "001": function(d) { return "Sairaus ja tapaturma"; },
        "002": function(d) { return "Kattava tapaturma"; },
        "003": function(d) { return "Tapaturma"; }
      },
      "insured-animal": {
        "001": function(d) { return "Rotukoira"; },
        "002": function(d) { return "Sekarotuinen koira"; },
        "003": function(d) { return "Rotukissa"; },
        "004": function(d) { return "Maatiaiskissa"; },
        "005": function(d) { return "Hevonen"; }
      },
      insuredItem: {
        "001": function(d) { return "Minä"; },
        "002": function(d) { return "Perheenjäsen"; },
        "003": function(d) { return "Vain matkatavarat"; }
      },
      longTrip: {
        "001": function(d) { return "0-45 vuorokautta"; },
        "002": function(d) { return "46-90 vuorokautta"; },
        "003": function(d) { return "91-120 vuorokautta"; },
        "004": function(d) { return "121-179 vuorokautta"; },
        "005": function(d) { return "Yli 179 vuorokautta"; }
      },
      person: {
        "001": function(d) { return "Minä"; },
        "002": function(d) { return "Toinen aikuinen"; },
        "003": function(d) { return "Lapsi"; },
        "004": function(d) { return "Syntyvä lapsi tai syntyvät kaksoset"; }
      },
      primaryEngines: {
        "001": function(d) { return "1"; },
        "002": function(d) { return "2"; },
        "003": function(d) { return "3"; }
      },
      purposeOfUse: {
        "001": function(d) { return "Asun omistamassani asunnossa"; },
        "002": function(d) { return "Käytän asuntoa vapaa-ajallani"; },
        "003": function(d) { return "Olen vuokranantaja"; },
        "004": function(d) { return "Olen vuokralainen"; }
      },
      transferrableBonus: {
        "001": function(d) { return "0%"; },
        "002": function(d) { return "10%"; },
        "003": function(d) { return "20%"; },
        "004": function(d) { return "30%"; },
        "005": function(d) { return "40%"; },
        "006": function(d) { return "50%"; },
        "007": function(d) { return "60%"; },
        "008": function(d) { return "70 % tai enemmän"; }
      },
      valuableType: {
        "001": function(d) { return "Soitin"; },
        "002": function(d) { return "Kamera varusteineen"; },
        "003": function(d) { return "Objektiivi"; },
        "004": function(d) { return "Ase"; },
        "005": function(d) { return "Kello"; },
        "006": function(d) { return "Koru"; }
      },
      vehicleType: {
        "001": function(d) { return "Henkilöauto"; },
        "002": function(d) { return "Pakettiauto"; },
        "003": function(d) { return "Moottoripyörä"; },
        "004": function(d) { return "Mopo tai mopoauto"; },
        "005": function(d) { return "Moottorikelkka"; },
        "006": function(d) { return "Perävaunu"; },
        "007": function(d) { return "Matkailuvaunu"; },
        "008": function(d) { return "Matkailuauto"; },
        "009": function(d) { return "Kuorma-auto"; },
        "010": function(d) { return "Traktori"; },
        "011": function(d) { return "Mönkijä"; },
        "012": function(d) { return "Museoajoneuvo"; },
        "013": function(d) { return "Sähköinen liikkumisväline"; },
        "014": function(d) { return "Muu ajoneuvo"; }
      },
      vehicleMileage: {
        "001": function(d) { return "Enintään 5 000 km"; },
        "002": function(d) { return "Enintään 10 000 km"; },
        "003": function(d) { return "Enintään 15 000 km"; },
        "004": function(d) { return "Enintään 20 000 km"; },
        "005": function(d) { return "Enintään 25 000 km"; },
        "006": function(d) { return "Enintään 30 000 km"; },
        "007": function(d) { return "Enintään 40 000 km"; },
        "008": function(d) { return "Yli 40 000 km"; },
        "009": function(d) { return "Ei tiedossa"; }
      },
      heatingSystem: {
        "001": function(d) { return "Vesikiertoinen lämmönjako"; },
        "002": function(d) { return "Muu kuin vesikiertoinen lämmönjako"; },
        "003": function(d) { return "Ei tiedossa"; }
      },
      electricity: {
        "001": function(d) { return "Kytketty sähköverkkoon"; },
        "002": function(d) { return "Oma sähköntuotanto"; },
        "003": function(d) { return "Ei sähköistetty"; }
      }
    },
    validInput: {
      modified: function(d) { return "Muokattu"; },
      modifiedAria: function(d) { return "Olet muokannut syöttökenttää"; },
      notValid: function(d) { return "Tarkista kenttä"; }
    },
    url: {
      direct: function(d) { return "suora"; },
      preSelect: function(d) { return "esivalinta"; },
      baseName: function(d) { return "/henkiloasiakkaat/vakuutukset/tarjouspyynto"; },
      thankyoupage: function(d) { return "/kiitos"; }
    }
  },
  sv: {
    errorText: {
      servlet: {
        locale: {
          missing: function(d) { return "Locale missing"; }
        },
        token: {
          missing: function(d) { return "Token missing"; }
        },
        serializing: {
          error: function(d) { return "Serialization error"; }
        },
        mandatory: {
          info: {
            missing: function(d) { return "Mandatory info missing"; }
          }
        },
        additional: {
          info: {
            too: {
              long: function(d) { return "Additional info too long"; }
            }
          }
        },
        email: {
          sending: {
            failed: function(d) { return "Email sending failed"; }
          }
        }
      },
      checkSsn: function(d) { return "Kontrollera försäkringstagarens ID -nummer."; },
      length: function(d) { return "Kontrollera värdets längd."; },
      notNumber: function(d) { return "Kontrollera det angivna numret:"; },
      invalidDate: function(d) { return "Ogiltigt datum "; },
      invalidInput: function(d) { return "Kontrollera det angivna värdet."; },
      invalidHomeInput: function(d) { return "Kontrollera det angivna värdet."; },
      formContains: function(d) { return "Formulärets fel:"; },
      forestArea: function(d) { return "Kontrollera skogens areal."; },
      forestPropertCode: function(d) { return "Kontrollera skogens fastighetsbeteckning."; },
      valuableFirstYearOfService: function(d) { return "Kontrollera ibruktagningsåret."; },
      permittedCharacters: function(d) { return "Kontrollera stavningen."; },
      animalDateOfBirthDog: function(d) { return "Kontrollera födelsedatumet. Den försäkrade hunden ska vara under 7 år gammal och födelsedatumet kan endast vara innevarande eller följande år."; },
      animalDateOfBirthCat: function(d) { return "Kontrollera födelsedatumet. Den försäkrade katten ska vara under 7 år gammal och födelsedatumet kan endast vara innevarande eller följande år."; },
      animalDateOfBirthHorse: function(d) { return "Kontrollera födelsedatumet. Den försäkrade hästen ska vara under 22 år gammal och födelsedatumet kan endast vara innevarande eller följande år."; },
      animalValue: function(d) { return "Kontrollera penningvärdet."; },
      personBirthDate: function(d) { return "Kontrollera det beräknade födelsedatumet. Det beräknade födelsedatumet kan inte vara i det förflutna."; },
      vehicleRegNum: function(d) { return "Kontrollera registreringsnumret."; },
      muuAjoneuvoVehicleRegNum: function(d) { return "Kontrollera registrerings- eller tillverkningsnumret."; },
      vehicleSsn: function(d) { return "Kontrollera försäkringstagarens personbeteckning."; },
      homeFloorArea: function(d) { return "Kontrollera lägenhetsytan."; },
      homeTotalFloorArea: function(d) { return "Kontrollera totalytan."; },
      homeYourOwnTotalFloorArea: function(d) { return "Kontrollera totalytan på din bostad."; },
      homeConstructionYear: function(d) { return "Kontrollera byggåret."; },
      boatMake: function(d) { return "Kontrollera märket."; },
      boatModel: function(d) { return "Kontrollera modellen."; },
      boatManufactureYear: function(d) { return "Kontrollera tillverkningsåret."; },
      boatEnginePower: function(d) { return "Kontrollera motorns effekt."; },
      engineProductionNumber: function(d) { return "Kontrollera tillverkningsnumret."; },
      engineYearOfManufacture: function(d) { return "Kontrollera tillverkningsår."; },
      technicalErrorTitle: function(d) { return "Störning i tjänsten, vi beklagar"; },
      checkValue: function(d) { return "Kontrollera värdet."; },
      required: function(d) { return "Obligatoriskt"; },
      noResponse: function(d) { return "Inget svar, försök igen om ett ögonblick."; },
      initError: function(d) { return "Applikationsinitialiseringen misslyckades."; },
      checkPersonalIdentityCode: function(d) { return "Kontrollera personbeteckningen."; },
      atLeastOne: function(d) { return "Välj minst ett objekt som ska försäkras."; },
      technicalErrorTextOpfi: function(d) { return "Vänligen försök igen eller kontakta stödet för kunder som köper försäkringar på nätet på 010 253 6139 (mån.?fre. kl. 8?18)."; },
      technicalErrorTextOpas: function(d) { return "Vänligen försök igen om ett ögonblick."; },
      technicalErrorSending: function(d) { return "Det går inte att skicka offertbegäran. Vänligen försök på nytt."; },
      sendingProposalFailed: function(d) { return "Det gick inte att skicka offertbegäran. Vänligen försök på nytt om ett ögonblick."; }
    },
    error: {
      fill: {
        "in": {
          missing: {
            information: function(d) { return "Fyll i den obligatoriska uppgift som saknas."; }
          }
        }
      },
      contact: {
        info: {
          first: {
            name: function(d) { return "Ange förnamn."; }
          },
          last: {
            name: function(d) { return "Ange efternamn"; }
          },
          security: {
            number: function(d) { return "Ange personbeteckning."; }
          },
          address: function(d) { return "Ange adress."; },
          postcode: function(d) { return "Ange e-postadress."; },
          postal: {
            district: function(d) { return "Ange postkontor."; }
          },
          phone: {
            number: function(d) { return "Ange telefonnummer."; }
          },
          email: function(d) { return "Ange e-postadress."; }
        }
      },
      check: {
        address: function(d) { return "Kontrollera adressen."; },
        email: function(d) { return "Kontrollera e-postadressen."; },
        first: {
          name: function(d) { return "Kontrollera förnamnet."; }
        },
        last: {
          name: function(d) { return "Kontrollera efternamnet."; }
        },
        phone: {
          number: function(d) { return "Kontrollera telefonnumret."; }
        },
        postal: {
          district: function(d) { return "Kontrollera postkontoret"; }
        },
        post: {
          code: function(d) { return "Kontrollera postnumret."; }
        },
        security: {
          number: function(d) { return "Kontrollera personbeteckningen.  "; }
        }
      },
      invalidCharacters: function(d) { return "Kontrollera stavningen."; },
      header: {
        text: function(d) { return "Tjänsten är för närvarande inte tillgänglig"; }
      },
      id: function(d) { return "Fel -ID"; },
      code: function(d) { return "Felkod"; }
    },
    placeHolderText: {
      ppkkvvvv: function(d) { return "dd.mm.åååå"; }
    },
    uiTitleText: {
      contactBasicDetails: function(d) { return "Egna uppgifter"; },
      contactExtraDetails: function(d) { return "Ytterligare information"; },
      insuraceQuestions: function(d) { return "Uppgifter om det objekt som ska försäkras"; }
    },
    uiText: {
      keepAliveModalTitle: function(d) { return "Sessionen avbröts"; },
      keepAliveModalBody: function(d) { return "Ett tekniskt fel inträffade i tjänsten."; },
      addInsurance: function(d) { return "Lägg till ett nytt objekt som ska försäkras"; },
      choose: function(d) { return "- Välj -"; },
      one: function(d) { return "1"; },
      two: function(d) { return "2"; },
      three: function(d) { return "3"; },
      insuranceSelectionheader: function(d) { return "Välj de objekt som ska försäkras"; },
      animal: function(d) { return "Djur"; },
      boat: function(d) { return "Båt"; },
      contactNeedContactInfo: function(d) { return "Fyll i dina kontaktuppgifter."; },
      forest: function(d) { return "Skog"; },
      home: function(d) { return "Hem"; },
      infoboxTile: function(d) { return "Vill du ta bort det här objektet från offertbegäran? De angivna uppgifterna kommer också att raderas."; },
      infoboxTileActive: function(d) { return "Vill du ta bort de här objekten från anbudsförfrågan? De angivna uppgifterna kommer också att raderas."; },
      person: function(d) { return "Person"; },
      travel: function(d) { return "Resa"; },
      valuable: function(d) { return "Värdeföremål"; },
      vehicle: function(d) { return "Fordon"; },
      deleteInsuranceQuestions: function(d) { return "Ta bort mål"; },
      questionsInfoBox: function(d) { return "Vill du ta bort objektet och de uppgifter som angetts i det?"; },
      all: function(d) { return "Allt"; },
      almost: {
        ready: function(d) { return "Nästan klart! Du behöver bara fylla i dina uppgifter så gör vi dig en personlig offert."; }
      },
      close: function(d) { return "Stäng"; },
      contactAdditionalInfo: function(d) { return "Ange ytterligare uppgifter vid behov."; },
      additionalInfoMessage: function(d) { return "Ange inte personuppgifter, såsom personbeteckningar eller hälsouppgifter, här."; },
      creditInformation: function(d) { return "Innan vi gör en offert kontrollerar vi dina kunduppgifter i Pohjola Försäkrings kundregister. Vi kontrollerar vid behov dina kreditupplysningar från Suomen Asiakastieto Oy och dina personuppgifter från Myndigheten för digitalisering och befolkningsdata. Mer information om behandlingen av personuppgifter finns i dataskyddsbeskrivningen för Pohjola Försäkring Ab:s och OP-Livförsäkrings Ab:s kundregister."; },
      enlarge: function(d) { return "Förstora"; },
      filter: function(d) { return "Filtrera"; },
      hideAdditionalErrorDetails: function(d) { return "Dölj ytterligare information om felet"; },
      lifeInsuranceIssuanceMsg: function(d) { return "Livförsäkringen beviljas av försäkringsbolaget OP-Livförsäkrings Ab, och Pohjola Försäkring Ab är ombud för bolaget. Övriga försäkringar för fordon, hem, egendom och hälsa beviljas av försäkringsbolaget Pohjola Försäkring Ab."; },
      noResults: function(d) { return "Inga träffar"; },
      open: function(d) { return "Öppna"; },
      responsiveTable: {
        checkDate: function(d) { return "Kontrollera datumet"; }
      },
      toApplicationStartPage: function(d) { return "Till applikationens första sida"; },
      toInsuranceFrontPage: function(d) { return "Till första sidan för försäkringar"; },
      returnToAuthenticatedFrontPage: function(d) { return "Återgå till nättjänsten."; },
      linkInterruptionTitle: function(d) { return "Att lämna applikationen"; },
      linkInterruptionBodyText: function(d) { return "Du håller på att lämna applikationen. Osparade uppgifter går förlorade."; },
      pieces: function(d) { return "st."; },
      startEditing: function(d) { return "Redigera"; },
      view: function(d) { return "Visa"; },
      showAdditionalErrorDetails: function(d) { return "Visa ytterligare information om felet"; },
      shrink: function(d) { return "Minska"; },
      returnToReportSearch: function(d) { return "Återgå till varningssökningen."; },
      oneTargetSelected: function(d) { return "objekt är valt"; },
      targetsSelected: function(d) { return "objekt är valt"; },
      thankYou: function(d) { return "Tack!"; },
      engineData: function(d) { return "Uppgifter om motorn"; },
      doesnNotRequireMotorLiabilityInsuranceElectricBike: function(d) { return "Utgående från de uppgifter som du har angett behöver din elcykel ingen separat trafikförsäkring."; },
      doesnNotRequireMotorLiabilityInsuranceElectricVehicle: function(d) { return "Utgående från de uppgifter som du har angett behöver ditt lätta elfordon ingen separat trafikförsäkring."; }
    },
    email: {
      sending: {
        failed: function(d) { return "Fyll i den uppgift som saknas."; }
      }
    },
    buttonText: {
      "continue": function(d) { return "Fortsätt"; },
      send: function(d) { return "Sänd"; },
      yes: function(d) { return "Ja"; },
      no: function(d) { return "Nej"; },
      previousButton: function(d) { return "Föregående"; },
      closeButton: function(d) { return "Stäng"; },
      okButton: function(d) { return "Ok"; },
      reStart: function(d) { return "Börja om"; },
      cancelQuit: function(d) { return "Avbryt"; },
      cancel: function(d) { return "Ångra"; },
      pdfButton: function(d) { return "Skriv ut PDF"; },
      confirm: function(d) { return "Bekräfta"; },
      ready: function(d) { return "Färdig"; },
      closeTab: function(d) { return "Stäng fliken"; },
      save: function(d) { return "Spara"; },
      showMore: function(d) { return "Visa mer"; },
      showLess: function(d) { return "Visa mindre"; },
      acceptButton: function(d) { return "Acceptera"; },
      declineButton: function(d) { return "Avvisa"; },
      search: function(d) { return "Sök"; },
      replace: function(d) { return "Rätta"; },
      back: function(d) { return "Tillbaka"; },
      "delete": function(d) { return "Radera"; },
      clear: function(d) { return "Töm"; }
    },
    unitText: {
      kw: function(d) { return "kW"; },
      cm3: function(d) { return "cm³"; },
      kg: function(d) { return "kg"; },
      euro: function(d) { return "€"; },
      horsePower: function(d) { return "hk"; },
      hectare: function(d) { return "ha"; },
      squareMetre: function(d) { return "m²"; },
      euros: function(d) { return "euro"; }
    },
    labelText: {
      bannerTextForFixedTermTravelInsurance: function(d) { return "Du kan teckna en tidsbestämd reseförsäkring endast i tjänsten op.fi eller i OP-mobilen."; },
      fixedTermLinkUrl: function(d) { return "/sv/privatkunder/forsakringar/personforsakring/reseforsakring"; },
      fixedTemLinkText: function(d) { return "Gå till att teckna en tidsbestämd reseförsäkring"; },
      boatUsedInCompetitionsOrRaces: function(d) { return "Är båten i tävlingsbruk?"; },
      boatFinanceCompany: function(d) { return "Finansbolag?"; },
      ownedByFinanceCompany: function(d) { return "Ägs båten av ett finansbolag?"; },
      registrationNumber: function(d) { return "Registreringsnummer"; },
      manufacturingMethod: function(d) { return "Tillverkningssätt"; },
      highRiskSports: function(d) { return "Utövar du specialidrottsgrenar eller riskfyllda idrottsgrenar?"; },
      highRiskSportsMe: function(d) { return "Utövar du specialidrottsgrenar eller riskfyllda idrottsgrenar?"; },
      whichHighRiskSports: function(d) { return "Ange vilken idrottsgren eller vilka idrottsgrenar det är fråga om."; },
      forestNameOfTheForestEstateAndLocality: function(d) { return "Skogslägenhetens och byns namn"; },
      animalUELN: function(d) { return "Hästens UELN-nummer"; },
      animalPurposeOfHorse: function(d) { return "Vad ska hästen användas till?"; },
      AddNewInsurance: function(d) { return "Välj det föremål som ska försäkras"; },
      BasicDetailsAddress: function(d) { return "Adress"; },
      BasicDetailsPostCode: function(d) { return "Postnummer"; },
      BasicDetailsPost: function(d) { return "Postkontor"; },
      BasicDetailsPhoneNumber: function(d) { return "Telefonnummer"; },
      BasicDetailsEmail: function(d) { return "E-post"; },
      BasicDetailsKela: function(d) { return "Do you have a KELA card?"; },
      BasicDetailsPermanentResidenceInFinland: function(d) { return "Do you have permanent residence in Finland?"; },
      BasicDetailsNationality: function(d) { return "Nationality"; },
      bannerTextForTotalOffer: function(d) { return "Om du vill begära en offert på fordonsförsäkringar även för din make eller ditt familjemedlem, kan du ringa vår kundtjänst tillsammans med hen. Vi behöver hens samtycke för att göra en offert."; },
      aspaLinkText: function(d) { return "Kontakta vår kundtjänst"; },
      aspaLinkUrl: function(d) { return "/sv/privatkunder/kundtjanst/kontaktinformation/stod-vid-kop-pa-natet"; },
      noElectricMotorAssistanceOver25Kph: function(d) { return "Kopplas cykelns elmotor av när cykeln når en hastighet på 25 km/h?"; },
      motorPowerOver250W: function(d) { return "Är motoreffekten över 250 W?"; },
      weighMoreThan25Kg: function(d) { return "Väger cykeln över 25 kg?"; },
      scooterWeighMoreThan25Kg: function(d) { return "Väger elfordonet över 25 kg?"; },
      topSpeedOver25Kph: function(d) { return "Är elfordonets topphastighet över 25 km/h?"; },
      BonusAuthorisedQuestionOtherPerson: function(d) { return "Har försäkringstagaren gett sitt samtycke till att hens försäkrings- och skadehistorik kan kontrolleras för beräkning av bonus?"; },
      DamageCoverage: function(d) { return "Vill du att försäkringen täcker skador på fordonet till följd av kollision eller krock?"; },
      vvhConsent: function(d) { return "Jag ger mitt samtycke till beräkning av bonus i trafikförsäkringen utifrån min försäkrings- och skadehistorik."; },
      ExtraDetailsAdditionalInfo: function(d) { return "Ange ytterligare uppgifter vid behov (frivillig)."; },
      FirstYearOfService: function(d) { return "Ibruktagningsår"; },
      electricPersonalTransportationDeviceFirstYearOfService: function(d) { return "Ibruktagningsår"; },
      Health: function(d) { return "Hälsoförsäkring"; },
      HealthCoverage: function(d) { return "Hälsoförsäkringens omfattning"; },
      Life: function(d) { return "OP Livförsäkring"; },
      LifeAria: function(d) { return "Mer information: OP Livförsäkring"; },
      LifeAdditionalInsurances: function(d) { return "Tilläggsförsäkringar till livförsäkringen (frivilliga)"; },
      LifeAdditionalInsurancesAria: function(d) { return "Mer information: Tilläggsförsäkringar till livförsäkringen "; },
      AdditionalLifeInsurancesSeriousIllness: function(d) { return "Försäkring vid allvarlig sjukdom"; },
      AdditionalLifeInsurancesSeriousIllnessAria: function(d) { return "Mer information: Försäkring vid allvarlig sjukdom"; },
      AdditionalLifeInsurancesTemporaryDisability: function(d) { return "Försäkring för övergående arbetsoförmåga"; },
      AdditionalLifeInsurancesTemporaryDisabilityAria: function(d) { return "Mer information: Försäkring för övergående arbetsoförmåga"; },
      AdditionalLifeInsurancesPermanentDisability: function(d) { return "Försäkring för bestående arbetsoförmåga"; },
      AdditionalLifeInsurancesPermanentDisabilitAria: function(d) { return "Mer information: Försäkring för bestående arbetsoförmåga"; },
      PolicyToOwnName: function(d) { return "Tecknar du försäkringen i eget namn?"; },
      PolicyholderSSN: function(d) { return "Försäkringstagarens personbeteckning"; },
      RegisteredOtherVehicle: function(d) { return "är fordonet registrerat?"; },
      RegistrationNumber: function(d) { return "Registreringsnummer"; },
      MuuAjoneuvoRegistrationNumber: function(d) { return "Registrerings- eller tillverkningsnummer"; },
      boatType: function(d) { return "Båt som ska försäkras"; },
      motorBoatType: function(d) { return "Båttyp"; },
      engineBrand: function(d) { return "Motorns märke"; },
      engineProductionNumber: function(d) { return "Tillverkningsnummer"; },
      engineYearOfManufacture: function(d) { return "Tillverkningsår"; },
      enginePower: function(d) { return "Motorns effekt"; },
      electricPersonalTransportationDevicEnginePower: function(d) { return "Effekt (W)"; },
      boatValue: function(d) { return "Båtens och utrustningens värde"; },
      boatMunicipality: function(d) { return "Kommun där båten används"; },
      boatEngine: function(d) { return "Har segelbåten en motor?"; },
      bonuses: function(d) { return "Vill du att bonusen från ett annat försäkringsbolag beaktas i premien?"; },
      "breed-horse": function(d) { return "Rasgrupp"; },
      breed: function(d) { return "Ras"; },
      calculatedDueDate: function(d) { return "Det beräknade födelsedatumet"; },
      competitiveSports: function(d) { return "Tävlingsidrottar hen?"; },
      competitiveSportsMe: function(d) { return "Tävlingsidrottar du?"; },
      highRiskSportsMeSecond: function(d) { return "Specialidrottsgrenar och riskfyllda grenar"; },
      competitiveSportsModalHeader: function(d) { return "Specialidrottsgrenar och riskfyllda grenar"; },
      competitiveSportsModalItemAdditionalCover: function(d) { return "Idrottsgrenar som kräver tilläggsskydd"; },
      competitiveSportsModalTitleAviationSports: function(d) { return "Flygsportsgrenar, såsom"; },
      competitiveSportsModalItemHotAirBalloonAndGasbagFlight: function(d) { return "flygning med varmluftsballong och gasballong"; },
      competitiveSportsModalItemMotorisedFlying: function(d) { return "motorflygning"; },
      competitiveSportsModalItemHangGlidingAndParagliding: function(d) { return "häng- och skärmflygning"; },
      competitiveSportsModalItemMicroLightFlying: function(d) { return "flygning med ultralätt flygplan"; },
      competitiveSportsModalItemSkydiving: function(d) { return "fallskärmshoppning"; },
      competitiveSportsModalItemIndoorSkydiving: function(d) { return "vindtunnelflygning"; },
      competitiveSportsModalItemFlyingWithAmateurBuiltAircraft: function(d) { return "flygning med självbyggt flygplan"; },
      competitiveSportsModalItemGlidingAndMotorsailing: function(d) { return "segelflygning och motorsegelflygning"; },
      competitiveSportsModalItemParasailing: function(d) { return "flygning med dragskärm"; },
      competitiveSportsModalTitleTeamSports: function(d) { return "Lagsporter, inklusive"; },
      competitiveSportsModalItemAmericanFootball: function(d) { return "amerikansk fotboll"; },
      competitiveSportsModalItemAustralianFootball: function(d) { return "australisk fotboll"; },
      competitiveSportsModalItemRugby: function(d) { return "rugby"; },
      competitiveSportsModalItemlLacrosse: function(d) { return "lacrosse"; },
      competitiveSportsModalItemRollerDerby: function(d) { return "roller derby"; },
      competitiveSportsModalTitleCombatSports: function(d) { return "Kamp-, självförsvars- eller stridsgrenar inklusive"; },
      competitiveSportsModalItemMixedMartialArts: function(d) { return "frikamp"; },
      competitiveSportsModalItemWrestling: function(d) { return "wrestling"; },
      competitiveSportsModalTitleClimbingSports: function(d) { return "Klättringsgrenar, inklusive"; },
      competitiveSportsModalItemIceAndRockClimbing: function(d) { return "is- och klippklättring"; },
      competitiveSportsModalItemGlacierAndMountainClimbing: function(d) { return "glaciär- och bergsklättring"; },
      competitiveSportsModalTitleDivingSports: function(d) { return "Dykningsgrenar, inklusive"; },
      competitiveSportsModalItemScubaDiving: function(d) { return "dykning med utrustning"; },
      competitiveSportsModalItemFreediving: function(d) { return "fridykning"; },
      competitiveSportsModalTitleWinterSports: function(d) { return "Vintersportgrenar, inklusive"; },
      competitiveSportsModalItemSledding: function(d) { return "kälkåkning"; },
      competitiveSportsModalItemFreestyleSkiing: function(d) { return "freestyleskidåkning"; },
      competitiveSportsModalItemSpeedAndDownhillSkiing: function(d) { return "speedskiing eller störtlopp"; },
      competitiveSportsModalItemOffPisteSkiing: function(d) { return "offpiståkning"; },
      competitiveSportsModalItemDownhillSkating: function(d) { return "utförsåkning på skridskor"; },
      competitiveSportsModalTitleStrengthSports: function(d) { return "Kraftsporter, inklusive"; },
      competitiveSportsModalItemStrengthAthletics: function(d) { return "styrkemansgrenar"; },
      competitiveSportsModalItemPowerlifting: function(d) { return "styrkelyft"; },
      competitiveSportsModalItemWeightlifting: function(d) { return "tyngdlyftning"; },
      competitiveSportsModalItemBodybuilding: function(d) { return "bodybuilding"; },
      competitiveSportsModalTitleOtherSeparatelyInsuredSports: function(d) { return "Andra grenar som ska försäkras separat"; },
      competitiveSportsModalItemBmxCycling: function(d) { return "BMX-cykling"; },
      competitiveSportsModalItemBungeeJumping: function(d) { return "bungyhopp"; },
      competitiveSportsModalItemSkimbatOrKiteSurfing: function(d) { return "ving- och draksegling"; },
      competitiveSportsModalItemSailboardingAndFlyboarding: function(d) { return "flygsegling eller flygsurfing"; },
      competitiveSportsModalItemParkour: function(d) { return "parkour"; },
      competitiveSportsModalItemAbseiling: function(d) { return "nedstigning med rep"; },
      competitiveSportsModalItemAcrobatics: function(d) { return "akrobatik"; },
      competitiveSportsModalItemFreeRunning: function(d) { return "free running"; },
      competitiveSportsModalItemDownhillBiking: function(d) { return "utförsåkning med cykel"; },
      competitiveSportsModalItemOceanSailing: function(d) { return "oceansegling"; },
      competitiveSportsModalItemBaseJumping: function(d) { return "BASE-hopp"; },
      competitiveSportsModalItemTrekking: function(d) { return "vandringar i obebyggda trakter, såsom vandringar och forskningsresor utomlands i berg, djungel, öken, ödemark eller andra motsvarande trakter"; },
      competitiveSportsModalItemWildwaterCanoeing: function(d) { return "forsränning"; },
      competitiveSportsModalTitleOtherSportsOfComparableLevelOfRisk: function(d) { return "Andra riskfyllda idrottsgrenar på motsvarande risknivå"; },
      constructionYear: function(d) { return "Byggår"; },
      damageCover: function(d) { return "Vill du att försäkringen täcker till exempel skador till följd av grundstötning eller kollision?"; },
      FullName: function(d) { return "Namn"; },
      FirstName: function(d) { return "Förnamn"; },
      floorArea: function(d) { return "Lägenhetsyta"; },
      forestArea: function(d) { return "Skogens areal (ha)"; },
      forestPropertCode: function(d) { return "Skogens fastighetsbeteckning"; },
      forestGrowthStage: function(d) { return "Skogens tillväxtskede"; },
      forestIndemnity: function(d) { return "Ersättningarnas omfattning"; },
      forestMunicipality: function(d) { return "Kommun där skogen finns"; },
      frameMaterial: function(d) { return "Skrovets material"; },
      homeType: function(d) { return "Hem eller byggnad som ska försäkras"; },
      housingCompany: function(d) { return "Är det fråga om ett bostadsaktiebolag?"; },
      inspectionClass: function(d) { return "Besiktningsklass eller konditionskartläggning"; },
      insuranceCompany: function(d) { return "Från vilket försäkringsbolag vill du överföra bonus?"; },
      insuranceIncludesMe: function(d) { return "Försäkrat resgods"; },
      insuranceScope: function(d) { return "försäkringens omfattning"; },
      "insured-animal": function(d) { return "Djur som ska försäkras"; },
      insuredItem: function(d) { return "Objekt som ska försäkras"; },
      LastName: function(d) { return "Efternamn"; },
      longTrip: function(d) { return "Den längsta resan"; },
      luggageInsuranceFamily: function(d) { return "Vill du försäkra din familjs resgods?"; },
      luggageInsuranceMe: function(d) { return "Försäkrar du resgodset?"; },
      manufactureYear: function(d) { return "Tillverkningsår"; },
      model: function(d) { return "Modell"; },
      electricPersonalTransportationDeviceModel: function(d) { return "Modell"; },
      make: function(d) { return "Märke"; },
      electricPersonalTransportationDeviceMake: function(d) { return "Märke"; },
      "monetary-value-horse": function(d) { return "Hästens penningvärde"; },
      "monetary-value-pedigree-cat": function(d) { return "Kattens penningvärde"; },
      person: function(d) { return "Person som ska försäkras"; },
      pipeRenewalYear: function(d) { return "Installations- eller förnyelseår för tappvattenledningen"; },
      pipeSystem: function(d) { return "Har byggnaden tappvattenledning?"; },
      postcode: function(d) { return "Postnumret till det objekt som ska försäkras"; },
      primaryEngines: function(d) { return "Antal huvudmotorer"; },
      purposeOfUse: function(d) { return "Syfte"; },
      SecurityId: function(d) { return "Personbeteckning"; },
      "time-of-birth": function(d) { return "Födelsedatum"; },
      totalFloorArea: function(d) { return "Totalyta"; },
      "totalFloorAreaOwnHomeSemi-detached": function(d) { return "Totalytan på din bostad."; },
      transferrableBonus: function(d) { return "Bonus som ska överföras"; },
      valuableType: function(d) { return "Värdeföremål som ska försäkras"; },
      valueCamera: function(d) { return "Kamerans och utrustningens värde"; },
      valueInstrument: function(d) { return "Musikinstrumentets värde"; },
      valueJewellery: function(d) { return "Smyckets värde"; },
      valueLens: function(d) { return "Objektivets värde"; },
      valueWatch: function(d) { return "Klockans värde"; },
      valueWeapon: function(d) { return "Vapnets värde"; },
      vehicleType: function(d) { return "Fordon som ska försäkras"; },
      vehicleValue: function(d) { return "Fordonets värde"; },
      vehicleMileage: function(d) { return "Uppskatta hur många kilometer man kör med bil per år."; },
      whichSports: function(d) { return "Ange vilken idrottsgren eller vilka idrottsgrenar det är fråga om."; },
      PolicyToOwnNameCarText: function(d) { return "Vi kontrollerar din försäkrings- och skadehistorik så att vi kan beräkna din personliga bonus och bästa möjliga pris för dig."; },
      museumVehicleType: function(d) { return "Vilket fordon är det fråga om?"; },
      electricPersonalTransportationDeviceVehicleType: function(d) { return "Typ av förflyttningshjälpmedel"; },
      HomeAddress: function(d) { return "Adressen till det objekt som ska försäkras"; },
      AnimalGender: function(d) { return "Kön"; },
      insuranceIncludesPackages: function(d) { return "Försäkrat resgods"; },
      "monetary-value-dog": function(d) { return "Hundens penningvärde"; },
      AnimalName: function(d) { return "Tilltalsnamn"; },
      personUnbornMotherChild: function(d) { return "Är du det ofödda barnets mor?"; },
      mothersIdentificationNumber: function(d) { return "Moderns personbeteckning"; },
      waterPipeSystem: function(d) { return "Har byggnaden tappvattenledning?"; },
      heatingSystem: function(d) { return "Har byggnaden värme?"; },
      electricityType: function(d) { return "Har byggnaden elektricitet?"; },
      YearOfWaterPipeSystem: function(d) { return "Installations- eller förnyelseår för tappvattenledningen"; },
      YearOfHeatingSystem: function(d) { return "Installations- eller förnyelseår för värmeledningen"; },
      ContactInfo: function(d) { return "Kontaktuppgifter"; },
      electricPersonalTransportationDeviceSerialNumber: function(d) { return "Tillverknings- eller ramnummer"; },
      electricPersonalTransportationDeviceMaximumDesignSpeed: function(d) { return "Konstruktiv maximal hastighet (km/h)"; },
      electricPersonalTransportationDeviceTotalWeight: function(d) { return "Totalvikt (kg)"; },
      electricPersonalTransportationDeviceValue: function(d) { return "Förflyttningshjälpmedlets värde"; },
      electricPersonalTransportationDeviceAgeUnder24: function(d) { return "Är personen som använder fordonet under 24 år?"; },
      electricPersonalTransportationDeviceCollisionCrashCoverage: function(d) { return "Vill du att försäkringen täcker skador på förflyttningshjälpmedlet till följd av kollision eller krock?"; },
      tractorInPrivateUse: function(d) { return "Är traktorn i privat bruk?"; },
      monthlyRent: function(d) { return "Månadshyra"; },
      deviceNumber: function(d) { return "Enhetsnummer"; },
      serialNumber: function(d) { return "Serienummer"; },
      whichJewellery: function(d) { return "Vilket smycke?"; }
    },
    hintText: {
      boatUsedInCompetitionsOrRaces: function(d) { return "Observera att försäkringen inte gäller under tävlingar."; },
      registrationNumber: function(d) { return "Du hittar registreringsnumret i registreringsintyget."; },
      animalUELN: function(d) { return "UELN-numret är hästens identifikationsnummer som kan bestå av bokstäver och siffror."; },
      tractorInPrivateUse: function(d) { return "Med traktor i privat bruk avses en traktor som inte används för företagets lantbruk eller produktion. Den används till exempel för att ploga den egna gårdsplanen, för att transportera egen ved eller för annat eget bruk."; },
      electricPersonalTransportationDeviceValue: function(d) { return "Ge en uppskattning av förflyttningshjälpmedlets värde i euro."; },
      electricPersonalTransportationDeviceTotalWeight: function(d) { return "Till exempel anteckna cykelns totalvikt med batteri."; },
      bannerTextForTotalOffer: function(d) { return "Totalytan är summan av ytorna beräknade enligt yttermåtten för alla våningsplan i bostaden, med beaktande av utrymmen som är minst 160 cm höga. Du kan kontrollera totalytan till exempel i byggnadsritningarna."; },
      BonusAuthorisedQuestionOtherPerson: function(d) { return "Om du svarar ja intygar du att du fått tillstånd av försäkringstagaren att kontrollera hens försäkrings- och skadehistorik. Vi kontrollerar med hjälp av personbeteckningen historiken i försäkringsbolagens gemensamma uppgifter om försäkrings- och skadehistorik och använder uppgifterna för att beräkna  en personlig bonus i trafikförsäkringen."; },
      DamageCoverage: function(d) { return "Omfattningen på ersättningarna beror på försäkringen, och därför kan vi utifrån valet erbjuda en kaskoförsäkring med lämplig omfattning för fordonet. Trafikförsäkringen ersätter endast skador som förorsakats motparten till följd av kollision eller krock, medan kaskoförsäkringen också ersätter skador på ditt fordon."; },
      vvhConsent: function(d) { return "Vi fastställer din personliga bonus i trafikförsäkringen utifrån din försäkrings- och skadehistorik. Vi kontrollerar din historik med din personbeteckning i försäkringsbolagens gemensamma uppgifter om försäkrings- och skadehistorik."; },
      vehicleValue: function(d) { return "Ge en uppskattning av fordonets värde i euro. Vi rekommenderar en lämplig  kaskoförsäkring för ditt fordon utifrån värdet. Exempelvis Lättkasko ersätter skador upp till 15 000 euro."; },
      vehicleMileage: function(d) { return "Uppskatta det maximala antalet körkilometer per år för den bil som ska försäkras. Om det sker förändringar i antalet körkilometer, kan du meddela detta i nättjänsten. Du kan alltid köra utan bekymmer eftersom antalet körkilometer påverkar försäkringspremien, men inte försäkringens innehåll."; },
      FirstYearOfService: function(d) { return "Med ibruktagningsår avses den tidpunkt då värdeföremålet har tillverkats eller använts första gången."; },
      Health: function(d) { return "Hälsoförsäkring är en personförsäkring från vilken det är möjligt att ersätta vårdkostnader för sjukdomar och olycksfall eller enbart för olycksfall enligt den omfattning som du valt."; },
      HealthCoverageTitle: function(d) { return "Välj vad du vill att försäkringen omfattar:"; },
      HealthCoverageFirst: function(d) { return "Olycksfall och sjukdom: Det mest omfattande alternativet ger det bästa skyddet vid sjukdomar och olycksfall. Det ersätter till exempel behandling av såväl förkylning som cancer, läkarbesök och läkemedel."; },
      HealthCoverageSecond: function(d) { return "Heltäckande olycksfall: Ger ett heltäckande skydd vid olycksfall och vid sjukdomar som specificeras i villkoren och ofta uppvisar symptom i anslutning till olycksfall."; },
      HealthCoverageThird: function(d) { return "Olycksfall: Ersätter behandling av och läkemedel för skador som förorsakas av olycksfall. Ersätter inte sjukdomar som en mer omfattande försäkring skulle ersätta."; },
      Life: function(d) { return "Ersättning från livförsäkringen betalas till förmånstagaren. Du kan själv utse förmånstagaren."; },
      LifeSecond: function(d) { return "Ersättningen från OP Livförsäkring hjälper dina närstående om du avlider under försäkringens giltighetstid. Du kan komplettera din OP Livförsäkring med försäkring vid allvarlig sjukdom och försäkringar för arbetsoförmåga. Du kan begära en offert på alla försäkringar samtidigt."; },
      LifeAdditionalInsurances: function(d) { return "Ersättningen från tilläggsförsäkringarna betalas ut till dig som en engångsersättning eller månatligen."; },
      AdditionalLifeInsurancesSeriousIllness: function(d) { return "Vi betalar en avtalad engångsersättning, om du diagnostiseras med en allvarlig sjukdom som anges i försäkringsvillkoren eller genomgår ett ingrepp som anges i villkoren."; },
      AdditionalLifeInsurancesTemporaryDisability: function(d) { return "Från försäkringen för övergående arbetsoförmåga kan du få ersättning per dag, om du inte kan utföra ditt arbete på grund av en sjukdom eller en skada och du blir sjukskriven."; },
      AdditionalLifeInsurancesPermanentDisability: function(d) { return "Från försäkringen för bestående arbetsoförmåga kan du få en engångsersättning, om du under försäkringens giltighetstid har förlorat din arbetsförmåga permanent på grund av en skada eller en sjukdom."; },
      PolicyToOwnName: function(d) { return "Försäkringstagaren kan utöver dig vara fordonets andra ägare eller innehavare. Lägg till en annan ägare eller innehavare som försäkringstagare om den nya försäkringen tecknas för hen eller om den befintliga försäkringen gäller denna person."; },
      boatValue: function(d) { return "Ange det penningvärde som din båt jämte motorer och utrustning försäkras för. Värdet motsvarar maximiersättningen för utrustningen. Ange anskaffningspriset på ny motsvarande utrustning för en relativt ny båt . Om det är fråga om en äldre båt, ange som värde det aktuella återanskaffningsvärdet."; },
      boatMunicipality: function(d) { return "Ange som kommun där båten används den kommun där din båt i huvudsak används."; },
      bonuses: function(d) { return "Du kan överföra bonus som är i ditt namn till en ny försäkring från ett annat försäkringsbolag. Välj din bonus som ska överföras mellan 0 % – 70 %."; },
      competitiveSports: function(d) { return "Till tävlingsidrott hör tävlingar och matcher som arrangeras av ett idrottsförbund eller en idrottsförening, träningar enligt träningsprogrammet och resor som är omedelbart anknutna till dem, oavsett på vilken nivå tävlingsidrott utövas eller den försäkrades ålder."; },
      damageCover: function(d) { return "Omfattningen på ersättningarna beror på försäkringen, och därför kan vi utifrån valet välja en lämplig försäkring för båten. Båtskadeskyddet ersätter utöver skador som förorsakats vid båtliv dessutom till exempel stormskador eller skador på en båt som förvaras på land."; },
      forestPropertCode: function(d) { return "Om du äger flera skogslägenheter, försäkra varje skogslägenhet separat med respektive fastighetsbeteckning."; },
      forestArea: function(d) { return "Observera att skogens areal inte omfattar tvinmark eller impediment."; },
      forestGrowthStage: function(d) { return "Maximiersättningen för stormskador bildas enligt skogens tillväxtskede."; },
      forestIndemnity: function(d) { return "Ersättningarnas omfattning beror på de skydd som ingår i din försäkring. De skydd som ingår i försäkringen ersätter skador som drabbar trädbestånd, plantbestånd, virke, plantor som ska planteras och avverkningsrester."; },
      inspectionClass: function(d) { return "Du får rabatt på din försäkring om du låter besikta din båt eller låter göra en konditionskartläggning (Finnboat) årligen."; },
      insuranceIncludes: function(d) { return "Din personliga resgodsförsäkring omfattar ditt eget resgods och resgodset för familjemedlemmar som bor i samma hushåll med dig när ni reser tillsammans. Resgodsförsäkringen för hela familjen omfattar resgodset för samtliga familjemedlemmar som bor i samma hushåll trots att ni inte reser tillsammans."; },
      insuranceScope: function(d) { return "Välj vad du vill att försäkringen omfattar så att vi kan erbjuda dig en lämplig personförsäkring. Personförsäkringen kan ersätta både vårdkostnader för sjukdomar och olycksfall eller enbart vårdkostnader för olycksfall."; },
      longTrip: function(d) { return "Om en enskild resa varar över 45 dygn, ska detta beaktas i reseförsäkringen."; },
      luggageInsuranceFamily: function(d) { return "Du kan försäkra resgodset för samtliga familjemedlemmar som bor i samma hushåll med dig trots att ni inte reser tillsammans eller ni reser till olika resmål."; },
      model: function(d) { return "Ange modelluppgifterna för båten så exakt som möjligt  (till exempel 520 DC)."; },
      "monetary-value": function(d) { return "Djurets penningvärde består av den ersättning som betalas vid förlust av djuret. Penningvärdet består av anskaffningspriset på djuret eller till exempel ett tilläggsvärde som beror på tävlings-, utställnings- eller avelsbakgrund."; },
      pipeSystem: function(d) { return "Om byggnaden har tappvattenledning rinner vattnet till tappställen. Om en läckageskada inträffar inverkar ledningens ålder på den ersättning som betalas."; },
      totalFloorArea: function(d) { return "Totalytan är summan av ytorna beräknade enligt yttermåtten för alla våningsplan i bostaden, med beaktande av utrymmen som är minst 160 cm höga. Du kan kontrollera totalytan till exempel i byggnadsritningarna."; },
      value: function(d) { return "Ange det penningvärde för vilket ditt värdeföremål ska försäkras. Värdet motsvarar maximiersättningen för värdeföremålet, och därför är det bra att som värde ange anskaffningspriset på ett nytt motsvarande värdeföremål."; },
      BonusAuthorisedQuestionOtherPersonCarExtraText: function(d) { return "Vi ringer dig eftersom vi behöver försäkringstagarens samtycke för att granska hens försäkrings- och skadehistorik. På så sätt kan vi beräkna en personlig bonus samt bästa möjliga pris för försäkringstagaren."; },
      PolicyToOwnNameCarHint: function(d) { return "Vi beräknar din personliga bonus i trafikförsäkringen utifrån din försäkrings- och skadehistorik. Vi kontrollerar din historik med din personbeteckning i försäkringsbolagens gemensamma uppgifter om försäkrings- och skadehistorik."; },
      electricPersonalTransportationDeviceSerialNumber: function(d) { return "Vi behöver tillverknings- eller serienumret för att fordonet kan försäkras."; },
      extra: {
        information: function(d) { return "Om du vill kan du komplettera din offertbegäran med ytterligare uppgifter."; }
      },
      phoneNumberContactInfo: function(d) { return "Ange ditt telefonnummer utan mellanslag. Kom ihåg landskoden om du har ett utländskt abonnemang."; },
      mothersIdentificationNumber: function(d) { return "Med hjälp av moderns personbeteckning beräknar vi den exakta premien för försäkringen med rabatter. Vi får hennes adressuppgifter från Pohjola Försäkrings kundregister, kundregistren hos övriga företag i OP Gruppen eller befolkningsdatasystemet. Dessutom sänder vi en hälsodeklarationsblankett till henne. "; },
      heatingSystem: function(d) { return "Med vattenburet värmesystem avses att vattnet cirkulerar i värmeelement eller i golvvärmeledningar. Obs! Om det finns vattenburen värme ens i en del av huset (t.ex. i badrummet), välj vattenburet värmesystem."; },
      waterPipeSystem: function(d) { return "Med tappvattenledning avses ledningar som för vatten till tappställen (t.ex. kranar). Observera att ledningens ålder inverkar på ersättningen för läckageskador."; },
      electricityType: function(d) { return "Ansluten till elnätet betyder att elektriciteten levereras från det riksomfattande nätet. Egen elproduktion betyder att elektriciteten inte levereras från det riksomfattande nätet utan t.ex. från en solpanel eller ett aggregat. Ingen elektricitet betyder att byggnaden inte får elektricitet."; },
      YearOfWaterPipeSystem: function(d) { return "Om tappvattenledningen har förnyats endast delvis, ange då det år då den ursprungliga ledningen installerades."; },
      YearOfHeatingSystem: function(d) { return "Om värmeledningen har förnyats endast delvis, ange då det år då den ursprungliga ledningen installerades."; }
    },
    option: {
      true: function(d) { return "Ja"; },
      false: function(d) { return "Nej"; },
      yes: function(d) { return "Ja"; },
      no: function(d) { return "Nej"; },
      manufacturingMethod: {
        "001": function(d) { return "Fabriksbyggd"; },
        "002": function(d) { return "Självbyggd"; }
      },
      animalPurposeOfHorse: {
        "001": function(d) { return "Banhoppning eller fälttävlan"; },
        "002": function(d) { return "Hobbybruk"; },
        "003": function(d) { return "Dressyr"; },
        "004": function(d) { return "Travsport"; },
        "005": function(d) { return "Avel"; },
        "006": function(d) { return "Annat"; }
      },
      HealthCoverage: {
        "001": function(d) { return "Olycksfall och sjukdom"; },
        "002": function(d) { return "Heltäckande olycksfall"; },
        "003": function(d) { return "Olycksfall"; }
      },
      museumVehicleType: {
        "001": function(d) { return "Personbil"; },
        "002": function(d) { return "Paketbil"; },
        "003": function(d) { return "Motorcykel"; },
        "004": function(d) { return "Moped eller mopedbil"; },
        "005": function(d) { return "Snöskoter"; },
        "006": function(d) { return "Släpvagn"; },
        "007": function(d) { return "Husvagn"; },
        "008": function(d) { return "Husbil"; },
        "009": function(d) { return "Lastbil"; },
        "010": function(d) { return "Traktor"; },
        "011": function(d) { return "Fyrhjuling"; }
      },
      electricPersonalTransportationDeviceVehicleType: {
        "001": function(d) { return "Elcykel"; },
        "002": function(d) { return "Lätt elfordon"; }
      },
      boatType: {
        "001": function(d) { return "Motorbåt"; },
        "002": function(d) { return "Motorseglare"; },
        "003": function(d) { return "Segelbåt"; }
      },
      motorBoatType: {
        "001": function(d) { return "Båt med utombordare"; },
        "002": function(d) { return "Båt med inombordare"; },
        "003": function(d) { return "Båt med inu-drev"; }
      },
      "breed-horse": {
        "001": function(d) { return "Varmblod eller halvblod"; },
        "002": function(d) { return "Kallblod"; },
        "003": function(d) { return "Ponny"; }
      },
      "breed-pedigree-cat": {
        "001": function(d) { return "Abessinier"; },
        "002": function(d) { return "American curl"; },
        "003": function(d) { return "Balines"; },
        "004": function(d) { return "Bengal"; },
        "005": function(d) { return "Brittiskt"; },
        "006": function(d) { return "Burma"; },
        "007": function(d) { return "Burmilla"; },
        "008": function(d) { return "Chartreux"; },
        "009": function(d) { return "Colourpoint hybrid"; },
        "010": function(d) { return "Cornish rex"; },
        "011": function(d) { return "Cymric"; },
        "012": function(d) { return "Devon rex"; },
        "013": function(d) { return "Don sphynx"; },
        "014": function(d) { return "Egyptisk mau"; },
        "015": function(d) { return "Europé"; },
        "016": function(d) { return "Exotic"; },
        "017": function(d) { return "German rex"; },
        "018": function(d) { return "Helig birma"; },
        "019": function(d) { return "Japanese bobtail"; },
        "020": function(d) { return "Javanese"; },
        "021": function(d) { return "Korat"; },
        "022": function(d) { return "Kurilean bobtail"; },
        "023": function(d) { return "Maine coon"; },
        "024": function(d) { return "Manx"; },
        "025": function(d) { return "Neva masquerade"; },
        "026": function(d) { return "Norsk skogkatt"; },
        "027": function(d) { return "Ocicat"; },
        "028": function(d) { return "Oriental"; },
        "029": function(d) { return "Orientaliskt korthår"; },
        "030": function(d) { return "Orientaliskt långhår"; },
        "031": function(d) { return "Perser"; },
        "032": function(d) { return "Peterbald"; },
        "033": function(d) { return "Ragdoll"; },
        "034": function(d) { return "Russian blue"; },
        "035": function(d) { return "Scottish fold"; },
        "036": function(d) { return "Selkirk rex"; },
        "037": function(d) { return "Seychellois korthår"; },
        "038": function(d) { return "Seychellois långhår"; },
        "039": function(d) { return "Sphynx"; },
        "040": function(d) { return "Siames"; },
        "041": function(d) { return "Singapura"; },
        "042": function(d) { return "Sibirisk katt"; },
        "043": function(d) { return "Snowshoe"; },
        "044": function(d) { return "Sokoke"; },
        "045": function(d) { return "Somali"; },
        "046": function(d) { return "Thai"; },
        "047": function(d) { return "Turkisk"; },
        "048": function(d) { return "Turkisk angora"; },
        "049": function(d) { return "Turkisk van"; },
        "050": function(d) { return "Rasen okänd"; }
      },
      "breed-pedigree-dog": {
        "100": function(d) { return "Dogue de bordeaux"; },
        "101": function(d) { return "Drever"; },
        "102": function(d) { return "Dunkerstövare"; },
        "103": function(d) { return "Dvärgpinscher"; },
        "104": function(d) { return "Dvärgpudel"; },
        "105": function(d) { return "Dvärgschnauzer"; },
        "106": function(d) { return "Engelsk bulldogg"; },
        "107": function(d) { return "Engelsk setter"; },
        "108": function(d) { return "Engelsk springer spaniel"; },
        "109": function(d) { return "English toy terrier"; },
        "110": function(d) { return "Entlebucher sennenhund"; },
        "111": function(d) { return "Épagneul de pont-audemer"; },
        "112": function(d) { return "Épagneul français"; },
        "113": function(d) { return "Epagneul picard"; },
        "114": function(d) { return "Épagneul picard"; },
        "115": function(d) { return "Erdélyi kopó"; },
        "116": function(d) { return "Estnisk stövare"; },
        "117": function(d) { return "Eurasier"; },
        "118": function(d) { return "Faraohund"; },
        "119": function(d) { return "Field spaniel"; },
        "120": function(d) { return "Fila brasileiro"; },
        "121": function(d) { return "Finsk lapphund"; },
        "122": function(d) { return "Finsk spets"; },
        "123": function(d) { return "Finsk stövare"; },
        "124": function(d) { return "Flatcoated retriever"; },
        "125": function(d) { return "Foxhound"; },
        "126": function(d) { return "Fransk bulldogg"; },
        "127": function(d) { return "Galgo español"; },
        "128": function(d) { return "Gammel dansk hönsehund"; },
        "129": function(d) { return "Golden retriever"; },
        "130": function(d) { return "Gordonsetter"; },
        "131": function(d) { return "Gos d'atura català"; },
        "132": function(d) { return "Grand basset griffon vendéen"; },
        "133": function(d) { return "Grand bleu de gascogne"; },
        "134": function(d) { return "Grand danois"; },
        "135": function(d) { return "Gränlandshund"; },
        "136": function(d) { return "Greyhound"; },
        "137": function(d) { return "Griffon belge"; },
        "138": function(d) { return "Griffon bruxellois"; },
        "139": function(d) { return "Griffon d'arret à poil dur"; },
        "140": function(d) { return "Griffon fauve de bretagne"; },
        "141": function(d) { return "Grosser münsterländer"; },
        "142": function(d) { return "Grosser schweizer sennenhund"; },
        "143": function(d) { return "Grosspitz"; },
        "144": function(d) { return "Haldenstövare"; },
        "145": function(d) { return "Hälleforshund"; },
        "146": function(d) { return "Hamiltonstövare"; },
        "147": function(d) { return "Hannoveransk viltspårhund"; },
        "148": function(d) { return "Harrier"; },
        "149": function(d) { return "Hellinikos ichnilatis"; },
        "150": function(d) { return "Hokkaido"; },
        "151": function(d) { return "Hollandse herdershond"; },
        "152": function(d) { return "Hollandse herdershond, korthårig"; },
        "153": function(d) { return "Hollandse herdershond, långhårig"; },
        "154": function(d) { return "Hollandse herdershond, strävhårig"; },
        "155": function(d) { return "Hollandse smoushond"; },
        "156": function(d) { return "Hovawart"; },
        "157": function(d) { return "Hrvatski ovcar"; },
        "158": function(d) { return "Hygenstövare"; },
        "159": function(d) { return "Irish glen of imaal terrier"; },
        "160": function(d) { return "Irish softcoated wheaten terrier"; },
        "161": function(d) { return "Irländsk röd och vit setter"; },
        "162": function(d) { return "Irländsk röd setter"; },
        "163": function(d) { return "Irländsk terrier"; },
        "164": function(d) { return "Irländsk varghund"; },
        "165": function(d) { return "Irländsk vattenspaniel"; },
        "166": function(d) { return "Isländsk fårhund"; },
        "167": function(d) { return "Istarski kratkodlaki gonic, strävhårig"; },
        "168": function(d) { return "Istarski ostrodlaki gonic"; },
        "169": function(d) { return "Italiensk vinthund"; },
        "170": function(d) { return "Jack russell terrier"; },
        "171": function(d) { return "Jämthund"; },
        "172": function(d) { return "Japanese chin"; },
        "173": function(d) { return "Japansk spets"; },
        "174": function(d) { return "Juzjnorusskaja ovtjarka"; },
        "175": function(d) { return "Kai"; },
        "176": function(d) { return "Kangal çoban köpe?i"; },
        "177": function(d) { return "Karelsk björnhund"; },
        "178": function(d) { return "Kavkazskaja ovtjarka"; },
        "179": function(d) { return "Keeshond"; },
        "180": function(d) { return "Kerry blue terrier"; },
        "181": function(d) { return "King charles spaniel"; },
        "182": function(d) { return "Kishu"; },
        "183": function(d) { return "Kleiner münsterländer"; },
        "184": function(d) { return "Kleinspitz"; },
        "185": function(d) { return "Komondor"; },
        "186": function(d) { return "Korthårig dvärgtax"; },
        "187": function(d) { return "Korthårig kanintax"; },
        "188": function(d) { return "Korthårig sankt bernhardshund"; },
        "189": function(d) { return "Korthårig tax"; },
        "190": function(d) { return "Korthårig vorsteh"; },
        "191": function(d) { return "Kromfohrländer"; },
        "192": function(d) { return "Kuvasz"; },
        "193": function(d) { return "Labrador retriever"; },
        "194": function(d) { return "Lagotto romagnolo"; },
        "195": function(d) { return "Lakelandterrier"; },
        "196": function(d) { return "Lancashire heeler"; },
        "197": function(d) { return "Landseer"; },
        "198": function(d) { return "Långhårig dvärgtax"; },
        "199": function(d) { return "Långhårig sankt bernhardshund"; },
        "200": function(d) { return "Långhårig tax"; },
        "201": function(d) { return "Långhårig tax"; },
        "202": function(d) { return "Långhårig vorsteh"; },
        "203": function(d) { return "Lapsk vallhund"; },
        "204": function(d) { return "Läwchen"; },
        "205": function(d) { return "Leonberger"; },
        "206": function(d) { return "Lhasa apso"; },
        "207": function(d) { return "Luzernerstövare"; },
        "208": function(d) { return "Magyar agár"; },
        "209": function(d) { return "Malteser"; },
        "210": function(d) { return "Manchesterterrier"; },
        "211": function(d) { return "Maremmano abruzzese"; },
        "212": function(d) { return "Mastiff"; },
        "213": function(d) { return "Mastin español"; },
        "214": function(d) { return "Mastino napoletano"; },
        "215": function(d) { return "Mellanpudel"; },
        "216": function(d) { return "Miniatyrbullterrier"; },
        "217": function(d) { return "Mittelspitz"; },
        "218": function(d) { return "Mops"; },
        "219": function(d) { return "Mudi"; },
        "220": function(d) { return "Nederlandse kooikerhondje"; },
        "221": function(d) { return "Nederlandse schapendoes"; },
        "222": function(d) { return "Newfoundlandshund"; },
        "223": function(d) { return "Norfolkterrier"; },
        "224": function(d) { return "Norrbottenspets"; },
        "225": function(d) { return "Norsk älghund, grå"; },
        "226": function(d) { return "Norsk älghund, svart"; },
        "227": function(d) { return "Norsk buhund"; },
        "228": function(d) { return "Norsk lundehund"; },
        "229": function(d) { return "Norwichterrier"; },
        "230": function(d) { return "Nova scotia duck tolling retriever"; },
        "231": function(d) { return "Ogar polski"; },
        "232": function(d) { return "Old english sheepdog"; },
        "233": function(d) { return "Olde English Bulldogge"; },
        "234": function(d) { return "Österreichischer pinscher"; },
        "235": function(d) { return "Östsibirisk lajka"; },
        "236": function(d) { return "Otterhound"; },
        "237": function(d) { return "Papillon"; },
        "238": function(d) { return "Parson russell terrier"; },
        "239": function(d) { return "Pekingese"; },
        "240": function(d) { return "Perdigueiro português"; },
        "241": function(d) { return "Perdiguero de burgos"; },
        "242": function(d) { return "Perro de agua español"; },
        "243": function(d) { return "Perro dogo mallorquín/ca de bou"; },
        "244": function(d) { return "Perro sin pelo del perú"; },
        "245": function(d) { return "Petit basset griffon vendéen"; },
        "246": function(d) { return "Petit bleu de gascogne"; },
        "247": function(d) { return "Petit brabançon"; },
        "248": function(d) { return "Phalène"; },
        "249": function(d) { return "Pinscher"; },
        "250": function(d) { return "Plott"; },
        "251": function(d) { return "Podenco ibicenco"; },
        "252": function(d) { return "Podengo portugues"; },
        "253": function(d) { return "Podengo portugues, cerdoso/médio"; },
        "254": function(d) { return "Podengo portugues, liso/grande"; },
        "255": function(d) { return "Podengo portugues, liso/médio"; },
        "256": function(d) { return "Podengo portugues, liso/pequeno"; },
        "257": function(d) { return "Pointer"; },
        "258": function(d) { return "Polski owczarek nizinny"; },
        "259": function(d) { return "Polski owczarek podhalanski"; },
        "260": function(d) { return "Pomeranian"; },
        "261": function(d) { return "Porcelaine"; },
        "262": function(d) { return "Portugisisk vattenhund"; },
        "263": function(d) { return "Posavski gonic"; },
        "264": function(d) { return "Prazský krysarík"; },
        "265": function(d) { return "Presa canario"; },
        "266": function(d) { return "Pudel"; },
        "267": function(d) { return "Pudelpointer"; },
        "268": function(d) { return "Puli"; },
        "269": function(d) { return "Pumi"; },
        "270": function(d) { return "Pyrenéerhund"; },
        "271": function(d) { return "Pyreneisk mastiff"; },
        "272": function(d) { return "Ratonero bodeguero andaluz"; },
        "273": function(d) { return "Rhodesian ridgeback"; },
        "274": function(d) { return "Riesenschnauzer"; },
        "275": function(d) { return "Rottweiler"; },
        "276": function(d) { return "Russkaja gontjaja"; },
        "277": function(d) { return "Russkaja tsvetnaja bolonka"; },
        "278": function(d) { return "Russkiy toy"; },
        "279": function(d) { return "Rysk svart terrier"; },
        "280": function(d) { return "Rysk-europeisk lajka"; },
        "281": function(d) { return "Saarloos wolfhond"; },
        "282": function(d) { return "Saluki"; },
        "283": function(d) { return "Samojedhund"; },
        "284": function(d) { return "Sankt bernhardshund"; },
        "285": function(d) { return "Sarplaninac"; },
        "286": function(d) { return "Sauerländer steinbracke"; },
        "287": function(d) { return "Schillerstövare"; },
        "288": function(d) { return "Schipperke"; },
        "289": function(d) { return "Schnauzer"; },
        "290": function(d) { return "Schweizerstövare"; },
        "291": function(d) { return "Sealyhamterrier"; },
        "292": function(d) { return "Segugio italiano, korthårig"; },
        "293": function(d) { return "Shar pei"; },
        "294": function(d) { return "Shetland sheepdog"; },
        "295": function(d) { return "Shiba"; },
        "296": function(d) { return "Shih tzu"; },
        "297": function(d) { return "Shikoku"; },
        "298": function(d) { return "Siberian husky"; },
        "299": function(d) { return "Silky terrier"; },
        "300": function(d) { return "Skotsk hjorthund"; },
        "301": function(d) { return "Skotsk terrier"; },
        "302": function(d) { return "Skyeterrier"; },
        "303": function(d) { return "Släthårig foxterrier"; },
        "304": function(d) { return "Sloughi"; },
        "305": function(d) { return "Slovenský cuvac"; },
        "306": function(d) { return "Smålandsstövare"; },
        "307": function(d) { return "Spinone"; },
        "308": function(d) { return "Sredneasiatskaja ovtjarka"; },
        "309": function(d) { return "Stabijhoun"; },
        "310": function(d) { return "Staffordshire bullterrier"; },
        "311": function(d) { return "Stor pudel"; },
        "312": function(d) { return "Strävhårig dvärgtax"; },
        "313": function(d) { return "Strävhårig foxterrier"; },
        "314": function(d) { return "Strävhårig kanintax"; },
        "315": function(d) { return "Strävhårig tax"; },
        "316": function(d) { return "Strävhårig vorsteh"; },
        "317": function(d) { return "Sussex spaniel"; },
        "318": function(d) { return "Svensk lapphund"; },
        "319": function(d) { return "Svensk vit älghund"; },
        "320": function(d) { return "Tax"; },
        "321": function(d) { return "Terrier brasileiro"; },
        "322": function(d) { return "Thai ridgeback dog"; },
        "323": function(d) { return "Tibetansk mastiff"; },
        "324": function(d) { return "Tibetansk spaniel"; },
        "325": function(d) { return "Tibetansk terrier"; },
        "326": function(d) { return "Tornjak"; },
        "327": function(d) { return "Tosa"; },
        "328": function(d) { return "Toypudel"; },
        "329": function(d) { return "Tysk jaktterrier"; },
        "330": function(d) { return "Tysk schäferhund"; },
        "331": function(d) { return "Tysk schäferhund, långhårig"; },
        "332": function(d) { return "Ungersk vizsla"; },
        "333": function(d) { return "Västgötaspets"; },
        "334": function(d) { return "Västsibirisk lajka"; },
        "335": function(d) { return "Vit herdehund"; },
        "336": function(d) { return "Volpino italiano"; },
        "337": function(d) { return "Wachtelhund"; },
        "338": function(d) { return "Weimaraner"; },
        "339": function(d) { return "Welsh corgi"; },
        "340": function(d) { return "Welsh corgi cardigan"; },
        "341": function(d) { return "Welsh corgi pembroke"; },
        "342": function(d) { return "Welsh springer spaniel"; },
        "343": function(d) { return "Welshterrier"; },
        "344": function(d) { return "West highland white terrier"; },
        "345": function(d) { return "Wetterhoun"; },
        "346": function(d) { return "Whippet"; },
        "347": function(d) { return "Xoloitzcuintle"; },
        "348": function(d) { return "Yorkshireterrier"; },
        "349": function(d) { return "Rasen okänd"; },
        "001": function(d) { return "Affenpinscher"; },
        "002": function(d) { return "Afghanhund"; },
        "003": function(d) { return "Airedaleterrier"; },
        "004": function(d) { return "Akita"; },
        "005": function(d) { return "Alaskan malamute"; },
        "006": function(d) { return "Alpenländische dachsbracke"; },
        "007": function(d) { return "American akita"; },
        "008": function(d) { return "American foxhound"; },
        "009": function(d) { return "American hairless terrier"; },
        "010": function(d) { return "American staffordshire terrier"; },
        "011": function(d) { return "American toy fox terrier"; },
        "012": function(d) { return "American water spaniel"; },
        "013": function(d) { return "Amerikansk cocker spaniel"; },
        "014": function(d) { return "Anglo-russkaja gontjaja"; },
        "015": function(d) { return "Appenzeller sennenhund"; },
        "016": function(d) { return "Australian cattledog"; },
        "017": function(d) { return "Australian kelpie"; },
        "018": function(d) { return "Australian shephard"; },
        "019": function(d) { return "Australisk terrier"; },
        "020": function(d) { return "Azawakh"; },
        "021": function(d) { return "Barbet"; },
        "022": function(d) { return "Basenji"; },
        "023": function(d) { return "Basset artésien normand"; },
        "024": function(d) { return "Basset bleu de gascogne"; },
        "025": function(d) { return "Basset fauve de bretagne"; },
        "026": function(d) { return "Basset griffon vendéen"; },
        "027": function(d) { return "Basset hound"; },
        "028": function(d) { return "Bayersk viltspårhund"; },
        "029": function(d) { return "Beagle"; },
        "030": function(d) { return "Beagle-harrier"; },
        "031": function(d) { return "Bearded collie"; },
        "032": function(d) { return "Beauceron"; },
        "033": function(d) { return "Bedlingtonterrier"; },
        "034": function(d) { return "Belgisk vallhund"; },
        "035": function(d) { return "Belgisk vallhund, groenendael"; },
        "036": function(d) { return "Belgisk vallhund, laekenois"; },
        "037": function(d) { return "Belgisk vallhund, malinois"; },
        "038": function(d) { return "Belgisk vallhund, tervueren"; },
        "039": function(d) { return "Bergamasco"; },
        "040": function(d) { return "Berger des pyrénées, à face rase"; },
        "041": function(d) { return "Berger des pyrénées, à poil long"; },
        "042": function(d) { return "Berger picard"; },
        "043": function(d) { return "Berner sennenhund"; },
        "044": function(d) { return "Bichon frisé"; },
        "045": function(d) { return "Bichon havanais"; },
        "046": function(d) { return "Black and tan coonhound"; },
        "047": function(d) { return "Blodhund"; },
        "048": function(d) { return "Bolognese"; },
        "049": function(d) { return "Border collie"; },
        "050": function(d) { return "Borderterrier"; },
        "051": function(d) { return "Borzoi"; },
        "052": function(d) { return "Bostonterrier"; },
        "053": function(d) { return "Bouvier des flandres"; },
        "054": function(d) { return "Boxer"; },
        "055": function(d) { return "Bracco italiano"; },
        "056": function(d) { return "Braque d'auvergne"; },
        "057": function(d) { return "Braque du bourbonnais"; },
        "058": function(d) { return "Braque français, type pyrénées"; },
        "059": function(d) { return "Breton"; },
        "060": function(d) { return "Briard"; },
        "061": function(d) { return "Broholmer"; },
        "062": function(d) { return "Bullmastiff"; },
        "063": function(d) { return "Bullterrier"; },
        "064": function(d) { return "Cairnterrier"; },
        "065": function(d) { return "Canaan dog"; },
        "066": function(d) { return "Cane corso"; },
        "067": function(d) { return "Cão da serra da estrela"; },
        "068": function(d) { return "Cão da serra de aires"; },
        "069": function(d) { return "Cão fila de são miguel"; },
        "070": function(d) { return "Cavalier king charles spaniel"; },
        "071": function(d) { return "Ceskoslovenský vlciak"; },
        "072": function(d) { return "Ceský fousek"; },
        "073": function(d) { return "Ceskyterrier"; },
        "074": function(d) { return "Chart polski"; },
        "075": function(d) { return "Chesapeake bay retriever"; },
        "076": function(d) { return "Chihuahua"; },
        "077": function(d) { return "Chihuahua, korthårig"; },
        "078": function(d) { return "Chihuahua, långhårig"; },
        "079": function(d) { return "Chinese crested dog"; },
        "080": function(d) { return "Chinese crested dog/powder puff"; },
        "081": function(d) { return "Chodský pes"; },
        "082": function(d) { return "Chow chow"; },
        "083": function(d) { return "Chow chow, korthårig"; },
        "084": function(d) { return "Cimarrón uruguayo"; },
        "085": function(d) { return "Ciobanesc romanesc mioritic"; },
        "086": function(d) { return "Cirneco dell'etna"; },
        "087": function(d) { return "Clumber spaniel"; },
        "088": function(d) { return "Cocker spaniel"; },
        "089": function(d) { return "Collie"; },
        "090": function(d) { return "Collie, korthårig"; },
        "091": function(d) { return "Collie, långhårig"; },
        "092": function(d) { return "Coton de tuléar"; },
        "093": function(d) { return "Curly coated retriever"; },
        "094": function(d) { return "Dalmatiner"; },
        "095": function(d) { return "Dandie dinmont terrier"; },
        "096": function(d) { return "Dansk-svensk gårdshund"; },
        "097": function(d) { return "Deutsche bracke"; },
        "098": function(d) { return "Dobermann"; },
        "099": function(d) { return "Dogo argentino"; }
      },
      enginebrand: {
        "001": function(d) { return "Alamarin-Jet"; },
        "002": function(d) { return "Alona"; },
        "003": function(d) { return "Archimedes"; },
        "004": function(d) { return "Arona"; },
        "005": function(d) { return "Bedford"; },
        "006": function(d) { return "Betamarine"; },
        "007": function(d) { return "Bmw"; },
        "008": function(d) { return "Bombardier-Rotax"; },
        "009": function(d) { return "Bukh"; },
        "010": function(d) { return "Castoldi Jet"; },
        "011": function(d) { return "Caterpillar"; },
        "012": function(d) { return "Chevrolet"; },
        "013": function(d) { return "Chrysler"; },
        "014": function(d) { return "Crusader"; },
        "015": function(d) { return "Cummins"; },
        "016": function(d) { return "Cummins Industrial"; },
        "017": function(d) { return "Detroit Diesel"; },
        "018": function(d) { return "Deutz"; },
        "019": function(d) { return "Deutz Marine"; },
        "020": function(d) { return "Ekström"; },
        "021": function(d) { return "Evinrude"; },
        "022": function(d) { return "Ford"; },
        "023": function(d) { return "Ford Power"; },
        "024": function(d) { return "Hamilton Jet"; },
        "025": function(d) { return "Hanomag"; },
        "026": function(d) { return "Honda"; },
        "027": function(d) { return "Industrial-Ford"; },
        "028": function(d) { return "Iveco"; },
        "029": function(d) { return "Iveco Aifo"; },
        "030": function(d) { return "Johnson"; },
        "031": function(d) { return "Kawasaki"; },
        "032": function(d) { return "Kubota Beta Marine"; },
        "033": function(d) { return "Kubota Nanni"; },
        "034": function(d) { return "Kubota Nanni Marine"; },
        "035": function(d) { return "Leyland"; },
        "036": function(d) { return "Lister"; },
        "037": function(d) { return "Lombardini"; },
        "038": function(d) { return "MAN"; },
        "039": function(d) { return "Mariner"; },
        "040": function(d) { return "Mariner Power"; },
        "041": function(d) { return "Mercedez-Benz"; },
        "042": function(d) { return "MerCruiser"; },
        "043": function(d) { return "Mercury"; },
        "044": function(d) { return "Mitsubishi"; },
        "045": function(d) { return "Monark"; },
        "046": function(d) { return "Motor"; },
        "047": function(d) { return "MTU"; },
        "048": function(d) { return "Najad 340"; },
        "049": function(d) { return "Nissan"; },
        "050": function(d) { return "Olympia"; },
        "051": function(d) { return "OMC"; },
        "052": function(d) { return "OMC Cobra Diesel"; },
        "053": function(d) { return "OMC-Cobra"; },
        "054": function(d) { return "OMC-King Cobra"; },
        "055": function(d) { return "Peninsular"; },
        "056": function(d) { return "Perkins"; },
        "057": function(d) { return "Rotax"; },
        "058": function(d) { return "Ruggesriine"; },
        "059": function(d) { return "Sabre Lehman"; },
        "060": function(d) { return "Scania"; },
        "061": function(d) { return "Seagull"; },
        "062": function(d) { return "Seatoy-Toyota"; },
        "063": function(d) { return "Selva"; },
        "064": function(d) { return "Sole Diesel"; },
        "065": function(d) { return "Status"; },
        "066": function(d) { return "Suzuki"; },
        "067": function(d) { return "Tamdee"; },
        "068": function(d) { return "Tohatsu"; },
        "069": function(d) { return "Toyota"; },
        "070": function(d) { return "Valmet"; },
        "071": function(d) { return "Vetus"; },
        "072": function(d) { return "Vetus Deutz"; },
        "073": function(d) { return "Vire"; },
        "074": function(d) { return "Volvo Penta"; },
        "075": function(d) { return "Westerbeke"; },
        "076": function(d) { return "Wickström"; },
        "077": function(d) { return "Yamaha"; },
        "078": function(d) { return "Yanmar"; }
      },
      forestGrowthStage: {
        "001": function(d) { return "Avverkningsmogen skog"; },
        "002": function(d) { return "En skog som håller på att växa"; },
        "003": function(d) { return "Skog där plantbestånd dominerar"; }
      },
      forestIndemnity: {
        "001": function(d) { return "Storm-, snö- och brandskador och skador till följd av blixtnedslag samt övriga skador"; },
        "002": function(d) { return "Storm-, snö- och brandskador och skador till följd av blixtnedslag"; },
        "003": function(d) { return "Storm- och brandskador och skador till följd av blixtnedslag"; },
        "004": function(d) { return "Storm- och snöskador"; },
        "005": function(d) { return "Stormskador"; }
      },
      municipality: {
        "100": function(d) { return "Kimitoön"; },
        "101": function(d) { return "Kinnula"; },
        "102": function(d) { return "Kittilä"; },
        "103": function(d) { return "Kiuruvesi"; },
        "104": function(d) { return "Kivijärvi"; },
        "105": function(d) { return "Kökar"; },
        "106": function(d) { return "Kolari"; },
        "107": function(d) { return "Konnevesi"; },
        "108": function(d) { return "Kontiolax"; },
        "109": function(d) { return "Korsholm"; },
        "110": function(d) { return "Korsnäs"; },
        "111": function(d) { return "Koskis"; },
        "112": function(d) { return "Kotka"; },
        "113": function(d) { return "Kouvola"; },
        "114": function(d) { return "Kristinestad"; },
        "115": function(d) { return "Kronoby"; },
        "116": function(d) { return "Kuhmo"; },
        "117": function(d) { return "Kuhmois"; },
        "118": function(d) { return "Kumlinge"; },
        "119": function(d) { return "Kumo"; },
        "120": function(d) { return "Kuopio"; },
        "121": function(d) { return "Kuortane"; },
        "122": function(d) { return "Kurikka"; },
        "123": function(d) { return "Kuusamo"; },
        "124": function(d) { return "Kyrkslätt"; },
        "125": function(d) { return "Kyyjärvi"; },
        "126": function(d) { return "Lahtis"; },
        "127": function(d) { return "Laihela"; },
        "128": function(d) { return "Lapinlahti"; },
        "129": function(d) { return "Lappajärvi"; },
        "130": function(d) { return "Lappträsk"; },
        "131": function(d) { return "Larsmo"; },
        "132": function(d) { return "Laukaa"; },
        "133": function(d) { return "Lemi"; },
        "134": function(d) { return "Lemland"; },
        "135": function(d) { return "Lempäälä"; },
        "136": function(d) { return "Leppävirta"; },
        "137": function(d) { return "Lestijärvi"; },
        "138": function(d) { return "Letala"; },
        "139": function(d) { return "Libelits"; },
        "140": function(d) { return "Lieksa"; },
        "141": function(d) { return "Limingo"; },
        "142": function(d) { return "Loimaa"; },
        "143": function(d) { return "Lojo"; },
        "144": function(d) { return "Loppi"; },
        "145": function(d) { return "Lovisa"; },
        "146": function(d) { return "Luhanka"; },
        "147": function(d) { return "Lumijoki"; },
        "148": function(d) { return "Lumparland"; },
        "149": function(d) { return "Lundo"; },
        "150": function(d) { return "Luumäki"; },
        "151": function(d) { return "Malax"; },
        "152": function(d) { return "Mäntsälä"; },
        "153": function(d) { return "Mänttä-Vilppula"; },
        "154": function(d) { return "Mäntyharju"; },
        "155": function(d) { return "Mariehamn"; },
        "156": function(d) { return "Masku"; },
        "157": function(d) { return "Merijärvi"; },
        "158": function(d) { return "Miehikkälä"; },
        "159": function(d) { return "Mörskom"; },
        "160": function(d) { return "Muhos"; },
        "161": function(d) { return "Multia"; },
        "162": function(d) { return "Muonio"; },
        "163": function(d) { return "Muurame"; },
        "164": function(d) { return "Mynämäki"; },
        "165": function(d) { return "Nådendal"; },
        "166": function(d) { return "Nakkila"; },
        "167": function(d) { return "Närpes"; },
        "168": function(d) { return "Nivala"; },
        "169": function(d) { return "Nokia"; },
        "170": function(d) { return "Nousis"; },
        "171": function(d) { return "Nurmes"; },
        "172": function(d) { return "Nurmijärvi"; },
        "173": function(d) { return "Nykarleby"; },
        "174": function(d) { return "Nyslott"; },
        "175": function(d) { return "Nystad"; },
        "176": function(d) { return "Orimattila"; },
        "177": function(d) { return "Oripää"; },
        "178": function(d) { return "Orivesi"; },
        "179": function(d) { return "Östermark"; },
        "180": function(d) { return "Oulainen"; },
        "181": function(d) { return "Outokumpu"; },
        "182": function(d) { return "Övertorneå"; },
        "183": function(d) { return "Padasjoki"; },
        "184": function(d) { return "Pälkäne"; },
        "185": function(d) { return "Paltamo"; },
        "186": function(d) { return "Påmark"; },
        "187": function(d) { return "Pargas"; },
        "188": function(d) { return "Parikkala"; },
        "189": function(d) { return "Parkano"; },
        "190": function(d) { return "Pedersöre"; },
        "191": function(d) { return "Pelkosenniemi"; },
        "192": function(d) { return "Pello"; },
        "193": function(d) { return "Pemar"; },
        "194": function(d) { return "Perho"; },
        "195": function(d) { return "Pertunmaa"; },
        "196": function(d) { return "Petäjävesi"; },
        "197": function(d) { return "Pieksämäki"; },
        "198": function(d) { return "Pielavesi"; },
        "199": function(d) { return "Pihtipudas"; },
        "200": function(d) { return "Polvijärvi"; },
        "201": function(d) { return "Posio"; },
        "202": function(d) { return "Pöytyä"; },
        "203": function(d) { return "Pudasjärvi"; },
        "204": function(d) { return "Pukkila"; },
        "205": function(d) { return "Punkaharju"; },
        "206": function(d) { return "Punkalaidun"; },
        "207": function(d) { return "Puolanka"; },
        "208": function(d) { return "Puumala"; },
        "209": function(d) { return "Pyhäjärvi"; },
        "210": function(d) { return "Pyhäjoki"; },
        "211": function(d) { return "Pyhäntä"; },
        "212": function(d) { return "Pyhäranta"; },
        "213": function(d) { return "Pyhäsalmi"; },
        "214": function(d) { return "Pyttis"; },
        "215": function(d) { return "Rääkkylä"; },
        "216": function(d) { return "Rantasalmi"; },
        "217": function(d) { return "Ranua"; },
        "218": function(d) { return "Raseborg"; },
        "219": function(d) { return "Raumo"; },
        "220": function(d) { return "Rautalampi"; },
        "221": function(d) { return "Rautavaara"; },
        "222": function(d) { return "Rautjärvi"; },
        "223": function(d) { return "Reisjärvi"; },
        "224": function(d) { return "Reso"; },
        "225": function(d) { return "Riihimäki"; },
        "226": function(d) { return "Ristijärvi"; },
        "227": function(d) { return "Rovaniemi"; },
        "228": function(d) { return "Ruokolax"; },
        "229": function(d) { return "Ruovesi"; },
        "230": function(d) { return "Rusko"; },
        "231": function(d) { return "Saarijärvi"; },
        "232": function(d) { return "Sagu"; },
        "233": function(d) { return "Säkylä"; },
        "234": function(d) { return "Salla"; },
        "235": function(d) { return "Salo"; },
        "236": function(d) { return "Saltvik"; },
        "237": function(d) { return "Sastamala"; },
        "238": function(d) { return "Sastmola"; },
        "239": function(d) { return "Savitaipale"; },
        "240": function(d) { return "Savukoski"; },
        "241": function(d) { return "Seinäjoki"; },
        "242": function(d) { return "Sibbo"; },
        "243": function(d) { return "Sievi"; },
        "244": function(d) { return "Siikais"; },
        "245": function(d) { return "Siikajoki"; },
        "246": function(d) { return "Siikalatva"; },
        "247": function(d) { return "Siilinjärvi"; },
        "248": function(d) { return "Simo"; },
        "249": function(d) { return "Sjundeå"; },
        "250": function(d) { return "Sodankylä"; },
        "251": function(d) { return "Soini"; },
        "252": function(d) { return "Somero"; },
        "253": function(d) { return "Sonkajärvi"; },
        "254": function(d) { return "Sotkamo"; },
        "255": function(d) { return "Sottunga"; },
        "256": function(d) { return "St Karins"; },
        "257": function(d) { return "St Mårtens"; },
        "258": function(d) { return "St Mårtens"; },
        "259": function(d) { return "St Michel"; },
        "260": function(d) { return "Storå"; },
        "261": function(d) { return "Storkyro"; },
        "262": function(d) { return "Sulkava"; },
        "263": function(d) { return "Sund"; },
        "264": function(d) { return "Suomussalmi"; },
        "265": function(d) { return "Suonenjoki"; },
        "266": function(d) { return "Sysmä"; },
        "267": function(d) { return "Taipalsaari"; },
        "268": function(d) { return "Taivalkoski"; },
        "269": function(d) { return "Tammela"; },
        "270": function(d) { return "Tammerfors"; },
        "271": function(d) { return "Tavastehus"; },
        "272": function(d) { return "Tavastkyro"; },
        "273": function(d) { return "Tervo"; },
        "274": function(d) { return "Tervola"; },
        "275": function(d) { return "Tohmajärvi"; },
        "276": function(d) { return "Toholampi"; },
        "277": function(d) { return "Toivakka"; },
        "278": function(d) { return "Torneå"; },
        "279": function(d) { return "Tövsala"; },
        "280": function(d) { return "Träskända"; },
        "281": function(d) { return "Tusby"; },
        "282": function(d) { return "Tuusniemi"; },
        "283": function(d) { return "Tyrnävä"; },
        "284": function(d) { return "Uleåborg"; },
        "285": function(d) { return "Ulvsby"; },
        "286": function(d) { return "Urjala"; },
        "287": function(d) { return "Utajärvi"; },
        "288": function(d) { return "Utsjoki"; },
        "289": function(d) { return "Uurainen"; },
        "290": function(d) { return "Vaala"; },
        "291": function(d) { return "Valkeakoski"; },
        "292": function(d) { return "Vanda"; },
        "293": function(d) { return "Vårdö"; },
        "294": function(d) { return "Varkaus"; },
        "295": function(d) { return "Vasa"; },
        "296": function(d) { return "Vemo"; },
        "297": function(d) { return "Vesanto"; },
        "298": function(d) { return "Vesilahti"; },
        "299": function(d) { return "Vetil"; },
        "300": function(d) { return "Vichtis"; },
        "301": function(d) { return "Vieremä"; },
        "302": function(d) { return "Viitasaari"; },
        "303": function(d) { return "Villmanstrand"; },
        "304": function(d) { return "Vindala"; },
        "305": function(d) { return "Virdois"; },
        "306": function(d) { return "Virolahti"; },
        "307": function(d) { return "Vörå"; },
        "308": function(d) { return "Ylivieska"; },
        "309": function(d) { return "Ylöjärvi"; },
        "310": function(d) { return "Ypäjä"; },
        "311": function(d) { return "Åbo"; },
        "312": function(d) { return "Äänekoski"; },
        "001": function(d) { return "Akaa"; },
        "002": function(d) { return "Alajärvi"; },
        "003": function(d) { return "Alavieska"; },
        "004": function(d) { return "Alavo"; },
        "005": function(d) { return "Asikkala"; },
        "006": function(d) { return "Askola"; },
        "007": function(d) { return "Aura"; },
        "008": function(d) { return "Birkala"; },
        "009": function(d) { return "Björneborg"; },
        "010": function(d) { return "Borgå"; },
        "011": function(d) { return "Borgnäs"; },
        "012": function(d) { return "Bötom"; },
        "013": function(d) { return "Brahestad"; },
        "014": function(d) { return "Brändö"; },
        "015": function(d) { return "Eckerö"; },
        "016": function(d) { return "Enare"; },
        "017": function(d) { return "Enonkoski"; },
        "018": function(d) { return "Enontekis"; },
        "019": function(d) { return "Esbo"; },
        "020": function(d) { return "Etseri"; },
        "021": function(d) { return "Eura"; },
        "022": function(d) { return "Euraåminne"; },
        "023": function(d) { return "Evijärvi"; },
        "024": function(d) { return "Finström"; },
        "025": function(d) { return "Föglö"; },
        "026": function(d) { return "Forssa"; },
        "027": function(d) { return "Fredrikshamn"; },
        "028": function(d) { return "Geta"; },
        "029": function(d) { return "Grankulla"; },
        "030": function(d) { return "Gustav Adolfs"; },
        "031": function(d) { return "Gustavs"; },
        "032": function(d) { return "Haapajärvi"; },
        "033": function(d) { return "Haapavesi"; },
        "034": function(d) { return "Halsua"; },
        "035": function(d) { return "Hammarland"; },
        "036": function(d) { return "Hangö"; },
        "037": function(d) { return "Hankasalmi"; },
        "038": function(d) { return "Harjavalta"; },
        "039": function(d) { return "Hattula"; },
        "040": function(d) { return "Hausjärvi"; },
        "041": function(d) { return "Heinävesi"; },
        "042": function(d) { return "Heinola"; },
        "043": function(d) { return "Helsingfors"; },
        "044": function(d) { return "Hirvensalmi"; },
        "045": function(d) { return "Högfors"; },
        "046": function(d) { return "Hollola"; },
        "047": function(d) { return "Huittinen"; },
        "048": function(d) { return "Humppila"; },
        "049": function(d) { return "Hyrynsalmi"; },
        "050": function(d) { return "Hyvinge"; },
        "051": function(d) { return "Idensalmi"; },
        "052": function(d) { return "Iitti"; },
        "053": function(d) { return "Ijo"; },
        "054": function(d) { return "Ikalis"; },
        "055": function(d) { return "Ilmola"; },
        "056": function(d) { return "Ilomants"; },
        "057": function(d) { return "Imatra"; },
        "058": function(d) { return "Ingå"; },
        "059": function(d) { return "Jakobstad"; },
        "060": function(d) { return "Jämijärvi"; },
        "061": function(d) { return "Jämsä"; },
        "062": function(d) { return "Janakkala"; },
        "063": function(d) { return "Jockis"; },
        "064": function(d) { return "Joensuu"; },
        "065": function(d) { return "Jomala"; },
        "066": function(d) { return "Jorois"; },
        "067": function(d) { return "Joutsa"; },
        "068": function(d) { return "Juga"; },
        "069": function(d) { return "Juupajoki"; },
        "070": function(d) { return "Juva"; },
        "071": function(d) { return "Jyväskylä"; },
        "072": function(d) { return "Kaavi"; },
        "073": function(d) { return "Kajana"; },
        "074": function(d) { return "Kalajoki"; },
        "075": function(d) { return "Kangasala"; },
        "076": function(d) { return "Kangasniemi"; },
        "077": function(d) { return "Kankaanpää"; },
        "078": function(d) { return "Kannonkoski"; },
        "079": function(d) { return "Kannus"; },
        "080": function(d) { return "Kärkölä"; },
        "081": function(d) { return "Karleby"; },
        "082": function(d) { return "Karlö"; },
        "083": function(d) { return "Kärsämäki"; },
        "084": function(d) { return "Karstula"; },
        "085": function(d) { return "Karvia"; },
        "086": function(d) { return "Kaskö"; },
        "087": function(d) { return "Kauhajoki"; },
        "088": function(d) { return "Kauhava"; },
        "089": function(d) { return "Kaustby"; },
        "090": function(d) { return "Keitele"; },
        "091": function(d) { return "Kemi"; },
        "092": function(d) { return "Kemijärvi"; },
        "093": function(d) { return "Keminmaa"; },
        "094": function(d) { return "Kempele"; },
        "095": function(d) { return "Kerimäki"; },
        "096": function(d) { return "Kervo"; },
        "097": function(d) { return "Keuru"; },
        "098": function(d) { return "Kides"; },
        "099": function(d) { return "Kihniö"; }
      },
      frameMaterial: {
        "001": function(d) { return "Aluminium"; },
        "002": function(d) { return "Kolfiber"; },
        "003": function(d) { return "Gummi"; },
        "004": function(d) { return "Glasfiber"; },
        "005": function(d) { return "Armerad plast"; },
        "006": function(d) { return "Trä"; },
        "007": function(d) { return "Stål"; },
        "008": function(d) { return "Glasfiberförstärkt trä"; }
      },
      "gender-horse": {
        "001": function(d) { return "Hingst"; },
        "002": function(d) { return "Valack"; },
        "003": function(d) { return "Sto"; }
      },
      homeType: {
        "001": function(d) { return "Egnahemshus"; },
        "002": function(d) { return "Våningshusbostad"; },
        "003": function(d) { return "Radhusbostad"; },
        "004": function(d) { return "Fristående hus"; },
        "005": function(d) { return "Parhus"; },
        "006": function(d) { return "Ekonomibyggnad"; },
        "007": function(d) { return "Bastubyggnad"; },
        "008": function(d) { return "Fritidsbostad"; }
      },
      insuranceIncludesMe: {
        "001": function(d) { return "Endast ditt eget resgods"; },
        "002": function(d) { return "Hela familjens resgods"; }
      },
      insuredItem: {
        "001": function(d) { return "Jag"; },
        "002": function(d) { return "Familjemedlem"; },
        "003": function(d) { return "Endast resgods"; }
      },
      longTrip: {
        "001": function(d) { return "0?45 dygn"; },
        "002": function(d) { return "46?90 dygn"; },
        "003": function(d) { return "91?120 dygn"; },
        "004": function(d) { return "121?179 dygn"; },
        "005": function(d) { return "över 179 dygn"; }
      },
      person: {
        "001": function(d) { return "Jag"; },
        "002": function(d) { return "En annan vuxen"; },
        "003": function(d) { return "Barn"; },
        "004": function(d) { return "Ofött barn eller ofödda tvillingar"; }
      },
      valuableType: {
        "001": function(d) { return "Musikinstrument"; },
        "002": function(d) { return "Kamera och utrustning"; },
        "003": function(d) { return "Objektiv"; },
        "004": function(d) { return "Vapen"; },
        "005": function(d) { return "Klocka"; },
        "006": function(d) { return "Smycke"; }
      },
      vehicleType: {
        "001": function(d) { return "Personbil"; },
        "002": function(d) { return "Paketbil"; },
        "003": function(d) { return "Motorcykel"; },
        "004": function(d) { return "Moped eller mopedbil"; },
        "005": function(d) { return "Snöskoter"; },
        "006": function(d) { return "Släpvagn"; },
        "007": function(d) { return "Husvagn"; },
        "008": function(d) { return "Husbil"; },
        "009": function(d) { return "Lastbil"; },
        "010": function(d) { return "Traktor"; },
        "011": function(d) { return "Fyrhjuling"; },
        "012": function(d) { return "Museifordon"; },
        "013": function(d) { return "Elektriskt förflyttningshjälpmedel"; },
        "014": function(d) { return "Annat fordon"; }
      },
      vehicleMileage: {
        "001": function(d) { return "Högst 5 000 km"; },
        "002": function(d) { return "Högst 10 000 km"; },
        "003": function(d) { return "Högst 15 000 km"; },
        "004": function(d) { return "Högst 20 000 km"; },
        "005": function(d) { return "Högst 25 000 km"; },
        "006": function(d) { return "Högst 30 000 km"; },
        "007": function(d) { return "Högst 40 000 km"; },
        "008": function(d) { return "Över 40 000 km"; },
        "009": function(d) { return "Okänt"; }
      },
      "gender-female": function(d) { return "Tik"; },
      "gender-male": function(d) { return "Hane     "; },
      inspectionClass: {
        "001": function(d) { return "Ingen besiktningsklass eller konditionskartläggning"; },
        "002": function(d) { return "Besiktningsklass 1"; },
        "003": function(d) { return "Besiktningsklass 2"; },
        "004": function(d) { return "Besiktningsklass 3"; },
        "005": function(d) { return "Konditionskartläggning"; }
      },
      insuranceCompany: {
        "001": function(d) { return "A-Vakuutus"; },
        "002": function(d) { return "Fennia"; },
        "003": function(d) { return "Folksam Vahinkovakuutus"; },
        "004": function(d) { return "If"; },
        "005": function(d) { return "LokalTapiola"; },
        "006": function(d) { return "OP"; },
        "007": function(d) { return "Pohjantähti"; },
        "008": function(d) { return "POP Vakuutus"; },
        "009": function(d) { return "Sparbankens försäkringar"; },
        "010": function(d) { return "Turva"; },
        "011": function(d) { return "Volvia"; },
        "012": function(d) { return "Ålands Ömsesidiga"; },
        "013": function(d) { return "Annat försäkringsbolag"; }
      },
      insuranceScope: {
        "001": function(d) { return "Olycksfall och sjukdom"; },
        "002": function(d) { return "Heltäckande olycksfall"; },
        "003": function(d) { return "Olycksfall"; }
      },
      "insured-animal": {
        "001": function(d) { return "Rashund"; },
        "002": function(d) { return "Blandrashund"; },
        "003": function(d) { return "Raskatt"; },
        "004": function(d) { return "Bondkatt"; },
        "005": function(d) { return "Häst"; }
      },
      primaryEngines: {
        "001": function(d) { return "1"; },
        "002": function(d) { return "2"; },
        "003": function(d) { return "3"; }
      },
      purposeOfUse: {
        "001": function(d) { return "Jag bor i den bostad som jag äger."; },
        "002": function(d) { return "Jag använder bostaden på fritiden"; },
        "003": function(d) { return "Jag är hyresvärd"; },
        "004": function(d) { return "Jag är hyresgäst"; }
      },
      transferrableBonus: {
        "001": function(d) { return "0%"; },
        "002": function(d) { return "10%"; },
        "003": function(d) { return "20%"; },
        "004": function(d) { return "30%"; },
        "005": function(d) { return "40%"; },
        "006": function(d) { return "50%"; },
        "007": function(d) { return "60%"; },
        "008": function(d) { return "70 % eller högre"; }
      },
      heatingSystem: {
        "001": function(d) { return "Vattenburet värmesystem"; },
        "002": function(d) { return "Annat än vattenburet värmesystem"; },
        "003": function(d) { return "Okänt"; }
      },
      electricity: {
        "001": function(d) { return "Ansluten till elnätet"; },
        "002": function(d) { return "Egen elproduktion"; },
        "003": function(d) { return "Ingen elektricitet"; }
      }
    },
    validInput: {
      modified: function(d) { return "Redigerat"; },
      modifiedAria: function(d) { return "Du har redigerat inmatningsfältet"; },
      notValid: function(d) { return "Kontrollera fältet"; }
    },
    url: {
      direct: function(d) { return "direkt"; },
      preSelect: function(d) { return "förval"; },
      baseName: function(d) { return "/privatkunder/forsakringar/offertbegaran"; },
      thankyoupage: function(d) { return "/tack"; }
    }
  }
}